window.slate = window.slate || {};
window.theme = window.theme || {};

//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
	screenMD = 768,
	screenLG = 992,
    screenXL = 1200,
    menuBreakPoint = 7680;
    
var slickPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-left' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'></path></svg></button>",
    slickNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-right' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path></svg></button>";

//if no image available, load the SVG placeholder image. Generate by the liquid tag {{ 'product-1' | placeholder_svg_tag: 'svg-placeholder' }}
var svgPlaceholder = '<svg class="svg-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
//BG: The below function is used by both the Recently Viewed and Related Products. When looping through the products, we use the below as a template.
function outputProduct(data, outputLocation) {
    // HM: If null compare_at_price will be an empty string that wont show in HTML
    var comparison_price = data.compare_at_price ? '<span class="carousel-cell-compare-price">'+slate.Currency.formatMoney(data.compare_at_price, theme.moneyFormat)+'</span>' : "";

    const enableVatMessaging = window.theme.settings.enableVatMessaging;
    const vatMessage = window.theme.settings.vatMessage;
    const isGermanStore = window.theme.shop.permanentDomain === "cosatto-germany.myshopify.com";

    const hasPrice = (data.price !== undefined && data.price !== null);

    let vatMessageHtml = '';
    if (isGermanStore && enableVatMessaging && hasPrice) {
        vatMessageHtml = `<span class="carousel-cell-vat-messaging">${vatMessage}</span>`;
    }

    var productHTML = "";
        productHTML += '<div class="carousel-cell four-wide flex-end">\n';
                    if (data.featured_image != null) {
                        productHTML += '<div class="carousel-cell-image-container"><img class="img-full" loading="lazy" src="'+slate.Image.getSizedImageUrl(data.featured_image,'300x')+'" srcset="'+slate.Image.getSizedImageUrl(data.featured_image,'300x')+' 1x,'+slate.Image.getSizedImageUrl(data.featured_image,'600x')+' 2x" alt="'+data.title+'"></div>';
                    } else {
                        productHTML += svgPlaceholder;
                    }
                    productHTML += '<h5>'+data.title+'</h5>';
                    productHTML += '<p>\n';
                    productHTML += '<span class="carousel-cell-price">'+slate.Currency.formatMoney(data.price, theme.moneyFormat)+'</span>';
                    productHTML += comparison_price;
                    productHTML += vatMessageHtml; 
                    productHTML += '</p>\n'; 
                productHTML += '<div class="wishlist-button-container">';
                    productHTML += '<a href="'+data.url+'" class="btn btn-primary">Shop Now</a>';
                    productHTML += '<span class="product-wishlist"><span class="smartwishlist" data-product="'+data.id+'" data-variant="'+data['variants'][0].id+'">' + theme.strings.wishlistButton + '</span></span>';
                productHTML += '</div>';

    $(outputLocation).find('.main-carousel').append(productHTML);
}

/*
BG: persistentCheck: The idea being to constantly check (or persistently check) if the target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking. 
*/
function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
    //console.log('persistentCheckFunction');
    var checkExist = setInterval(function() {
        //console.log('Persistently checking for: '+target);
    //keep checking to see if condition is true 

    if ($(target).length > targetValue) {
            //console.log('condition is true, will no longer check.');
            //check paramFunction is actually a function
            if (typeof paramFunction == "function") {
                paramFunction(paramTarget); 
            }
            //clear interval
            clearInterval(checkExist);
        }
    }, 100); // check every 100ms
    
    setTimeout(function(){
        //console.log('couldn\'t find target or condition wasn\'t true');
        clearInterval(checkExist);
    }, timeoutTime);
}

//HM: Broken down into global function as other scroll/layout elements rely on these dynamic elements.

function getHeightOfHeaderElements(whichElements) {
    var headerHeight = document.querySelector('#site-header').getBoundingClientRect().height,
        headerTextFeaturesHeight = document.querySelector('.header-text-features').getBoundingClientRect().height;
    switch (whichElements) {
        case 'header':
            return headerHeight;
        case 'header-text-features':
            return headerHeight + headerTextFeaturesHeight;
    }
}

/*
BG: A mobile first approach that moves HTML from one place to another. The reason being the mobile and desktops can be fairly different in certain areas and rather than using liquid to render the change twice, we can use this function to move it. 
The mobile first approach means it should be in the correct position but for desktop, we make the switch as it should have better resources available.

example usage:
moveMarkup('.store-select','#store-select-mobile','#store-select-desktop',screenLG);

elementToMove - String
startPoint  - String
endPoint - String
screenSize - Int

 */
function accordionToggle() {
    $('.accordion-title').off('click').on('click', function () {
        const item = $(this).parent('.accordion-item');
        if (item.hasClass('active')) {
            item.removeClass('active');
        } else {
            $('.accordion-item.active').removeClass('active');
            item.addClass('active');
        }
    });
}

function moveMarkup(elementToMove,startPoint,endPoint,screenSize) {
    var elementToMove = $(elementToMove);
    if ($(window).width() >= screenSize) {
        elementToMove.detach().appendTo(endPoint);
    } else {
        elementToMove.detach().appendTo(startPoint);
    }
};
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },
  addToCart
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function (evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                //$(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCart, this.$container).addClass('variant-available');
                $(selectors.addToCart, this.$container).removeClass('variant-not-available');
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                //$(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCart, this.$container).addClass('variant-not-available');
                $(selectors.addToCart, this.$container).removeClass('variant-available');
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function (evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function (evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

            this.$featuredImage.attr('src', sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });


//BG: Make the call to the related products API
    function relatedProductsAPI() {
        var targetCarousel = $('.product-carousel .main-carousel'),
            productID = targetCarousel.attr('data-product-id');

        //Make the JSON request to the recommendations API, pass over the current product ID.
        $.getJSON('/recommendations/products.json?product_id=' + productID + '&limit=8', function (data) {
            //for each product in the API Response, pass over to the output function.
            $.each(data.products, function (i, product) {
                //BG: outputProduct function used in settings/common.js. It's basic styling.
                outputProduct(product, '.product-carousel');
                var increment = i + 1;

                //BG: if we've cycled through all products, trigger the slickInit
                if (data.products.length == increment) {
                    var el = targetCarousel[0];
                    if (el.swiper) {
                        el.swiper.destroy(true, true);
                    }
                    var existingWrapper = findDirectChildByClass(el, 'swiper-wrapper');
                    if (existingWrapper) {
                        while (existingWrapper.firstChild) {
                            el.insertBefore(existingWrapper.firstChild, existingWrapper);
                        }
                        el.removeChild(existingWrapper);
                    }
                    var opts = parseJSONAttribute(el, 'data-swiper-options');
                    if (opts) {
                        opts = normalizeSwiperMarkup(el, opts);
                        new Swiper(el, opts);
                    }
                    // HM: Race condition with script loaded from Shopify
                    if (typeof ReloadSmartWishlist !== "undefined") {
                        ReloadSmartWishlist();
                    }
                }
            });
        });
    }

//Get URL Parameter
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

//BG: if variant parameter is available in the URL, change the selection based on this.
    function changeProductByVariantID() {
        var variantID = getUrlParameter('variant');

        if (variantID) {
            $('.swatch [data-variant-id="' + variantID + '"]').find('input[type="radio"]').prop("checked", true);
        }
    }


//BG: Style the output from the Ajax request
    let priceprefix = '';
    let pricesuffix = '';
    let priceSymbol = '';
    function parsePriceString(priceString) {
        // List of common currency symbols (expand as needed)
        const currencySymbols = ['$', '€', '£', '¥', '₹', '₣', '₽', '₺'];
        let amount = priceString.trim(); // Trim whitespace

        // Check for currency symbols at the start or end
        for (const symbol of currencySymbols) {
            if (amount.startsWith(symbol)) {
                priceprefix = symbol;
                priceSymbol = symbol;
            } else if (amount.endsWith(symbol)) {
                pricesuffix = symbol;
                priceSymbol = symbol;
            }
        }
    }
    function formatPriceWithoutSymbols(price) {
        // Remove currency symbols, decimals, and commas
        var strippedPrice = price.replace(/\D/g, ''); // Keep only digits
        return strippedPrice;
    }
    function stripPostNonNumeric(input) {
        // Regular expression to match the first non-numeric character and anything after it
        const regex = /[^0-9].*/;

        // Replace the matched part with an empty string
        return input.replace(regex, '');
    }
      

    //BG: Style the output from the Ajax request
    function outputColourSwatchProducts(container, json, currentProductID) {

        var productColourContainer = $(container);
        var bundleDisplayLayout = productColourContainer.data('bundle-display-layout');
        var isBundleContainer = productColourContainer.hasClass('product-bundleways-container');

        const enableVatMessaging = window.theme.settings.enableVatMessaging;
        const vatMessage = window.theme.settings.vatMessage;
        const isGermanStore = window.theme.shop.permanentDomain === "cosatto-germany.myshopify.com";

        // SH: Check if there are any products
        if (json.products.length > 1) {

            if(isBundleContainer){
                function extractPrice(priceString) {
                    if (!priceString || typeof priceString !== 'string') {
                        return 0; 
                    }
                    
                    let cleanPrice = priceString.replace(/[^0-9.,]/g, '');
                    
                    if (cleanPrice.indexOf(',') > cleanPrice.indexOf('.') || cleanPrice.indexOf('.') === -1) {
                        cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
                    } else {
                        cleanPrice = cleanPrice.replace(/,/g, '');
                    }
                    
                    return parseFloat(cleanPrice) || 0;
                }
                
                // Usage in sorting function
                json.products.sort((a, b) => {
                    const priceA = extractPrice(a.price);
                    const priceB = extractPrice(b.price);
                    return priceB - priceA; // Descending order
                });
            }

            

            var listClass = 'product-colourways main-carousel';
            if (isBundleContainer && bundleDisplayLayout === 'stacked') {
                listClass += ' flex-column';
            }
            var listMarkup = '<div class="' + listClass + '">';
                markUpArray = [],
                listMarkupElement = "";

            //for each product
            for (var key in json.products) {
                var product = json.products[key],
                    productColour = json.products[key]['colourwayName'].toUpperCase(),
                    productGroup = json.products[key]['colourwayBundle'],
                    productURL = json.products[key]['url'],
                    productID = json.products[key]['id'],
                    productImg = json.products[key]['image'],
                    productPrice = json.products[key]['price'],
                    productComparePrice = json.products[key]['comparePrice'],
                    productBundlePrice = json.products[key]['bundlePrice'],
                    bundleDescription = json.products[key]['description'],
                    productBundleSaving = productBundlePrice,
                    activeClass = "",
                    titleElement = "";
                    priceElement = "";
                    comparePriceElement = "";
                    bundleDescriptionElement = "";

                let vatMessageHtml = '';
                const hasPriceContent = (priceElement || comparePriceElement);
                if (isGermanStore && enableVatMessaging) {
                    vatMessageHtml = `<span class="vat-messaging">${vatMessage}</span>`;
                }


                //if bundle, add title
                if (container.includes('bundle')) {
                    if(productBundlePrice) {

                        parsePriceString(productBundlePrice);
                        var productBundlePriceNum = formatPriceWithoutSymbols(productBundlePrice);
                        var productPriceNum = formatPriceWithoutSymbols(productPrice);
                        // When there are price differences with a a decimal value it doesn't round correctly so we find the difference and the round the decimal value then remultiply it by 100 to then be able to format it
                        var roundedDifference = Math.round(((productBundlePriceNum - productPriceNum)/100))*100
                        var totalNumbers = slate.Currency.formatMoney(roundedDifference, theme.moneyFormat);
                        totalNumbers = stripPostNonNumeric(totalNumbers.replace(priceSymbol,''));
                        productBundleSaving = priceprefix + totalNumbers + pricesuffix;
                    }

                    titleElement = '<span class="product-bundle-title">' + productGroup + '</span>';

                    if (productComparePrice) {
                        priceElement = '<span class="product-bundle-price reduced-bundle-price">' + productPrice + '</span>';
                    } else {
                        priceElement = '<span class="product-bundle-price reduced-bundle-price">' + productPrice + '</span>';
                    }
                    
                    if(productBundlePrice){
                        comparePriceElement = '<span class="product-bundle-compare">' + productBundlePrice + '</span>';
                    }
                    bundleDescriptionElement = '<span class="product-bundle-description">' + bundleDescription + '</span>';
                }

                let bundlePriceElement = "";    
                if(productBundlePrice) {
                    bundlePriceElement = `<div class="product-details__bundle-price-saving">${window.theme.strings.bundle_saving}<span class="money">${productBundleSaving}</span></div>`;
                } else {
                    productBundleSaving = productBundlePrice;
                }

                //if current product ID matches the product ID in the loop, set active class and add to start of array.
                if (productID === currentProductID) {
                    activeClass = "current";
                    //Add option product to the list and select markup
                    if (isBundleContainer && bundleDisplayLayout === 'stacked') {
                        listMarkupElement = `
                        <li class="${activeClass} stacked">
                            <a class="bundle-wrapper" href="${productURL}">
                            <div class="bundle-image-wrapper">
                                <img class="bundle-image" src="${productImg}">
                            </div>
                            <div class="bundle-container">
                                <div>
                                ${titleElement}${bundleDescriptionElement}
                                </div>
                                <span class="product-bundle-price-container">
                                ${priceElement}
                                ${comparePriceElement}
                                ${bundlePriceElement}
                                ${vatMessageHtml}
                                </span>
                            </div>
                            </a>
                        </li>
                        `;
                    } else {
                        listMarkupElement = `
                        <li class="${activeClass}">
                          <div class="bundle-wrapper">
                            <a class="bundle-image-wrapper" href="${productURL}">
                              <img class="bundle-image" src="${productImg}">
                            </a>
                            <div class="bundle-container">
                              <a href="${productURL}">
                                ${titleElement}${bundleDescriptionElement}
                              </a>
                              <span class="product-bundle-price-container">
                                ${priceElement}
                                ${comparePriceElement}
                                ${bundlePriceElement}
                              </span>
                            </div>
                          </div>
                        </li>
                      `;
                    }
                    if(isBundleContainer){
                        markUpArray.push(listMarkupElement);
                    } else {
                        markUpArray.unshift(listMarkupElement);
                    }
                } else {
                    if (isBundleContainer && bundleDisplayLayout === 'stacked') {
                        listMarkupElement = '<li class="stacked"><a class="bundle-wrapper" href="' + productURL + '"><div class="bundle-image-wrapper"><img class="bundle-image" src="' + productImg + '"></div><div class="bundle-container"><div>' + titleElement + bundleDescriptionElement + '</div><span class="product-bundle-price-container">' + priceElement + comparePriceElement + bundlePriceElement + vatMessageHtml + '</span></div></a></li>';
                    } else {
                        listMarkupElement = '<li><div class="bundle-wrapper"><a class="bundle-image-wrapper" href="' + productURL + '"><img class="bundle-image" src="' + productImg + '"></a><div class="bundle-container"><a href="' + productURL + '">' + titleElement + bundleDescriptionElement + '</a><span class="product-bundle-price-container">' + priceElement + comparePriceElement + bundlePriceElement + '</span></div></div></li>';
                    }
                    
                    // HM: All other swatches added to end of array for rendering last
                    markUpArray.push(listMarkupElement);
                }
            }
            listMarkup += markUpArray.join('\n');

            //close list markup
            listMarkup += '</div>';

            //output the results.
            productColourContainer.append(listMarkup);

            //SH: if we have result, add class to container.
            productColourContainer.parent('div').addClass('jsloaded');
            productColourContainer.parent('div').parent('div').addClass('bundlesloaded');

            var swiperContainer = container + ' .product-colourways.main-carousel';
            var elem = document.querySelector(swiperContainer);

            var prevNextButtonsVal = true,
                wrapAroundVal = true;

            var initSwiper = !isBundleContainer || (isBundleContainer && bundleDisplayLayout === 'carousel');

            if (initSwiper) {
            if (isBundleContainer) {
                if (json.products.length < 2) {
                    prevNextButtonsVal = false;
                    wrapAroundVal = false;
                } else {
                    var productColourWrappers = document.querySelectorAll('.product-colourways.main-carousel');
                    productColourWrappers.forEach(function(productColourWrapper) {
                        productColourWrapper.classList.add('has-arrows');
                    });
                }
            } else {
                var isMobile = window.innerWidth <= 1024;
                if (json.products.length < 7) {
                    if (isMobile && json.products.length > 3) {
                        prevNextButtonsVal = true;
                        var productColourWrappers = document.querySelectorAll('.product-colourways.main-carousel');
                        productColourWrappers.forEach(function(productColourWrapper) {
                            productColourWrapper.classList.add('has-arrows');
                        });
                    } else {
                        prevNextButtonsVal = false;
                    }
                    wrapAroundVal = false;
                } else {
                    var productColourWrappers = document.querySelectorAll('.product-colourways.main-carousel');
                    productColourWrappers.forEach(function(productColourWrapper) {
                        productColourWrapper.classList.add('has-arrows');
                    });
                }
            }

            var swiperOpts = {
                slidesPerView: 'auto',
                watchOverflow: true,
                loop: wrapAroundVal,
                loopedSlides: 4,
                navigation: prevNextButtonsVal
            };
            swiperOpts = normalizeSwiperMarkup(elem, swiperOpts);
            new Swiper(elem, swiperOpts);
            }

        } else {
            // remove colour div if there is no content
            productColourContainer.parent().parent().remove();
        }
        
    }

    function getMatchingProductsByTag() {
        /* only run if this div exists. This won't appear if:
        A) the snippet 'product-colour-swatch.liquid' file is not included on the product page
        B) the product does not have a tag that contains "group_colours_"
        */
        var colours = '.product-colourways-container';
        if ($(colours).length) {
            var colourName = $(colours).attr('data-colourway-handle'),
                currentProductID = $(colours).attr('data-current-product-id'),
                currentType = $(colours).attr('data-product-type'),
                currentBundle = $(colours).attr('data-bundle-type'),
                currentFamily = $(colours).attr('data-family-handle'),
                currentAge = $(colours).attr('data-sleeping-bag-age'),
                // HM todo: Do similar checks for empty falsy to generate the URL string without needing verbose conditional statements
                ageAsURL = currentAge ? '+' + currentAge : "",
                urlPath = '/collections/all/', liveProductsOnly = 'web-store', urlParameter = '?view=json-colourways',
                fetchURL;

            // HM: If the bundle tag has been passed in and isn't an empty string then add the bundle tag to the filters as we only want colourways from the same bundle type
            if (currentBundle) {
                fetchURL = urlPath + currentFamily + '+' + currentBundle + '+' + liveProductsOnly + '+' + currentType + urlParameter;
            } else {
                fetchURL = urlPath + currentFamily + '+' + liveProductsOnly + '+' + currentType + ageAsURL + urlParameter;
            }

            $.ajax({
                type: 'GET',
                //BG: "?view=colour" is a url parameter that will the template based on the value provided.
                // currentFamily applies a Shopify filter that finds products based on product tag and currentType filters out any bundles or accessories.
                url: fetchURL,
                success: function (data) {
                    if (data) {
                        try {
                            var json = JSON.parse(data);
                        } catch (e) {
                            var json = null; // meh
                        }
                    }
                    if (json) {
                        //if Json is sucessful, pass over to function to output the results.
                        outputColourSwatchProducts(colours, json, currentProductID);
                    }
                },
                error: function(request, status, error) {
                    successmessage = 'Error: Colourways cannot get ' + fetchURL;
                }
            });
        }

        /* SH: TODO:
        only run if this div exists. This won't appear if:
        A) the snippet 'product-colour-swatch.liquid' file is not included on the product page
        B) the product does not have a tag that contains "group_bundles_"
        */

        var bundles = '.product-bundleways-container';
        if ($(bundles).length) {
            var bundleName = $(bundles).attr('data-colourway-handle'),
                currentProductID = $(bundles).attr('data-current-product-id'),
                currentFamily = $(bundles).attr('data-family-handle'),
                bundlesURL = $(bundles).attr('data-bundle-handle'),
                // HM todo: Do similar checks for empty falsy to generate the URL string without needing verbose conditional statements
                
                // SH todo: Support multi-language bundles URL
                urlPath = '/collections/' + bundlesURL + '/', urlParameter = '?view=json-bundles',
                fetchURL;

            fetchURL = urlPath + currentFamily + '+' + bundleName + urlParameter;

            $.ajax({
                type: 'GET',
                //BG: "?view=colour" is a url parameter that will the template based on the value provided.
                // currentFamily applies a Shopify filter that finds products based on product tag and currentType filters out any bundles or accessories.
                url: fetchURL,
                success: function (data) {
                    if (data) {
                        try {
                            var json = JSON.parse(data);
                        } catch (e) {
                            var json = null; // meh
                        }
                    }
                    if (json) {
                        //if Json is sucessful, pass over to function to output the results.
                        outputColourSwatchProducts(bundles, json, currentProductID);
                    }
                },
                error: function(request, status, error) {
                    successmessage = 'Error: Bundleways cannot get ' + fetchURL;
                }
            });
        } 
    }

    function trackMobileScroll() {
        // Reference: http://www.html5rocks.com/en/tutorials/speed/animations/

        var last_known_scroll_position = 0,
            ticking = false,
            fixedMobileCta = document.querySelector('.product-details-mobile'),
            scrollCtaPast = document.getElementById('cart-actions'),
            fixedMobileProposition = document.querySelector('.proposition-banner'),
            scrollPropositionPast = 30;

        function ifPastAddToBag(scroll_pos) {
            if (window.scrollY > (scrollCtaPast.offsetTop + scrollCtaPast.offsetHeight)) {
                if (!fixedMobileCta.classList.contains('active')) {
                    fixedMobileCta.classList.add('active');
                    var mobileBasketheight = fixedMobileCta.outerHeight(true);
                    $('.product-compare-container > div').css('bottom', mobileBasketheight);
                }
            } else {
                //if (fixedMobileCta.classList.contains('active')) {
                    fixedMobileCta.classList.remove('active');
                    $('.product-compare-container > div').css('bottom', '0px');
                //}
            }
        }

        function ifPastProposition(scroll_pos) {
            /*
            if (window.scrollY > scrollPropositionPast) {
                if (!fixedMobileProposition.classList.contains('active')) {
                    fixedMobileProposition.classList.add('active');
                    var mobilePropositionHeight = fixedMobileProposition.outerHeight(true);
                    fixedMobileProposition.css('top', mobilePropositionHeight);
                }
            } else {
                if (fixedMobileProposition.classList.contains('active')) {
                    fixedMobileProposition.classList.remove('active');
                    fixedMobileProposition.css('top', '0px');
                }
            }
            */
        }

        window.addEventListener('scroll', function (e) {

            /*
            last_known_scroll_position = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function () {
                    ifPastAddToBag(last_known_scroll_position);
                    ifPastProposition(last_known_scroll_position);
                    ticking = false;
                });

                ticking = true;
            }
            */

        });

    }

    function getMatchingFamily(parent) {

        var htmlType = $(parent).prop('tagName');
        var familyHolder = $(parent).find('[data-product-family]');

        // HM: Fetch all products within the same family from a collection JSON fetch
        var currentFamily = familyHolder.attr('data-product-family'),
            urlPath = '/collections/all/', urlParameter = '?view=json-reviews',
            ratingRoot = 'root-review',
            ratingMiniRoot = 'root-mini-review',
            //ratingMiniTemplate = 'product-mini-review-template',
            ratingTemplate = 'product-review-template',
            ratingMiniTrustbox = 'product-mini-review-trustbox',
            ratingTrustbox = 'product-review-trustbox',
            ratingMiniMultisource = 'product-mini-review-multisource',
            // HM: Find products in same family with the trustpilot tag, this excludes spares
            fetchURL = urlPath + currentFamily + "+trustpilot" + urlParameter;

        // SH: We need unique review IDs
        if(familyHolder.attr('data-num')){
            var parentID = familyHolder.attr('data-num'),
                ratingRoot = 'root-review' + parentID,
                ratingMiniRoot = 'root-mini-review' + parentID,
                //ratingMiniTemplate = 'root-mini-review-template' + parentID,
                ratingTemplate = 'product-review-template' + parentID,
                ratingMiniTrustbox = 'product-mini-review-trustbox' + parentID,
                ratingTrustbox = 'product-review-trustbox' + parentID,
                ratingMiniMultisource = 'product-mini-review-multisource' + parentID;
        }

        $.ajax({
            type: 'GET',
            url: fetchURL,
            success: function (data) {
                if (data) {
                    try {
                        var json = JSON.parse(data);
                    } catch (e) {
                        var json = null; // meh
                    }
                }
                if (json) {
                    /* HM: The below appends templated HTML and then inits the Trustpilot widget within it. Theoretically
                    * we could just add the returned SKUs as data attributes on the existing HTML element and then reinit TP.
                    * This seems to be bugged however and this method works.
                    * */
                    if (json.products.length > 0 && window.Trustpilot.loadFromElement !== "undefined") {
                        if(document.getElementById(ratingRoot)){
                            var root = document.getElementById(ratingRoot);
                        }
                        if(document.getElementById(ratingMiniRoot)){
                            var miniRoot = document.getElementById(ratingMiniRoot);
                        }
                        if(document.getElementById(ratingTemplate)){
                            var trustboxTemplate = document.getElementById(ratingTemplate);
                        }
                        if(document.getElementById(ratingMiniMultisource)){
                            var miniMultisource = document.getElementById(ratingMiniMultisource);
                        }

                        if(miniMultisource){
                            var miniMultisource = document.getElementById(ratingMiniMultisource);
                            miniMultisource.dataset.sku = skuListAsString;
                        }

                        var skuListAsString = json.products.join(),
                            root = root,
                            miniRoot = miniRoot,
                            trustboxTemplate = trustboxTemplate,
                            miniMultisource = miniMultisource;

                        // Clone the new row and insert it into the table
                        if(trustboxTemplate.content){
                            var trustboxClone = trustboxTemplate.content.cloneNode(true);
                            root.appendChild(trustboxClone);
                            var trustbox = document.getElementById(ratingTrustbox);
                            trustbox.dataset.sku = skuListAsString;
                        }

                        try {
                            window.Trustpilot.loadFromElement(trustbox);
                        } catch (error) {
                            console.warn('Error loading Trustpilot:', error)
                        }
                    }
                }
            },
            error: function(request, status, error) {
                successmessage = 'Error: Trustpilot cannot get ' + fetchURL;
            }
        });

    }

//BG: Only run on Product Page.
    if ($('body.template-product').length > 0) {

        changeProductByVariantID();
        accordionToggle();
        getMatchingProductsByTag();

        var parent = document;

            trackMobileScroll();
            $('.product-add-to-basket').on('click', function (e) {
                var mobileAddToCartBtn = $('#mobile-add-button', this);
                var mobileAddToCartBtnInnerText = $('#mobile-add-button > span', this);
                var variantId = mobileAddToCartBtn.attr('data-variant-id');
                var variantProperties = $("div[data-variant-id='" + variantId +"'] #available-date");
                if (e.target === mobileAddToCartBtn[0] || e.target === mobileAddToCartBtnInnerText[0]) {
                    addToCartWithoutForm(mobileAddToCartBtn, $(this), variantId, variantProperties)
                }
            });


        // HM: Carousel data source can be altered in Customise, so product id might not exist
        if ($('.product-carousel .main-carousel').attr('data-product-id')) {
            $(parent).ready(relatedProductsAPI);
        }





        //SH: Highlight menu according to page scroll position
        // Get all sections that are specifically assigned to PDP menu
        const sections = parent.querySelectorAll("div[data-id]");

        // Add an event listener listening for scroll
        window.addEventListener("scroll", navHighlighter);

        function navHighlighter() {
        
        // Get current scroll position
        let scrollY = window.pageYOffset;
        
        // Now we loop through sections to get height, top and ID values for each
        sections.forEach(current => {
            var sectionHeight = current.offsetHeight;
        
            // Original:
            // const sectionTop = current.offsetTop - 50;
            //  
            // Alex Turnwall's update:
            // Updated original line (above) to use getBoundingClientRect instead of offsetTop, based on:
            // https://plainjs.com/javascript/styles/get-the-position-of-an-element-relative-to-the-document-24/
            // https://newbedev.com/difference-between-getboundingclientrect-top-and-offsettop
            // This allows the use of sections inside a relative parent, which I'm not using here, but needed for a project
            //
            sectionTop = (current.getBoundingClientRect().top + window.pageYOffset) - 200;
            sectionId = current.getAttribute("data-id");

            // Flex layout complicates accuracy, approximate height according to required parts
            if(sectionId == 'product'){
                sectionTop = sectionTop - 50;
                const meta = parent.querySelector(".product-details__meta");
                const carousel = parent.querySelector(".product-carousel");
                const breadcrumb = parent.querySelector(".breadcrumb");
                const options = parent.querySelector(".product-options");
                sectionHeight = meta.offsetHeight + carousel.offsetHeight + breadcrumb.offsetHeight + options.offsetHeight;
            }
        });
        }



    }

    //SH: Test on Collection Page.
    if ($('body.template-collection').length > 0) {

        var parent = $('.native-grid__list').find('li');
        parent.each(function() {
            var product = $(this);
            var attr = product.find('[data-product-family]');
            if (attr) {
                var family = attr.data('product-family');

                    try {
                        getMatchingFamily(product);
                    } catch (error) {
                    }

            }
        });

    }



    return Product;
})();

function handleStickyProposition() {
    if($('.proposition-banner')[0]) {
        const propositionY = $('#site-header').height();

        if (window.scrollY > propositionY) { 
            $('.proposition-banner').slideDown(250);
        } else {
            $('.proposition-banner').slideUp(250);
        }
    }
}

function handleStickyCart() {
    if($('.product-details-mobile')[0]) {

        if($('.stickyCart')[0] && $('.always-sticky')[0] && $(window).width() <= screenMD){
            $('#product-details .product-options #cart-actions').show();
            $('.product-details-mobile').slideDown(250);
        }

        if($('.always-sticky')[0] && $(window).width() <= screenMD){
            $('#product-details .product-options #cart-actions').hide();
            $('body').addClass('stickyCart');
        } else {
            $('#product-details .product-options #cart-actions').show();
            var p = $('.product-options');
            var position = p.offset();
            const addtocartButtonY = position.top - ($('#site-header').height() - $('#cart-actions .btn-add-to-cart').height());

            if (window.scrollY < addtocartButtonY) { 
                $('.product-details-mobile').slideUp(250);
            } else {
                $('.product-details-mobile').slideDown(250);
            }
        }
    }

}

function handlePaymentGrid() {
    var plansGrid = document.querySelectorAll('.payment-plans');
    var iconsGrid = document.querySelectorAll('.payment-icons');
    
    var mobileHolder = document.querySelectorAll('.mobile-section .accordion-container');
    var desktopHolder = document.querySelectorAll('.product-options .payment-icons');
    var desktopIconsHolder = document.querySelectorAll('.product-options .payment-icons');

    /* Check for payment icons (we want these below the payment plans, so insert first) */
    if(document.querySelectorAll('.payment-icons')){
        /* On mobile we want the payment icons above the accordion items */
        /* On desktop we want the payment icons above payment grid */
        if(desktopIconsHolder[0]){
            insertAfter(iconsGrid[0], desktopIconsHolder[0]);
        }
    }

    /* Check for payment plans (we want these above the payment icons, so insert second) */
    if(document.getElementById('shopify-section-payment-plans')){
        /* On mobile we want the payment grid above the accordion items */
        /* On desktop we want the payment grid below the accordion items */
        if(desktopHolder[0]){
            insertAfter(iconsGrid[0], desktopHolder[0]);
        }
    }
}      


function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

//handleStickyProposition();
handleStickyCart();
//$(window).scroll(handleStickyProposition);
handlePaymentGrid();
$(window).scroll(handleStickyCart);

/* ==========================================================================
# PDP - Product Description Expand Buttons
========================================================================== */

// Builds a tag-safe truncated clone of an element, stopping once maxWords is reached,
// so that inline formatting (e.g. bold) is preserved in the preview instead of being stripped.
const truncateHtmlByWords = (rootElement, maxWords) => {
    const state = { count: 0, done: false, lastTextNode: null };

    const truncateNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            const tokens = node.textContent.split(/(\s+)/);
            let result = '';
            for (const token of tokens) {
                if (state.done) break;
                if (token.trim() === '') {
                    result += token;
                    continue;
                }
                if (state.count >= maxWords) {
                    state.done = true;
                    break;
                }
                result += token;
                state.count += 1;
            }
            if (!result) return null;
            const textNode = document.createTextNode(result);
            state.lastTextNode = textNode;
            return textNode;
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
            const clone = node.cloneNode(false);
            for (const child of Array.from(node.childNodes)) {
                if (state.done) break;
                const truncatedChild = truncateNode(child);
                if (truncatedChild) clone.appendChild(truncatedChild);
            }
            // Drop containers left empty by truncation (e.g. a paragraph cut off before its first word)
            if (node.childNodes.length > 0 && clone.childNodes.length === 0) {
                return null;
            }
            return clone;
        }

        return null;
    };

    const node = truncateNode(rootElement);
    return { node, truncated: state.done, lastTextNode: state.lastTextNode };
}

const handleProductDescriptionToggles = () => {
    const descriptionContainers = document.querySelectorAll('[data-description-toggle]');
    if (!descriptionContainers) return;

    const initDescriptionToggle = (element) => {
        const toggleButton = element.querySelector('[data-toggle-button]');
        const full = element.querySelector('[data-description-full]');
        const contentWrapper = element.querySelector('[data-description-content]');

        if (!toggleButton || !full || !contentWrapper) return;

        const maxWords = parseInt(contentWrapper.getAttribute('data-word-threshold'), 10) || 0;
        const { node: preview, truncated, lastTextNode } = truncateHtmlByWords(full, maxWords);

        if (!truncated) return;

        preview.classList.add('description-content__preview');
        preview.setAttribute('data-description-preview', '');

        // Append the ellipsis onto the last word's own parent, so it sits inline instead of on its own line
        const ellipsisTarget = lastTextNode ? lastTextNode.parentNode : preview;
        ellipsisTarget.appendChild(document.createTextNode('...'));

        full.hidden = true;
        full.before(preview);

        const readMoreText = toggleButton.getAttribute('data-read-more');
        const readLessText = toggleButton.getAttribute('data-read-less');

        let isExpanded = false;

        toggleButton.addEventListener('click', function () {
            isExpanded = !isExpanded;

            preview.hidden = isExpanded;
            full.hidden = !isExpanded;

            toggleButton.textContent = isExpanded ? readLessText : readMoreText;
        });
    }

    descriptionContainers.forEach(initDescriptionToggle);
}
handleProductDescriptionToggles();

/* ==========================================================================
# PDP - Sticky Cart Button additional functionality
========================================================================== */

function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        Math.floor(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight) &&
        Math.floor(rect.right) <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function handleStickyCartOutOfView() {
    var stickyCart = $('.partial-sticky-cart');
    
    // MB: Check if the .partial-sticky-cart element exists
    if (stickyCart.length > 0) {
        if (stickyCart.hasClass('sticky-out-of-view')) {
            var addToBasket = $('.product-details .product-add-to-basket')[0];
            if (!isElementInViewport(addToBasket)) {
                stickyCart.css('display', 'block');
            } else {
                stickyCart.css('display', 'none');
            }
        }
    }
}

// MB: Run on page load
handleStickyCartOutOfView();

// MB: Run on scroll
$(window).on('scroll', function() {
    handleStickyCartOutOfView();
});

/* ==========================================================================
# PDP - Video Promo
========================================================================== */

// Function to handle click on video-content
function handleVideoContentClick() {
    // Hide video-content
    var videoContent = document.querySelector('.product-banner-content.video-content');
    if (videoContent) {
      videoContent.style.display = 'none';
    }
  
    // Hide product-banner-overlay
    var overlay = document.querySelector('.product-banner-overlay.video-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  
    // Play the YouTube video
    if (player) {
      player.playVideo();
    }
  }
  
// Function to set the YouTube video embed URL with rel=0
function setYouTubeEmbedURL() {
    var iframe = document.querySelector('.product-content__video iframe');
    if (iframe) {
        iframe.addEventListener('load', function() {
        var src = iframe.src;
        var url = new URL(src);
        if (!url.searchParams.has('rel')) {
            url.searchParams.set('rel', '0');
            iframe.src = url.toString();
        }
        });
    }
}
  

var videoContentElement = document.querySelector('.product-banner-content.video-content');
if (videoContentElement) {
    videoContentElement.addEventListener('click', handleVideoContentClick);
}

// Set the YouTube embed URL with rel=0
setTimeout(setYouTubeEmbedURL, 1000);
  

/* ==========================================================================
# PDP - Key Features
========================================================================== */

// Key features carousel is initialised via data-swiper-options by initSwipers() in theme.js.
// This block only handles adding the no-carousel class when there are too few items to scroll.
(function () {
    var keyFeaturesCarousel = document.querySelector('.key-features-carousel');
    if (!keyFeaturesCarousel) return;
    var keyFeaturesItems = keyFeaturesCarousel.querySelectorAll('.key-feature');
    var shouldInit = window.innerWidth > 768
        ? keyFeaturesItems.length > 4
        : keyFeaturesItems.length > 1;
    if (!shouldInit) {
        keyFeaturesCarousel.classList.add('no-carousel');
    }
}());

/* ==========================================================================
# PDP - Main Image Carousel Thumbnails
========================================================================== */
function initPDPThumbnails(context) {
    const scope = context || document;
    const mainCarouselEl = scope.querySelector('.product-content__carousel.main-carousel');
    const thumbsEl = scope.querySelector('.product-content__carousel--thumbs');

    if (!mainCarouselEl || !thumbsEl || thumbsEl.dataset.pdpThumbsInit) return;
    if (!thumbsEl.querySelector('.pdp-thumb')) return;
    thumbsEl.dataset.pdpThumbsInit = '1';

    // Build the thumbnail strip as its own Swiper. Swiper's Thumbs module then
    // owns everything the old hand-rolled code did (active-thumb highlighting,
    // scrolling the active thumb into view, click-to-navigate) and handles the
    // main carousel's loop internally, so there are no manual clones to wrap.
    const thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 4,
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        scrollbar: {
          el: '.product-thumbs-swiper-scrollbar',
          hide: false,
        }
    });

    // The main carousel is initialised generically from its data-swiper-options
    // (which declares "thumbs": { "swiper": null }). Attach our thumbs instance
    // to it once it exists. init() reads params.thumbs.swiper, so set that, not
    // swiper.thumbs.swiper.
    function attachThumbs() {
        const mainSwiper = mainCarouselEl.swiper;
        if (!mainSwiper || !mainSwiper.thumbs) return false;
        mainSwiper.params.thumbs.swiper = thumbsSwiper;
        mainSwiper.thumbs.init();
        mainSwiper.thumbs.update(true);

        // Swiper's Thumbs module only scrolls the strip when the active thumb is
        // off-screen; it won't reposition one that's already visible (so clicking
        // a thumb that's showing leaves it where it is). Bring the active thumb to
        // the start of the strip on every change so the selection is consistent.
        // Thumbs don't loop, so realIndex maps directly; slideTo clamps at the end.
        const syncThumb = () => thumbsSwiper.slideTo(mainSwiper.realIndex);
        mainSwiper.on('slideChange', syncThumb);
        syncThumb();

        return true;
    }

    if (!attachThumbs()) {
        // Main Swiper not initialised yet; attach when it adds swiper-initialized.
        const observer = new MutationObserver(() => {
            if (attachThumbs()) observer.disconnect();
        });
        observer.observe(mainCarouselEl, { attributes: true, attributeFilter: ['class'] });
    }
}

$(document).ready(function () {
    initPDPThumbnails();
});

document.addEventListener('shopify:section:load', function (e) {
    initPDPThumbnails(e.target);
});
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
	  
	if ($(this).hasClass('address-new-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-new-secondary')) {
		$('.address-new-primary').removeClass('hide');
	}
	  
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
	  
	if ($(this).hasClass('address-edit-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-edit-secondary')) {
		$('.address-edit-primary').removeClass('hide');
	}
  });

  // $('.address-delete').on('click', function() {
  //   var $el = $(this);
  //   var formId = $el.data('form-id');
  //   var confirmMessage = $el.data('confirm-message');
  //   if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
  //     Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  //   }
  // });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

moveMarkup('.template-cart .accordion-container','#accordion-cart-mobile','#accordion-cart-desktop',screenLG);
moveMarkup('.donation','#charity-cta-mobile','#charity-cta-desktop',screenLG);

function spanishAnchor() {
    $('#formNID #cartLabel').on('click', function(){

        if ($(window).width() > screenLG) {
            $('html, body').animate( 
                { scrollTop: $('#accordion-cart-desktop').offset().top - $('#site-header').height()
            }, {duration: 400 });
        } else {
            $('html, body').animate( 
                { scrollTop: $('#accordion-cart-mobile').offset().top - $('#site-header').height()
            }, {duration: 400 });
        }
    });
}

if ($('body.template-cart').length) {
    accordionToggle();
    spanishAnchor();
}

$(window).on('resize',function() {
    moveMarkup('.template-cart .accordion-container','#accordion-cart-mobile','#accordion-cart-desktop',screenLG);
    moveMarkup('.donation','#charity-cta-mobile','#charity-cta-desktop',screenLG);
});
function forgotPassword() {

	var loginForm = $('#CustomerLoginForm'),
		passwordForm = $('#RecoverPasswordForm');

	$('.show-forgot-password').click(function(){
		loginForm.addClass('hide');
		passwordForm.removeClass('hide');
	});

	$('.hide-forgot-password').click(function(){
		loginForm.removeClass('hide');
		passwordForm.addClass('hide');
	});
}

function resetPasswordForm() {
	var formState = $('.reset-password-success')

	if (formState.length) {
		$('#ResetSuccess').removeClass('hide');
	}
}


//BG: Tokyo Laundry want to capture Birthdays.
function birthdayFormat(form) {
    var birthdayField = form.find('#Birthday'),
        birthdayFieldValue = 'Day/Month/Year',
        birthdayDay = form.find('#birthday-day'),
        birthdayDayValue = '',
        birthdayMonth = form.find('#birthday-month'),
        birthdayMonthValue = '',
        birthdayYear = form.find('#birthday-year'),
        birthdayYearValue = '';
    
    function combinedValue() {
        birthdayFieldValue = birthdayDayValue +' '+birthdayMonthValue +' '+ birthdayYearValue;
        birthdayField.val(birthdayFieldValue);
    }    

    birthdayDay.on('change', function(){
        birthdayDayValue = $(this).val();
        combinedValue();
    });

    birthdayMonth.on('change', function(){
        birthdayMonthValue = $(this).val();
        combinedValue();
    });

    birthdayYear.on('change', function(){
        birthdayYearValue = $(this).val();
        combinedValue();
    });
}

//BG: Check to see if the form is valid.
function checkFormValidation(form) {
    var invalidFields = form.find('label.required'),
        invalidFieldsCount = 0,
        validFieldsCount = 0;

    invalidFields.each(function(){
        if ($(this).hasClass('validated')) {
            validFieldsCount++;
        } else {
            invalidFieldsCount++;
        }
    });
    if (invalidFieldsCount === 0) {
        form.removeClass('validation-invalid');
    }

    console.log('invalid count:'+invalidFieldsCount);
    console.log('valid count:' +validFieldsCount);
}

//BG: build error message, what the message contains and where it should output.
function feedbackMessage(field, status, message,form) {
    var messageNoWhitespace = field.replace(/\s/g, ""),
        html = "<div class='ajaxfeedback "+status+" "+messageNoWhitespace+"'>"+message+"</div>";

    //if error messages are already showing, don't show again.
    if ($('.ajaxfeedback.' + messageNoWhitespace).length == 0) {
        form.before(html);
    }
}

function confirmPasswords(form) {
    $('#CreatePassword').on('input', function(){
        var passwordOneValue = $('#PasswordOne').val(),
            passwordTwoValue = $('#CreatePassword').val();

        if (passwordOneValue != passwordTwoValue) {
            $('.ajaxfeedback.Password').remove();
            feedbackMessage('Password','error','Passwords do not match',form);
            $('label.password-required').removeClass('validated');
        } else {
            $('.ajaxfeedback.Password').remove();
            $('label.password-required').addClass('validated');
            feedbackMessage('Password','success','Passwords match',form);
            checkFormValidation(form);
        }
    });  
}


//BG: Check input values
function checkRequiredFields(form) {
    var formFields = form.find('input.required:not(.password-required)'),
        passwordFields = form.find('input.password-required');

    //For each required field....
    formFields.each(function(){
        //on input should detect: paste, right click, deleting text or typing text. 
        $(this).on('input', function(){
            var thisValue = $(this).val(),
                label = $(this).attr('id'),
                labelNoWhitespace = label.replace(/\s/g, "");

            //If the value is greater than 0
            //add valid input classes and remove invalid messages
            if (thisValue.length > 0) {
                $(this).addClass('input-valid');
                $(this).removeClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').addClass('validated')
                $('.ajaxfeedback.'+labelNoWhitespace).remove();
                checkFormValidation(form);
            } else {
                $(this).removeClass('input-valid');
                $(this).addClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').removeClass('validated')
            }
        });
    });

    if (passwordFields.length > 0) {
        confirmPasswords(form);
    }
}

//Highlighted the required fields to the user, and output error message.
function highlightRequiredFields(form) {
    //get list of labels
    var invalidFormLabels = form.find('label.required:not(.validated)'),
        once = 0;

    invalidFormLabels.each(function(){
        if ($(this).hasClass('password-required')) {
            //Run once
            if (once == 0) {
                feedbackMessage('Password','error','<strong>Password</strong> this field is required.',form);
                once++;
            }
        } else {
            var labelValue = $.trim($(this).text());
            feedbackMessage(labelValue,'error','<strong>'+labelValue+'</strong> this field is required.',form)
        }
    })

}

/* 
BG: Basic form validation intended for the registration form.
*/
function registrationFormValidation() {
    var registrationForm = $('#create_customer');

    checkRequiredFields(registrationForm);
    birthdayFormat(registrationForm);

    registrationForm.on('submit', function(e) {
        //If class is present, don't submit form.
        if ($(this).hasClass('validation-invalid')) {
            e.preventDefault();
            highlightRequiredFields(registrationForm);
        }
    });
}

function addressEditDelete() {

    //Delete Address, confirm user action.    
    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
    
    //Toggle edit address
    $('.edit-address').on('click', function() {
        var formId = $(this).attr('data-form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
          
        if ($(this).hasClass('address-edit-primary')) {
            $(this).addClass('hide');
        }
          
        if ($(this).hasClass('address-edit-secondary')) {
            $('.address-edit-primary').removeClass('hide');
        }
    });
}

function accountNavigation() {
    var accountSidebarTitle = $('.account-sidebar h3'),
        accountSidebarNavigation = $('.account-sidebar-navigation');

   accountSidebarTitle.on('click', function(){
        accountSidebarTitle.toggleClass('active');
        accountSidebarNavigation.toggleClass('active');
   });   
}

addressEditDelete();
resetPasswordForm();
forgotPassword();
registrationFormValidation();
accountNavigation();
(function () {
    function sidebarLinks() {
        var sidebarTitle = $('.sidebar-title'),
            sidebarContent = $('.sidebar-content');

        if ($(window).width() <= screenMD) {

            sidebarTitle.off('click').on('click', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).next('.sidebar-content').slideUp();
                } else {
                    $(this).addClass('active');
                    $(this).next('.sidebar-content').slideDown();
                }
            });

        } else {
            sidebarTitle.off('click');
            sidebarContent.css('display', '');
        }
    }

    sidebarLinks();

    if ($('.template-page').length || $('#warranty-form').length) {
        accordionToggle();
    }

    $(window).on('resize', function () {
        sidebarLinks();
    });
})();

// Help Zone Search Functionality
window.addEventListener('load', function () {
    let helpZoneWrapper = $(".help-zone-search-wrapper");

    if(helpZoneWrapper.length > 0){
        
        var searchResultsTimeout,
        templateView = helpZoneWrapper.data('view'),
        suggestionResultsBox = $(".help-zone-suggestions-wrapper .suggestion-results.results-content-box"),
        mainResultsBox = $(".help-zone-main-results-wrapper .main-results.results-content-box"),
        pageResultsBox = $(".help-zone-page-results-wrapper .page-results.results-content-box");

        $("input#help-zone-input").on("input", function () {
            var inputTrimmed = $(this).val().trim();

            // HM: Check if there any characters have been entered in search, ignoring pure whitespace
            if (inputTrimmed.length > 0) {
                mainResultsBox.text('');
                pageResultsBox.text('');
                suggestionResultsBox.text('');
                $(this).addClass('test');
                $('.js-help-zone-title strong').text(`"${inputTrimmed}"`);
                var searchTerm = $(this).val();
                $('.help-zone-sidebar-results').addClass('active-help');
                $('.help-zone-page-results-wrapper').addClass('active-help');
                $('.help-zone-suggestions-wrapper').addClass('active-help');
                $('.help-zone-main-results-wrapper').addClass('active-help');
                $('.help-zone-blocks__container').addClass('noactive-help');
                $('.help-zone-side-bar').addClass('margin-right');
                $('.page-results-cover').hide();
                $('.suggestion-results-cover').hide();
                $('.main-results-cover').hide();
                $('.main-results-cover.loading').show();
                clearTimeout(searchResultsTimeout);
                searchResultsTimeout = setTimeout(function () {
                    suggestionResults(searchTerm);
                    searchResults(searchTerm)
                }, 1000);
            } else {
                mainResultsBox.text('');
                pageResultsBox.text('');
                $(this).removeClass('test');
                $('.help-zone-sidebar-results').removeClass('active-help');
                $('.help-zone-page-results-wrapper').removeClass('active-help');
                $('.help-zone-suggestions-wrapper').removeClass('active-help');
                $('.help-zone-main-results-wrapper').removeClass('active-help');
                $('.help-zone-blocks__container').removeClass('noactive-help');
                $('.help-zone-side-bar').removeClass('margin-right');
                $('.main-results-cover').show();
                $('.main-results-cover.loading').hide();
                clearTimeout(searchResultsTimeout);
            }
        });
        $('div.suggestion-results').on('click', '.help-zone-suggestion-option', function () {
            mainResultsBox.text('');
            pageResultsBox.text('');
            $('.page-results-cover').hide();
            $('.main-results-cover').hide();
            $('.main-results-cover.loading').show();
            var selectedSuggestion = $(this).text();
            $("input#help-zone-input").val(selectedSuggestion);
            suggestionResults(selectedSuggestion);
            searchResults(selectedSuggestion);
        });
    }

    function suggestionResults(searchTerm) {
        // ? Make a request to the Predictive Search API for pages & suggestions
        if(!!searchTerm){
            let downcaseSearchTerm = searchTerm.toLowerCase();

            fetch(`${window.Shopify.routes.root}search/suggest.json?q=${searchTerm}&resources[limit_scope]=each&resources[limit]=${parseInt(suggestionResultsBox.data('limit'))}&resources[type]=query,page`)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                suggestionResultsBox.text('');
                if (data.resources.results.queries.length > 0) {
                    data.resources.results.queries.forEach((result) => {
                        let queryText = result.text.toLowerCase().replace(downcaseSearchTerm, `<strong class="highlight">${downcaseSearchTerm}</strong>`);
                        suggestionResultsBox.append('<p class="help-zone-suggestion-option">' + queryText + '</p>');
                    });
                } else {
                    $('.suggestion-results-cover.no-results').show();
                }
                if (data.resources.results.pages.length > 0) {
                    data.resources.results.pages.forEach((result) => {
                        let pageTitle = result.title.toLowerCase().replace(downcaseSearchTerm, `<strong class="highlight">${downcaseSearchTerm}</strong>`);
                        pageResultsBox.append('<a href="' + result.url + '"><p class="result-option">' + pageTitle + '</p></a>');
                    });
                } else {
                    $('.page-results-cover.no-results').show();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    function searchResults(searchTerm) {           
        // ? Make a request to an alternate liquid search template for main results
        fetch(`${window.Shopify.routes.root}search?view=help-zone&q=${searchTerm}&filter.p.tag=Allow+Product+Registration`)
        .then((response) => {
            return response.text();
        })
        .then((text) => {
            $('.main-results-cover.loading').hide();
            if(text.trim() === ''){
                $('.main-results-cover.no-results').show();
            } else {
                mainResultsBox.html(text);
                if(!!templateView){
                    $('.ps-results-product .product-card').each(function(){
                        let newURL = new URL(window.location.origin + $(this).attr('href'));
                        newURL.searchParams.set('view', templateView);
                        $(this).attr('href', newURL);
                    });
                }
            }
        })
        .catch((error) => {
            console.log(error);
            $('.main-results-cover.loading').hide();
            $('.main-results-cover.no-results').show();
        });
    }

    //JO: Clear search inputs

    function clearInput(input){
        input.val('');
        input.trigger('input');
        input.focus();
    }

    $(".js-help-zone-clear").on("click", () => clearInput($('input#help-zone-input')));
    $(".js-search-clear").on("click", () => {
        clearInput($('.site-search input[type="search"]'));
        $('#site-header .header-search-icon').click();
    });
});
$(document).ready(function () {
  $('.scroll-link').click(function(e){
    $([document.documentElement, document.body]).animate({
        scrollTop: $($(this).data('scroll')).offset().top
    }, 2000);
  })
});
// JO: Updated code post Klevu removal

document.addEventListener('DOMContentLoaded', e => {
    function collectionCTA() {
        var ctaContainers = document.querySelectorAll('.collection-inline-cta-container');
        ctaContainers.forEach(function (ctaContainer) {
          var number = parseInt(ctaContainer.getAttribute('data-cta-position'));
          var nthChild = document.querySelector('.plp-products .product-card-wrapper:nth-child(' + number + ')');
          if (typeof nthChild != 'undefined' && nthChild != null) {
            nthChild.insertAdjacentElement('afterend', ctaContainer);
          }
        });
    }
    collectionCTA();
    // Existing JS

    if(document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')){
        const showFilterBtn = document.querySelector('.js-mobile-filters');
        const closeFilterBtn = document.querySelector('.js-close-mobile-filters');
        const filtersWrapper = document.querySelector('.js-plp-filters');
        const pageBody = document.querySelector('body');

        showFilterBtn.addEventListener('click', function(){
            filtersWrapper.style.display = 'block';
            pageBody.style.overflow = 'hidden';
        });
        closeFilterBtn.addEventListener('click', function(){
            filtersWrapper.style.display = 'none';
            pageBody.style.overflow = 'auto';
        });
    }

    // Updated JS

    let filters = document.querySelectorAll('details'),
    cloneColourWays = document.querySelectorAll('.js-filter-clone'),
    cloneSliderWrapper = document.querySelector('.desktop-clone-wrapper'),
    cloneSlider = cloneSliderWrapper?.querySelector('.desktop-design-filter-clones'),
    sortBy = document.getElementById('sort-by'),
    sortByButtons = document.querySelectorAll('.js-sort-button');

    // Mobile Sort buttons
    sortByButtons.forEach(button => button.addEventListener('click', e => setSortParam(e.target.value)));

    // Mobile Sort Select
    if(!!sortBy){
        sortBy.addEventListener('change', e => {
            setSortParam(e.target.value);
        }) 
    }

    function setSortParam(value){
        let currentUrl = new URL(window.location.href);

        currentUrl.searchParams.set('sort_by', value);

        window.location.href = currentUrl;
    }

    if(!!cloneSlider){
        let prevArrow = cloneSliderWrapper.querySelector('.js-scroll-backward'),
        nextArrow = cloneSliderWrapper.querySelector('.js-scroll-forward'),
        fullScroll = cloneSlider.scrollWidth - cloneSlider.clientWidth,
        scollAmount = window.innerWidth < 768 ? 140 : 255,
        scrollLeft = 0;

        cloneSlider.addEventListener('scroll', e => {
            scrollLeft = e.target.scrollLeft;
            if(scrollLeft < fullScroll){
                nextArrow.classList.remove('disabled');
            } else if(scrollLeft == fullScroll){
                nextArrow.classList.add('disabled');
            }
            if(scrollLeft > 0){
                prevArrow.classList.remove('disabled');
            } else if(scrollLeft == 0){
                prevArrow.classList.add('disabled');
            }
        });

        prevArrow?.addEventListener('click', e => {
            if(!prevArrow.classList.contains('disabled')){
                cloneSlider.scrollLeft -= scollAmount;
                scrollLeft -= scollAmount;

                if(scrollLeft < scollAmount){
                    cloneSlider.scrollLeft = 0;
                    scrollLeft = 0;
                }
            }
        });

        nextArrow?.addEventListener('click', e => {
            if(!nextArrow.classList.contains('disabled')){
                cloneSlider.scrollLeft += scollAmount;
                scrollLeft += scollAmount;

                if(scrollLeft > (fullScroll - scollAmount)){
                    cloneSlider.scrollLeft = fullScroll;
                    scrollLeft = fullScroll;
                }
            }
        });
    }

    // Ensure only 1 tab is open at a time
    filters.forEach(filter => {
        filter.addEventListener('click', e => {
            let target = e.target.closest('details'),
            openFilters = document.querySelectorAll('details[open]');
            openFilters.forEach(item => item != target && item.removeAttribute('open'));
        });
    });

    document.querySelectorAll('.js-price-box').forEach(button => {
        button.addEventListener('click', e => {
          const min = button.dataset.min;
          const max = button.dataset.max;
          const form = document.querySelector('form.js-plp-filters');
      
          const gteInput = form.querySelector('#price-gte');
          const lteInput = form.querySelector('#price-lte');
      
          const isAlreadyActive = button.classList.contains('active');
      
          document.querySelectorAll('.js-price-box').forEach(b => b.classList.remove('active'));
      
          if (isAlreadyActive) {
            gteInput.value = '';
            lteInput.value = '';
          } else {
            gteInput.value = min;
            lteInput.value = max;
            button.classList.add('active');
          }
        });
      });

      const urlParams = new URLSearchParams(window.location.search);

      const gteParam = urlParams.get('filter.v.price.gte');
      const lteParam = urlParams.get('filter.v.price.lte');
      
      const gteInput = document.querySelector('#price-gte');
      const lteInput = document.querySelector('#price-lte');
      
      if (gteInput && lteInput && gteParam && lteParam) {
        gteInput.value = gteParam;
        lteInput.value = lteParam;
      
        const activeBox = document.querySelector(
          `.js-price-box[data-min="${gteParam}"][data-max="${lteParam}"]`
        );
        activeBox?.classList.add('active');
      }

      const isSearchPage = document.body.classList.contains('template-search');
      const baseUrl = isSearchPage ? '/search' : window.location.pathname;
      const boxes = document.querySelectorAll('.js-price-box');
      const searchParamsBase = new URLSearchParams(window.location.search);
      const container = document.querySelector('.js-price-box-container');

      // Create an array of fetch promises
      const fetches = Array.from(boxes).map(button => {
        const min = button.dataset.min;
        const max = button.dataset.max;

        const params = new URLSearchParams(searchParamsBase);
        params.set('filter.v.price.gte', min);
        params.set('filter.v.price.lte', max);
        params.set('view', 'price-count');

        return fetch(`${baseUrl}?${params.toString()}`)
            .then(res => res.text())
            .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const count = doc.querySelectorAll('.product-card-wrapper').length;

            if (count === 0) {
                button.closest('.price-box')?.remove();
            }
            })
            .catch(err => console.error(`Price range ${min}-${max} fetch failed:`, err));
      });

      // After all fetches finish, show the container
      Promise.all(fetches).then(() => {
        if (container) container.classList.remove('is-hidden');
      });
      

    // Select real colourway filters and submit form
    cloneColourWays.forEach(clone => {
        clone.addEventListener('click', e => {
            let filterForm = document.querySelector('form.js-plp-filters'),
            originalColourWay = filterForm.querySelector(`[data-colourway="${clone.id}"]`),
            submitButton = filterForm.querySelector('button.js-mobile-filter-btn');

            if(!!originalColourWay){
                originalColourWay.checked = clone.classList.contains('active') ? false : true;
                submitButton?.click();
            }
        });
    });

    // Search Check for type URL param
    if (document.body.classList.contains('template-search')) {
        const currentUrl = new URL(window.location.href);
        const hasType = currentUrl.searchParams.has('type');
      
        if (!hasType) {
          currentUrl.searchParams.set('type', 'product');
          window.location.href = currentUrl.href;
        }
    }

    function reinitializeTrustpilotWidgets() {
        let trustpilotWidgets = document.querySelectorAll('.trustpilot-widget');
        trustpilotWidgets.forEach(widget => {
            Trustpilot?.loadFromElement(widget);
        });
    }

    // JO: Set colourway clones to active when original is checked

    let colourwayCheckboxes = document.querySelectorAll('.js-style-filter[data-colourway]');

    colourwayCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', e => {
            let clone = document.querySelector(`.js-filter-clone#${checkbox.getAttribute('data-colourway')}`);
            if(!!clone){
                clone.classList.toggle('active');
            }
        });
    });

    // JO: Load More Button used to fetch alternate view templates for pagination
    
    class LoadMore extends HTMLElement {
        constructor(){
            super();
            this.data = {
                page: Number(this.dataset?.page),
                pages: Number(this.dataset?.pages),
                template: this.dataset?.template,
                container: this.dataset?.container,
                url: new URL(window.location.href),
                itemSelector: this.dataset?.itemSelector
    
            }
    
            this.addEventListener('click', e => this.getItems(e));
        }
        async getItems(e){
            let nextPage = this.data.page + 1;
    
            if(nextPage <= this.data.pages){
                this.querySelector('.js-loading')?.classList.remove('no-load');
                this.querySelector('.js-text')?.classList.add('no-load');
                this.data.url.searchParams.set('page', nextPage);
                this.data.url.searchParams.set('view', this.data.template);
                let nextPageResponse = await fetch(this.data.url.href),
                nextPageHtml = await nextPageResponse.text();

                let parser = new DOMParser(),
                nextPageDoc = parser.parseFromString(nextPageHtml, 'text/html');
                
                if(!!nextPageHtml && !nextPageHtml.includes('!doctype html')){
                    let itemsContainer = document.querySelector(`${this.data.container}`),
                    items = nextPageDoc.querySelectorAll(`${this.data.itemSelector}`);
                    if(!!itemsContainer && items.length > 0){
                        items.forEach(item => itemsContainer.appendChild(item));
                        this.dataset.page = nextPage;
                        this.data.page = nextPage;
                        nextPage == this.data.pages && this.setAttribute('disabled', 'true');
                        let collectionCounts = document.querySelectorAll('.js-collection-count'),
                        productCardsCount = document.querySelectorAll('.plp-products .product-card-wrapper').length;
                        
                        collectionCounts.forEach(collectionCount => {
                            collectionCount.textContent = productCardsCount;
                        }); 

                        setTimeout(() => reinitializeTrustpilotWidgets(), 500);
                    }
                }
                this.querySelector('.js-loading')?.classList.add('no-load');
                this.querySelector('.js-text')?.classList.remove('no-load');
            }
        }
    }
      
    customElements.define('load-more', LoadMore);
});

//Open and close the mobile Search
function siteSearch() {
    var searchIcon = $('#site-header .header-search-icon'),
        menuIcon = $('#site-header .header-mobile-menu'),
        menu = $('#navigation-mobile'),
        searchBar = $('.search-bar'),
        searchInput = $('.search-bar input[type="search"]');

    searchIcon.click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            searchBar.slideUp();
        } else {
            // HM todo: Both mobile search and mobile nav are full screen, so need to be sure to shut the other down when one opens. This can be refactored
            if (menuIcon.hasClass('active')) {
                menuIcon.removeClass('active');
                menu.removeClass('active');
                menu.removeClass('transition');
                $('html').removeClass('nav-open');
                $('body').removeClass('nav-push');
                $('#navigation-mobile .sub-open').removeClass('sub-open');
                $('#navigation-mobile ul.active').removeClass('active');
            }
            $(this).addClass('active');

            // HM: Only desktop will slide down as searchIcon doesn't exist on mobile.
            searchBar.slideDown('slow');
            searchInput.focus();

        }
    });
}


//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
    var menuIcon = $('#site-header .header-mobile-menu'),
        menu = $('#navigation-mobile'),
        searchIcon = $('#site-header .header-search-icon'),
        searchBar = $('.search-bar');

    menuIcon.click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            menu.removeClass('active');
            menu.removeClass('transition');
            $('html').removeClass('nav-open');
            $('body').removeClass('nav-push');
        } else {
            if ($(window).width() >= screenLG && $(window).width() <= menuBreakPoint) {
              $('#navigation-mobile').addClass('sub-open');
              $('#navigation-mobile #main-nav').addClass('active');
            }
            if (searchIcon.hasClass('active')) {
                searchIcon.removeClass('active');
                searchBar.slideUp();
            }
            $(this).addClass('active');
            menu.addClass('active');
            $('html').addClass('nav-open');
            $('body').addClass('nav-push');
        }
    });
}

function mobileNavigation() {
    var parentLink = $("#navigation-mobile .first-level > .has-children > a"),
      parentBackLink = $(".second-level > .mobile-navigation-header .nav-back"),
      secondaryLink = $("#navigation-mobile .second-level > .has-children > a"),
      secondaryBackLink = $(".third-level > .mobile-navigation-header .nav-back");
  
    if ($(window).width() <= screenLG) {
  
      parentLink.off("click").on("click", function (e) {
        e.preventDefault();
        parentLink.siblings(".second-level").removeClass("active");
        $(this).siblings(".second-level").addClass("active");
      });
  
      secondaryLink.off("click").on("click", function (e) {
        e.preventDefault();
        secondaryLink.siblings(".second-level").removeClass("active");
        $(this).siblings(".third-level").addClass("active");
      });
  
      parentBackLink.off("click").on("click", function (e) {
        $(this).parents(".second-level.active").removeClass("active");
      });
  
      secondaryBackLink.off("click").on("click", function (e) {
        $(this).parents(".third-level.active").removeClass("active");
      });
  
    }
  }

function countrySelect() {
	var currentCountry = $('.current-country li');

	currentCountry.click(function(){
		$(this).toggleClass('active');
	});
}

function headerButtons() {
    // Select all buttons with class "nav-button"
    var buttons = $(".nav-button");
  
    // Add a click event handler to each button
    buttons.click(function () {
      // Toggle the "active" class on the corresponding message
      var message = $(this).find(".button-message");
      message.toggleClass("active");

      // Hide all other messages
      $(".button-message").not(message).removeClass("active");
    });
}

function thirdLevelNavToggle() {
    // Find all containers with class 'second-level-container'
    var containers = document.querySelectorAll('.second-level-container');

    // Iterate over each container
    containers.forEach(function (container) {
        // Find all elements with class 'has-third-level-popup' within this container
        var second_level_buttons = container.querySelectorAll('.has-third-level-popup');

        // Add click event listener to each element within this container
        second_level_buttons.forEach(function (element) {
            element.addEventListener('click', function (event) {
                // Prevent the default behavior of the anchor
                event.preventDefault();

                // Remove 'active' class from all elements with class 'has-third-level-popup' within this container
                second_level_buttons.forEach(function (button) {
                    button.classList.remove('active');
                });

                // Add 'active' class to the clicked element within this container
                element.classList.add('active');

                // Get the value of 'data-title' attribute
                var dataTitle = element.getAttribute('data-title');

                // Find the corresponding third-level-block element within this container
                var thirdLevelBlock = container.querySelector('.third-level-block[data-title="' + dataTitle + '"]');

                // Remove 'active' class from all third-level-block elements within this container
                var allThirdLevelBlocks = container.querySelectorAll('.third-level-block');
                allThirdLevelBlocks.forEach(function (block) {
                    block.classList.remove('active');
                });

                // Add 'active' class to the corresponding third-level-block element within this container
                thirdLevelBlock.classList.add('active');
            });
        });
    });
}



$(document).ready(function () {
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation();
    countrySelect();
    headerButtons();
    thirdLevelNavToggle();
});

$(window).on('resize', function () {
    mobileNavigation();
});
function footerLinks() {
	var footerTitle = $('footer .footer-title:not(.nocollapse)'),
		footerContent = $('footer .footer-content');

	if ($(window).width() <= screenSM) {
		
		footerTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.footer-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.footer-content').slideDown();
			}
		});
		
	} else {
		footerTitle.off('click');
		footerContent.css('display', '');
	}
}

if ($("a[href='#scrollTop']").length > 0) {
	// HM: Iterate over the two types of scroll button, bottom takes an element ID, finds it's offset from top and scrolls to that point
	$("a[href='#scrollTop']").each(function () {
		$(this).click(function (e) {
			e.preventDefault();
			$("html, body").animate({scrollTop: 0}, "slow");
		})
	});
}

footerLinks();

$(window).on('resize',function() {
	console.log('resize footer');
	handleStickyCart();
    footerLinks();
	handlePaymentGrid();
});
theme.Filters = (function () {

    var selectors = {
        filterSelection: '#FilterTags',
        filterHeaders: '.filters__header',
        sortSelection: '#SortBy',
        checkboxInputChecked: 'input[type="checkbox"]:checked',
        checkboxInput: 'input[type="checkbox"]',
        resetButton: '#ResetFilters'
    };

    function Filters(container) {
        this.filterSelect = container.querySelector(selectors.filterSelection);
        this.sortSelect = container.querySelector(selectors.sortSelection);
        this.url = container.dataset.collectionUrl;
        this.filterHeaders = container.querySelectorAll(selectors.filterHeaders);
        this.filterReset = container.querySelector(selectors.resetButton);
        this.getCheckboxFilters = function () {
            return container.querySelectorAll(selectors.checkboxInputChecked);
        };
        this.getAllCheckboxes = function () {
            return container.querySelectorAll(selectors.checkboxInput);
        };

        if (this.sortSelect) {
            this.defaultSort = this._getDefaultSortValue();
        }

        if (this.filterHeaders) {
            this.filterHeaders.forEach(function (header) {
                header.addEventListener('click', function (e) {
                    e.target.classList.toggle('active');
                })
            })
        }

        if (this.filterSelect) {
            this.filterSelect.addEventListener(
                'change',
                this._onFilterChange.bind(this)
            );
        }

        if (this.sortSelect) {
            this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
        }

        if (this.filterReset && this._hasFilters()) {
            this.filterReset.disabled = false;
            this.filterReset.addEventListener('click', this._onReset.bind(this));
        }

        this._initParams();
    }

    Filters.prototype = Object.assign({}, Filters.prototype, {
        _initParams: function () {
            this.queryParams = {};
            if (location.search.length) {
                var aKeyValue;
                var aCouples = location.search.substr(1).split('&');
                for (var i = 0; i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        this.queryParams[
                            decodeURIComponent(aKeyValue[0])
                            ] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },

        _onSortChange: function () {
            this.queryParams.sort_by = this._getSortValue();

            if (this.queryParams.page) {
                delete this.queryParams.page;
            }

            window.location.search = decodeURIComponent(
                new URLSearchParams(Object.entries(this.queryParams)).toString()
            );
        },

        _onFilterChange: function () {
            // HM: Simply disable all checkboxes to allow page to reload and apply filters
            this.getAllCheckboxes().forEach(function(checkbox) {
                checkbox.disabled = true;
            })
            document.location.href = this._getFilterValue();
        },

        _onReset: function () {
            document.location.href = this.url;
        },
        

        _hasFilters: function () {
            var filters = Array.from(this.getCheckboxFilters()).filter(function (input) {
                return input.checked;
            });
            return Boolean(filters.length);
        },

        _getFilterValue: function () {
            var filterUrl = Array.from(this.getCheckboxFilters()).map(function (checked) {
                return checked.value;
            }).join('+');
            var existingSort = new URLSearchParams(Object.entries(this.queryParams)).toString();
            var sortAppend = existingSort.length > 0 ? '?' + existingSort : "";
            return this.url + '/' + filterUrl + sortAppend;
        },

        _getSortValue: function () {
            return this.sortSelect.value || this.defaultSort;
        },

        _getDefaultSortValue: function () {
            return this.sortSelect.dataset.defaultSortby;
        },

        onUnload: function () {
            if (this.filterSelect) {
                this.filterSelect.removeEventListener('change', this._onFilterChange);
            }

            if (this.sortSelect) {
                this.sortSelect.removeEventListener('change', this._onSortChange);
            }
        }
    });

    return Filters;
})();

if (document.getElementById('native-collection')) {
    var filterInstance = Object.assign(new theme.Filters(document.getElementById('native-collection')));
}

function addCollectionBuyButtons() {
    $('.wishlist-button-container[data-has-buy-button]').on('click', function (e) {
        var addToCartButton = $('.btn.btn-primary', this);
        var variantId = addToCartButton.attr('data-variant-id');
        if (e.target === addToCartButton[0]) {
            e.preventDefault();
            addToCartWithoutForm(addToCartButton, $(this), variantId)
        }
        e.stopImmediatePropagation();
    });
}



/* Group Product Cards */
function fetchColourwayImages(familyHandle, bundleTypeHandle = '') {
    const bundleSegment = bundleTypeHandle ? `+bundletype_${bundleTypeHandle}` : '';
    const url = `/collections/all/family_${familyHandle}${bundleSegment}+web-store?view=json-colourways`;
    //console.log(url);

    return fetch(url)
        .then(res => {
            if (!res.ok) throw new Error(`Failed to fetch colourways for ${familyHandle}`);
            return res.json();
        })
        .then(data => {
            if (!data.products) return [];

            return data.products
                .map(product => ({
                    name: product.colourwayName,
                    bundleSaving: product.bundleSaving,
                    image: product.image.startsWith('//') ? 'https:' + product.image : product.image,
                    url: product.url
                }))
                .filter(product => !product.image.includes('no-image'));

        })
        .catch(err => {
            console.error(`Error loading colourways for ${familyHandle}${bundleSegment}:`, err);
            return [];
        });
}

(function () {
    const groupedContainer = document.querySelector('.plp-products.grouped');
    if (!groupedContainer) return;

    const urlParams = new URLSearchParams(window.location.search);

    const hasFamilyFilter = urlParams.has('filter.p.m.filter.family');
    const hasColourwayFilter = urlParams.has('filter.p.m.filter.colourway');
    const hasAnyFilters = urlParams.toString() !== '';
    const noFilters = !hasAnyFilters;
    const noFamilyOrColourway = hasAnyFilters && !hasFamilyFilter && !hasColourwayFilter;

    if (!groupedContainer) return;

    const productCards = groupedContainer.querySelectorAll('.product-card-wrapper');
    let hiddenCount = 0;

    const familyMap = new Map(); // Used for default family grouping
    const familyBundleMap = new Map(); // For family + bundletype grouping
    const familyColourways = new Map(); // Tracks how many colourways exist per family

    // Collect grouping maps and stats
    productCards.forEach((card) => {
        const family = card.getAttribute('data-family');
        const bundletype = card.getAttribute('data-bundletype') || '';
        const colourway = card.getAttribute('data-colourway') || '';

        if (!family) return;

        // Track all cards by family
        if (!familyMap.has(family)) familyMap.set(family, []);
        familyMap.get(family).push(card);

        // Track colourways per family
        if (!familyColourways.has(family)) familyColourways.set(family, new Set());
        familyColourways.get(family).add(colourway);

        // Track cards by (family + bundletype)
        const key = bundletype ? `${family}|||${bundletype}` : family;
        if (!familyBundleMap.has(key)) familyBundleMap.set(key, []);
        familyBundleMap.get(key).push(card);
    });

    const applyFamilyBundleGrouping = noFilters || noFamilyOrColourway;
    const applyFamilyColourwayGrouping = hasFamilyFilter && !hasColourwayFilter;

    if (applyFamilyBundleGrouping) {
        // Group by family + bundletype (or just family if no bundletype)
        familyBundleMap.forEach((cards, key) => {
            cards.forEach((card, index) => {
                if (index === 0) {
                    card.classList.add('group');
                } else {
                    card.classList.add('hide');
                    hiddenCount++;
                }
            });
        });

    } else if (applyFamilyColourwayGrouping) {
        // Only group if family has more than one colourway
        familyBundleMap.forEach((cards, key) => {
            const [family] = key.split('|||');
            const colourwaySet = familyColourways.get(family);
            const colourwayCount = colourwaySet ? colourwaySet.size : 0;

            if (colourwayCount <= 1) {
                return;
            }

            // Group each (family + bundletype)
            cards.forEach((card, index) => {
                if (index === 0) {
                    card.classList.add('group');
                } else {
                    card.classList.add('hide');
                    hiddenCount++;
                }
            });
        });

    }

    document.querySelectorAll('.product-card-wrapper.group').forEach((card) => {
        const family = card.getAttribute('data-family');
        const uptoAttr = card.getAttribute('data-upto');
        const upto = uptoAttr ? uptoAttr : '';
        if (!family) return;

        let bundletype = card.getAttribute('data-bundletype') || '';
        if (bundletype.startsWith('bundletype_')) {
            bundletype = bundletype.replace(/^bundletype_/, '');
        }
        
        fetchColourwayImages(family, bundletype).then(colourways => {
            if (!colourways.length) return;

            const infoEl = document.createElement('div');
            infoEl.className = 'colourway-summary';

            // Ensure unique images only
            const uniqueImages = new Map();
            colourways.forEach(cw => {
                if (!uniqueImages.has(cw.image)) {
                    uniqueImages.set(cw.image, cw);
                }
            });

            const uniqueImageArray = [...uniqueImages.values()];
            const maxToShow = 5;
            const imagesToShow = uniqueImageArray.slice(0, maxToShow);
            const remainingCount = uniqueImageArray.length - maxToShow;

            imagesToShow.forEach(cw => {
                const img = document.createElement('img');
                img.src = cw.image;
                img.alt = cw.name;
                img.width = 40;
                img.height = 40;
                img.loading = 'lazy';
                img.className = 'colourway-thumb';
                infoEl.appendChild(img);
            });

            if (remainingCount > 0) {
                const moreSpan = document.createElement('span');
                moreSpan.className = 'colourway-more';
                moreSpan.textContent = `+${remainingCount}`;
                // Optionally add a "+" icon SVG here if you want a graphic
                infoEl.appendChild(moreSpan);
            }

            const imageContainer = card.querySelector('.product-card-title');
            if (imageContainer && imageContainer.parentNode) {
                imageContainer.parentNode.insertBefore(infoEl, imageContainer.nextSibling);
            } else {
                // Fallback: if image container not found, append at end
                card.appendChild(infoEl);
            }

            // Bundle Saving
            const allSavings = colourways
                .map(cw => cw.bundleSaving)
                .filter(s => typeof s === 'string' && s.trim() !== '');
        
            //console.log(`\n[Bundle Savings] Family: ${family}, Bundletype: ${bundletype}`);
            //console.log('All bundleSavings:', allSavings);
        
            const maxSaving = colourways.reduce((max, cw) => {
                const current = parseFloat(cw.bundleSaving?.replace(/[^\d.]/g, '')) || 0;
                const maxVal = parseFloat(max?.replace(/[^\d.]/g, '')) || 0;
                return current > maxVal ? cw.bundleSaving : max;
            }, null);
        
            //console.log('Selected max bundleSaving:', maxSaving);
        
            if (maxSaving) {
                const savingDisplay = card.querySelector('.product-details__bundle-price-saving .money');
                if (savingDisplay) {
                    const originalText = savingDisplay.textContent.trim();
                    const newText = maxSaving;
            
                    if (originalText !== newText) {
                        //console.log(`→ Updating saving display for family '${family}', bundletype '${bundletype}'`);
                        //console.log(`   Original: "${originalText}"`);
                        //console.log(`   New:      "${newText}"`);
                        savingDisplay.textContent = upto + ' ' + newText;
                    } else {
                        //console.log(`→ No update needed for family '${family}', bundletype '${bundletype}' (value already correct: "${originalText}")`);
                    }
                } else {
                    console.warn(`Saving display element not found in card for family '${family}'`);
                }
            }            

        });
    });

    // Hide load more button if any grouping occurred
    if (hiddenCount > 0) {
        const loadMoreBtn = document.querySelector('.load-more-button');
        if (loadMoreBtn) loadMoreBtn.classList.add('hide');
    }

    // Update result count if grouping applied
    if (applyFamilyBundleGrouping || applyFamilyColourwayGrouping) {
        const visibleCount = document.querySelectorAll('.product-card-wrapper.group').length;
        document.querySelectorAll('.js-collection-count').forEach((countEl) => {
            countEl.textContent = visibleCount;
        });
        document.querySelectorAll('.js-collection-total').forEach((totalEl) => {
            totalEl.textContent = visibleCount;
        });
    }     

    function sortAndRenderSafe(sortType) {
        // Ensure data attributes are set before sorting
        updateGroupCardDataAttributes();
        
        // Get all children and their types with their original positions
        const allChildren = Array.from(groupedContainer.children);
        const childrenWithPositions = allChildren.map((child, index) => ({
            element: child,
            originalIndex: index,
            isProduct: child.classList.contains('product-card-wrapper') && child.classList.contains('group'),
            isCTA: child.classList.contains('collection-inline-cta-container')
        }));
        
        const productCards = childrenWithPositions.filter(item => item.isProduct);
        const ctaCards = childrenWithPositions.filter(item => item.isCTA);
        
        // Sort the product cards
        const sortedProductCards = productCards.sort((a, b) => {
            const aCard = a.element.querySelector('.product-card');
            const bCard = b.element.querySelector('.product-card');
            const aPrice = aCard ? parseInt(aCard.getAttribute('data-price')) : 0;
            const bPrice = bCard ? parseInt(bCard.getAttribute('data-price')) : 0;
            const aManual = aCard ? parseInt(aCard.getAttribute('data-manual-order')) : 0;
            const bManual = bCard ? parseInt(bCard.getAttribute('data-manual-order')) : 0;

            if (sortType === 'price-ascending') {
                return aPrice - bPrice;
            }
            if (sortType === 'price-descending') {
                return bPrice - aPrice;
            }
            if (sortType === 'manual' || sortType === 'manual-order' || sortType === '') {
                return aManual - bManual;
            }
            // Default: return to original order
            return a.originalIndex - b.originalIndex;
        });
        
        // Clear the container
        groupedContainer.innerHTML = '';
        
        // Rebuild the container maintaining CTA positions
        let productIndex = 0;
        let ctaIndex = 0;
        
        // Go through original positions and place elements accordingly
        childrenWithPositions.forEach((item, originalPosition) => {
            if (item.isProduct) {
                // Place the next sorted product card
                if (productIndex < sortedProductCards.length) {
                    groupedContainer.appendChild(sortedProductCards[productIndex].element);
                    productIndex++;
                }
            } else if (item.isCTA) {
                // Place the CTA card in its original position
                if (ctaIndex < ctaCards.length) {
                    groupedContainer.appendChild(ctaCards[ctaIndex].element);
                    ctaIndex++;
                }
            } else {
                // Place any other elements in their original position
                groupedContainer.appendChild(item.element);
            }
        });
    }
    window.sortAndRenderSafe = sortAndRenderSafe;
})();


(function () {
    const groupedContainer = document.querySelector('.plp-products.grouped');
    const sortBy = document.getElementById('sort-by');
    if (!groupedContainer || !sortBy) return;

    // Helper: get all children and their types
    function getChildrenWithTypes() {
        return Array.from(groupedContainer.children).map(child => ({
            node: child,
            isProduct: child.classList.contains('product-card-wrapper') && child.classList.contains('group')
        }));
    }

    function getSortedGroupCards(sortType) {
        return Array.from(document.querySelectorAll('.product-card-wrapper.group')).sort((a, b) => {
            const aCard = a.querySelector('.product-card');
            const bCard = b.querySelector('.product-card');
            const aPrice = aCard ? parseInt(aCard.getAttribute('data-price')) : 0;
            const bPrice = bCard ? parseInt(bCard.getAttribute('data-price')) : 0;
            const aManual = aCard ? parseInt(aCard.getAttribute('data-manual-order')) : 0;
            const bManual = bCard ? parseInt(bCard.getAttribute('data-manual-order')) : 0;

            if (sortType === 'price-ascending') {
                return aPrice - bPrice;
            }
            if (sortType === 'price-descending') {
                return bPrice - aPrice;
            }
            return aManual - bManual;
        });
    }

    function sortAndRender(sortType) {
        const children = getChildrenWithTypes();
        const sortedProducts = getSortedGroupCards(sortType);
        let productIndex = 0;

        children.forEach((childObj, index) => {
            if (childObj.isProduct) {
                // Replace product card with the next in sorted order
                if (sortedProducts[productIndex] !== childObj.node) {
                    groupedContainer.replaceChild(sortedProducts[productIndex], childObj.node);
                }
                productIndex++;
            }
            // If not a product card, leave as is (advert/cta)
        });
    }

    // Wait for CTA cards to be loaded (if dynamic)
    function waitForCTAsAndInit() {
        // If CTAs are already present, init immediately
        if (groupedContainer.querySelector('.collection-inline-cta-container')) {
            initSort();
            return;
        }
        // Otherwise, observe for CTA insertion
        const observer = new MutationObserver((mutations, obs) => {
            if (groupedContainer.querySelector('.collection-inline-cta-container')) {
                obs.disconnect();
                initSort();
            }
        });
        observer.observe(groupedContainer, { childList: true, subtree: false });
    }

    function initSort() {
        // Prevent form submission if inside a form
        if (sortBy.form) {
            sortBy.form.addEventListener('submit', function(e) {
                e.preventDefault();
            });
        }
        sortBy.addEventListener('change', function(e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            // sortAndRender(sortBy.value); // Original function
            sortAndRenderSafe(sortBy.value); // Safer function for testing
        }, true);
    }

    waitForCTAsAndInit();
})();

function updateGroupCardDataAttributes() {
    document.querySelectorAll('.product-card-wrapper.group').forEach((card, idx) => {
        const productCard = card.querySelector('.product-card');
        
        // Get the original manual order from Liquid (don't overwrite it)
        const originalManualOrder = productCard?.getAttribute('data-manual-order');
        
        // Only update the price attribute, preserve the original manual order
        let domPrice = productCard?.getAttribute('data-price');
        let priceCents = 0;
        if (domPrice && !isNaN(domPrice) && domPrice !== "0") {
            priceCents = parseInt(domPrice, 10);
        } else {
            // Fallback: try to parse from visible price
            const priceEl = card.querySelector('.product-card-price-container__bundle .product-card-price');
            let priceText = priceEl ? priceEl.textContent.trim() : '';
            let cleanPrice = priceText.replace(/[^0-9.]/g, '');
            if (cleanPrice && !isNaN(cleanPrice)) {
                priceCents = Math.round(parseFloat(cleanPrice) * 100);
            }
        }
        
        // Set or update the price attribute only
        productCard?.setAttribute('data-price', priceCents);
        
        // Preserve the original manual order (don't overwrite with current DOM position)
        if (!originalManualOrder) {
            productCard?.setAttribute('data-manual-order', idx);
        }
    });
}

// Debounce logic
let updateTimeout;
function debouncedUpdateGroupCardDataAttributes() {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(updateGroupCardDataAttributes, 150); // Adjust delay as needed
}

// Only set up MutationObserver if grouping is enabled
if (document.querySelector('.plp-products.grouped')) {
    const observer = new MutationObserver(function(mutations) {
        // Only trigger if the mutation is related to grouping (adding/removing .group class)
        const hasGroupingChanges = mutations.some(mutation => {
            return mutation.type === 'attributes' && 
                   mutation.attributeName === 'class' &&
                   (mutation.target.classList.contains('product-card-wrapper') ||
                    mutation.target.classList.contains('group'));
        });
        
        if (hasGroupingChanges) {
            // Debounce the update function
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(updateGroupCardDataAttributes, 500);
        }
    });
    
    // Only observe the product grid, not all children
    const productGrid = document.querySelector('.plp-products.grouped');
    if (productGrid) {
        observer.observe(productGrid, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
        });
    }
}

function getGroupCardsWithPrice() {
    return Array.from(document.querySelectorAll('.product-card-wrapper.group')).map(card => {
        const priceEl = card.querySelector('.product-card-price-container__bundle .product-card-price');
        let priceText = priceEl ? priceEl.textContent : '';
        let price = priceText.replace(/[^0-9.]/g, '');
        let priceCents = Math.round(parseFloat(price) * 100);
        return {
            card,
            price: isNaN(priceCents) ? 0 : priceCents,
            manualOrder: parseInt(card.querySelector('.product-card')?.getAttribute('data-manual-order')) || 0
        };
    });
}

function sortGroupedProducts(sortType) {
    // Always get the current set of visible group cards
    const visibleGroupCards = Array.from(document.querySelectorAll('.product-card-wrapper.group:not(.hide)'));
    
    if (visibleGroupCards.length === 0) return;
    
    // Sort the cards based on the sort type
    const sortedCards = visibleGroupCards.sort((a, b) => {
        const productCardA = a.querySelector('.product-card');
        const productCardB = b.querySelector('.product-card');
        
        if (sortType === 'price-ascending') {
            const priceA = parseInt(productCardA?.getAttribute('data-price') || '0', 10);
            const priceB = parseInt(productCardB?.getAttribute('data-price') || '0', 10);
            return priceA - priceB;
        } else if (sortType === 'price-descending') {
            const priceA = parseInt(productCardA?.getAttribute('data-price') || '0', 10);
            const priceB = parseInt(productCardB?.getAttribute('data-price') || '0', 10);
            return priceB - priceA;
        } else if (sortType === 'manual') {
            const orderA = parseInt(productCardA?.getAttribute('data-manual-order') || '0', 10);
            const orderB = parseInt(productCardB?.getAttribute('data-manual-order') || '0', 10);
            return orderA - orderB;
        }
        return 0;
    });
    
    // Reorder the cards in the DOM
    const container = document.querySelector('.plp-products.grouped');
    if (container) {
        sortedCards.forEach(card => {
            container.appendChild(card);
        });
    }
}

// Example: attach to sort-by select
const sortBy = document.getElementById('sort-by');
if (sortBy) {
    sortBy.addEventListener('change', function(e) {
        e.preventDefault();
        setTimeout(() => sortGroupedProducts(sortBy.value), 500); // Wait for DOM/prices to settle
    });
}

// Disable infinite scroll when grouping is enabled
if (document.querySelector('.plp-products.grouped')) {
    const loadMoreButton = document.querySelector('load-more');
    if (loadMoreButton) {
        loadMoreButton.style.display = 'none';
    }
    
    // Also disable any scroll-based loading
    const infiniteScrollScripts = document.querySelectorAll('script[src*="infinite"], script[src*="load-more"]');
    infiniteScrollScripts.forEach(script => {
        script.remove();
    });
}


document.addEventListener('DOMContentLoaded', function() {
    const openBtn = document.getElementById('open-mobile-filter');
    if (openBtn) {
        openBtn.addEventListener('click', function(e) {
            console.log('Modal trigger clicked! via collection-native.js');
            // Wait for modal to render (adjust delay if needed)
            setTimeout(() => {
                const filterModal = document.querySelector('.plp-filters.js-plp-filters');
                if (filterModal) {
                    // Select sort-by radios inside the modal
                    const sortByRadios = filterModal.querySelectorAll('input[type="radio"][name="sort_by"]');
                    sortByRadios.forEach(radio => {
                        radio.onchange = null;
                        radio.addEventListener('change', function() {
                            // Wait for the DOM to update after filter change
                            setTimeout(() => {
                                const filterModal = document.querySelector('.plp-filters.js-plp-filters');
                                const applyBtn = document.getElementById('apply-mobile-filter');
                                const groupCards = document.querySelectorAll('.product-card-wrapper.group');
                                // Remove any previous custom button
                                const existingCustomBtn = filterModal.querySelector('.custom-mobile-filter-btn');
                                if (existingCustomBtn) existingCustomBtn.remove();

                                if (groupCards.length > 0) {
                                    // Hide the default apply button and create the custom one
                                    if (applyBtn) applyBtn.style.display = 'none';
                                    const customBtn = document.createElement('button');
                                    customBtn.type = 'button';
                                    customBtn.className = 'custom-mobile-filter-btn js-mobile-filter-btn';
                                    customBtn.textContent = applyBtn.textContent || (window.themeStrings && window.themeStrings.applyFilters) || '';
                                    applyBtn.parentNode.insertBefore(customBtn, applyBtn.nextSibling);

                                    customBtn.addEventListener('click', function(ev) {
                                        ev.preventDefault();
                                        ev.stopImmediatePropagation();
                                        const checkedRadio = filterModal.querySelector('input[type="radio"][name="sort_by"]:checked');
                                        const closeBtn = filterModal.querySelector('.js-close-mobile-filters');
                                        if (closeBtn) closeBtn.click();
                                        applyBtn.style.display = '';
                                        customBtn.remove();
                                        setTimeout(function() {
                                            if (checkedRadio) window.sortAndRenderSafe(checkedRadio.value);
                                        }, 200);
                                    });
                                } else {
                                    // Show the default apply button
                                    if (applyBtn) applyBtn.style.display = '';
                                }
                            }, 200); // Adjust delay as needed
                        });
                    });
                }
            }, 100);
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const groupedContainer = document.querySelector('.plp-products.grouped');
        const groupCards = groupedContainer ? groupedContainer.querySelectorAll('.product-card-wrapper.group') : [];
        console.log('[group debug] Grouped container exists:', !!groupedContainer);
        console.log('[group debug] Number of group cards:', groupCards.length);
        if (groupCards.length > 0) {
            console.log('[group debug] Custom sort-by should be active.');
        } else {
            console.log('[group debug] No group cards, default sort-by should be active.');
        }
    }, 300); // Adjust delay as needed for your theme
});

document.addEventListener('DOMContentLoaded', function() {
  const groupedContainer = document.querySelector('.plp-products.grouped');
  const groupCards = groupedContainer ? groupedContainer.querySelectorAll('.product-card-wrapper.group') : [];
  const sortByForm = document.getElementById('SortByForm');
  const sortBy = document.getElementById('sort-by');
  if (!sortByForm || !sortBy) return;

  // Remove any previous event listeners
  sortByForm.onsubmit = null;

  if (groupCards.length > 0) {
    // Intercept form submission for grouped products
    sortByForm.addEventListener('submit', function(e) {
      e.preventDefault();
      window.sortAndRenderSafe(sortBy.value);
    });
    // Also handle change for accessibility
    sortBy.addEventListener('change', function(e) {
      e.preventDefault();
      window.sortAndRenderSafe(sortBy.value);
    });
  } else {
    // No handler: let the form submit as normal
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const groupedContainer = document.querySelector('.plp-products.grouped');
  const groupCards = groupedContainer ? groupedContainer.querySelectorAll('.product-card-wrapper.group') : [];
  const sortBy = document.getElementById('sort-by');
  if (!sortBy) return;

  // Remove all previous event listeners
  sortBy.replaceWith(sortBy.cloneNode(true));
  const newSortBy = document.getElementById('sort-by');

  if (groupCards.length > 0) {
    // Attach custom handler for grouped products
    newSortBy.addEventListener('change', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.sortAndRenderSafe(newSortBy.value);
    }, true);
    console.log('[group debug] Custom sort-by handler attached.');
  } else {
    // Fallback: reload the page with the selected sort param
    newSortBy.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', newSortBy.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
    console.log('[group debug] No group cards, fallback to URL reload.');
  }
});

document.addEventListener('DOMContentLoaded', function() {
    const groupedContainer = document.querySelector('.plp-products.grouped');
    if (groupedContainer) {
        // Fix all individual filter removal links
        const filterRemoveLinks = document.querySelectorAll('.active-filters__remove-filter');
        filterRemoveLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Get the original URL and remove sort parameters
                const originalUrl = this.getAttribute('href');
                const url = new URL(originalUrl, window.location.origin);
                url.searchParams.delete('sort_by');
                
                // Redirect to the cleaned URL
                window.location.href = url.toString();
            });
        });
    }
});
if (document.getElementById('start-quiz')) {

    var startQuizButton = document.getElementById('start-quiz'),
        brandSearchInput = document.getElementById('search-brand'),
        interstitialOverlay = document.getElementById('car-seat-interstitial-overlay'),
        messageButton = document.getElementById('car-seat-message-button'),
        backButton = document.querySelector('.breadcrumb__back'),
        closeQuizButton = document.querySelector('.breadcrumb__close'),
        quizContainer = document.querySelector('.car-seat-checker__container'),
        containerElement = document.querySelector('.car-seat-checker__container'),
        fitChecker = document.querySelector('.fit-checker'),
        carSeatPages = document.querySelectorAll('.car-seat-page'),
        messageOverlay = document.getElementById('car-seat-message-overlay'),
        pageNumberElement = document.getElementById('page-number'),
        familyTitle = document.getElementById('family-header').getElementsByClassName('family-details')[0],
        familyDescription = document.getElementById('family-description'),
        familyButton = document.getElementById('family-buy-button');


// HM: All the event listeners from elements that should remain static
    startQuizButton.addEventListener('click', function () {
        viewHelpers.toggleQuizOpen();
    });

    messageButton.addEventListener('click', function () {
        window.location.href = this.dataset.href;
    })

    brandSearchInput.addEventListener('keyup', function (e) {
        var brandsArray = model.brands;
        var brandsArray = model.brands.filter(function (brand) {
            return brand && brand.trim() !== "";
          });
        var searchTerm = this.value.toLowerCase();
        if (this.value === "") {
            filteredBrandsArray = brandsArray
        } else {
            var filteredBrandsArray = brandsArray.filter(function (brand) {
                return brand.toLowerCase().indexOf(searchTerm) !== -1;
            });
        }
        document.querySelector(pageDetails[1].contentContainer).innerHTML = "";
        for (var i = 0; i < filteredBrandsArray.length; i++) {
            viewHelpers.outputButtons(pageDetails[1].contentContainer, filteredBrandsArray[i], 3);
        }
    })

    backButton.addEventListener('click', function () {
        var newPage = parseInt(pageNumberElement.dataset.pageNumber) - 1;
        // HM todo: For now if the user clicks back on the first page just close the quiz
        if (newPage > 0) {
            changePage(newPage, true);
        } else {
            viewHelpers.toggleQuizOpen();
        }
    });

    closeQuizButton.addEventListener('click', function () {
        viewHelpers.toggleQuizOpen();
    });

}

// HM: Just attempting to keep HTML strings and class changes here while helper naming gives the main description
var viewHelpers = {
    toggleTarget: function (target) {
        if (target.classList.contains('active')) {
            target.classList.remove('active')
        } else {
            target.classList.add('active')
        }
    },
    closeTarget: function (target) {
        if (target.classList.contains('active')) {
            target.classList.remove('active')
        }
    },
    openTarget: function (target) {
        if (!target.classList.contains('active')) {
            target.classList.add('active')
        }
    },
    toggleMessageOpen: function () {
        // HM todo: Uses class to check state, brittle and could be improved with standard event listener pattern
        if (!messageOverlay.classList.contains('active')) {
            messageOverlay.addEventListener('click', viewHelpers.toggleMessageOpen);
        } else {
            messageOverlay.removeEventListener('click', viewHelpers.toggleMessageOpen);
        }
        viewHelpers.toggleTarget(messageOverlay);
    },
    toggleQuizOpen:
        function () {
            if (!quizContainer.classList.contains('active')) {
                quizContainer.classList.add('active');
                // HM: Fixed body for modal taken from CSS-Tricks https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
                // When the modal is shown, we want a fixed body
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
            } else {
                quizContainer.classList.remove('active');
                var scrollY = document.body.style.top;
                // When the modal is hidden...
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        },
    makePageActive: function (targetPage, pageNumber) {
        // HM: A lot of the logic is couple to a page array pageDetails, zero indexing the page number
        var pageDetailsArrayNum = pageNumber - 1;

        for (let i = 0; i < carSeatPages.length; i++) {
            // HM: Just remove the active class from all pages before assigning the new one
            if (carSeatPages[i].classList.contains('active')) {
                carSeatPages[i].classList.remove('active');
            }
            targetPage.classList.add('active');
            // HM: Could be more easily maintained with an array of values derived from pageDetails but think this needs ES6
            containerElement.classList.remove('pink', 'orange', 'turquoise', 'green', 'yellow');
            containerElement.classList.add(pageDetails[pageDetailsArrayNum].colour);
            // HM: Maintain the page number state in a data attribute
            pageNumberElement.dataset.pageNumber = pageNumber;
            pageNumberElement.textContent = pageNumber;
        }
    },
    outputButtons: function (containerClass, dataValue, pageTarget) {
        var buttonContainer = document.querySelector(containerClass),
            buttonHtml = '<button class="btn btn-car-seat" onclick="contentHandlers.loadPage(' + pageTarget + ', false, this)" data-carseat-checker-value="' + dataValue + '">' + dataValue + '</button>';
        buttonContainer.insertAdjacentHTML('beforeend', buttonHtml);
    },
    outputFamily: function (data) {
        const foundBlock = sectionBlocks.find((item) => item.collection === data.family)
        if (foundBlock !== undefined && foundBlock.is_disabled || data.price === null) {
            return null;
        }
        // HM todo: Simplified version of Shopify handleize and string concatenation below relies on empty strings not creating new lines
        var bulletArray = [];
        var hasLiquidImage = "img-not-uploaded";
        /* HM: We try and match this modified family string to a text field in the customiser.
        Both the tag and text field could be entered incorrectly.
        Lower case and stripping white space from tag and field increases the chances of them matching in this case.
        */
        var hasObjWithHandle = slate.utils.findInstance(sectionBlocks, 'collection', data.family);
        if (hasObjWithHandle) {
            data.image = hasObjWithHandle.image || data.image;
            hasLiquidImage = hasObjWithHandle.image ? 'img-upload' : "";
            var bullet1 = hasObjWithHandle.bullet_1 ? '<li>' + hasObjWithHandle.bullet_1 + '</li>' : "";
            var bullet2 = hasObjWithHandle.bullet_2 ? '<li>' + hasObjWithHandle.bullet_2 + '</li>' : "";
            var bullet3 = hasObjWithHandle.bullet_3 ? '<li>' + hasObjWithHandle.bullet_3 + '</li>' : "";
            var bullet4 = hasObjWithHandle.bullet_4 ? '<li>' + hasObjWithHandle.bullet_4 + '</li>' : "";
            bulletArray = [bullet1, bullet2, bullet3, bullet4];
        }

        var productHTML = "";
        productHTML += '<div class="result-cell swiper-slide">';
        if (data.image != null) {
            productHTML += '<div class="result-cell__image ' + hasLiquidImage + '"><img src="' + slate.Image.getSizedImageUrl(data.image, 'x300') + '" srcset="' + slate.Image.getSizedImageUrl(data.image, 'x300') + ' 1x,' + slate.Image.getSizedImageUrl(data.image, 'x600') + ' 2x" alt="' + data.title + '"></div>';
        } else {
            productHTML += '<div class="result-cell__image ' + hasLiquidImage + '">' + svgPlaceholder + '</div>';
        }
        productHTML += '<h4 class="result-cell__family">' + data.family + '</h4>';
        // HM todo: Quick fix to check for unwanted return data, fix source
        var validGroups = ["Group 0",
            "Group 0+",
            "Group 0+ /1",
            "Group 0+123",
            "Group 1",
            "Groups 1",
            "Group 123",
            "Group 2 / 3",
            "Group 2",
            "Group 3"];

        var hasValidGroup;
        for (var i = 0; i < validGroups.length; i++) {
            if (data.group === validGroups[i]) {
                hasValidGroup = true;
            }
        }

        if (hasValidGroup) {
            productHTML += '<p class="group">' + data.group + '</p>';
        }

        // HM: Check to make sure some of the bullet points contain text
        var contentBullets = bulletArray.filter(function (bullet) {
            return bullet !== "";
        })
        if (contentBullets.length > 0) {
            productHTML += '<ul class="result-cell__bullets">';
            for (var i = 0; i < contentBullets.length; i++) {
                productHTML += contentBullets[i];
            }
            productHTML += '</ul>';
        }
        productHTML += '<p>From: ' + slate.Currency.formatMoney(data.price, theme.moneyFormat) + '</p>';
        productHTML += '<button class="btn btn-primary" onclick="contentHandlers.loadPage(6, false, this)" data-carseat-checker-value="' + data.family + '">' + theme.strings.seeHowItFits + '</button>';
        productHTML += '</div>';
        return productHTML;
    },
    outputFitCell: function (installationInfo, seatImageUrl, seatImageAlt, fiveOrSevenSeater) {
        // HM todo: Fat function, add more methods to viewHelper
        var fitClass, fitInfo, fitPosition;
        var fitCarousel = document.querySelector(pageDetails[5].contentContainer);
        // HM: If seat doesn't have a fit show red dot class

        var fitHtml = '<div class="fit-checker-cell ' + fiveOrSevenSeater + '">'
        fitHtml += '<div class="fit-checker-image"><img class="img-full" src="' + seatImageUrl + '" alt="' + seatImageAlt + '">';

        for (var x = 0; x < installationInfo.length; x++) {
            fitClass = installationInfo[x].installation ? "active" : "no-fit";
            fitInfo = installationInfo[x].installation ? installationInfo[x].installation : "Does not fit this seat";
            fitPosition = installationInfo[x].seatClass;
            fitHtml += '<div class="fit-dot ' + fitPosition + ' ' + fitClass + ' ' + fiveOrSevenSeater + '" data-seat="' + installationInfo[x].seat + '" data-installation="' + fitInfo + '"></div>'
        }
        fitHtml += '</div>'

        for (var y = 0; y < installationInfo.length; y++) {
            fitInfo = installationInfo[y].installation ? installationInfo[y].installation : "Does not fit this seat";
            fitHtml += '<div class="fit-checker-extra-info"><strong>' + installationInfo[y].seat + ':</strong> ' + fitInfo + '</div>';
        }

        fitHtml += '<div class="fit-checker-modal"><strong id="fit-modal-seat-text"></strong>: <span id="fit-modal-text"></span></div>'
        fitHtml += '</div>'

        fitCarousel.insertAdjacentHTML('beforeend', fitHtml);

        var modalSeatText = document.getElementById('fit-modal-seat-text'),
            modalText = document.getElementById('fit-modal-text');

        fitChecker.addEventListener('click', function (e) {
            if (e.target.classList.contains('fit-dot') && !fitChecker.querySelector('.fit-checker-modal').classList.contains('active')) {
                modalSeatText.textContent = e.target.dataset.seat;
                modalText.textContent = e.target.dataset.installation;
                viewHelpers.openTarget(fitChecker.querySelector('.fit-checker-modal'));

            } else if (e.target.classList.contains('fit-dot') && fitChecker.querySelector('.fit-checker-modal').classList.contains('active')) {
                modalSeatText.textContent = e.target.dataset.seat;
                modalText.textContent = e.target.dataset.installation;
            } else {
                viewHelpers.closeTarget(fitChecker.querySelector('.fit-checker-modal'));
            }
        })
    },
    destroyContent: function (pageToStartDestroyingFrom, pageToDestroy) {
        if (pageToStartDestroyingFrom > 2 && pageToDestroy.swiper) {
            pageToDestroy.swiper.destroy(true, true);
            pageToDestroy.swiper = undefined;
        }
        try {
            clearNode = document.querySelector(pageToDestroy.contentContainer);
            clearNode.innerHTML = "";
        } catch (error) {
            console.log('Could not destroy object');
        }
    }
}

var contentHandlers = {
    loadPage: function (pageNumber, goingBack, elm, valueOverride) {
        if (goingBack != true) {
            try {
                return this.fetchContent(pageNumber, elm, valueOverride)
                    .then(function () {
                        viewHelpers.openTarget(interstitialOverlay);
                        changePage(pageNumber, goingBack);
                    })
                    .catch(function (error) {
                        viewHelpers.toggleMessageOpen();
                    });
            } catch (error) {
                viewHelpers.toggleMessageOpen();
            }
        } else {
            changePage(pageNumber, goingBack);
        }
    },
    fetchContent: function (stepNumber, elm, value) {
        if (elm == undefined) {
            console.log('Error - 2');
            viewHelpers.toggleMessageOpen();
        } else {
            if (elm.dataset != undefined || value != undefined) {
                if (value != undefined) {
                    var optionValue = value;
                } else {
                    var optionValue = elm.dataset.carseatCheckerValue;
                }

                switch (stepNumber) {
                    case 2:
                        carSeatChecker.setAgeGroup(optionValue);
                        var apiPromise = carSeatChecker.fetchMakes()
                            .then(function (brandData) {
                                model.brands = brandData;
                                contentHandlers.setPersistentData(stepNumber, optionValue);
                            });
                        break;
                    case 3:
                        var apiPromise = carSeatChecker.setMake(optionValue)
                            .fetchModels()
                            .then(function (modelData) {
                                new Promise(function (resolve) {
                                    model.models = modelData;
                                    contentHandlers.setPersistentData(stepNumber, optionValue);
                                    resolve();
                                });
                            });
                        break
                    case 4:
                        var apiPromise = carSeatChecker.setModel(optionValue)
                            .fetchCars()
                            .then(function (carData) {
                                model.types = carData;
                                console.log(model.types)
                                contentHandlers.setPersistentData(stepNumber, optionValue);
                            });
                        break
                    case 5:
                        var apiPromise = carSeatChecker.setCar(optionValue)
                            .fetchSeatOptions();

                        apiPromise = carSeatChecker
                            .search()
                            .then(function (data) {
                                model.families = [];
                                data.forEach((seat) => {
                                    if (familyDetails[seat.family] == undefined) {
                                        familyDetails[seat.family] = {
                                            title: seat.family,
                                            group: seat.collection,
                                        }
                                    }
                                    model.families.push({
                                        image: seat.image_url,
                                        family: seat.family,
                                        group: seat.collection,
                                        price: seat.min_price,
                                    })
                                })

                                contentHandlers.setPersistentData(stepNumber, optionValue)
                            });
                        break
                    case 6:
                        var details = familyDetails[optionValue]
                        familyTitle.innerHTML = details.title;
                        familyButton.innerHTML = theme.strings.shop + ' ' + details.title;

                        var hasObjWithHandle = slate.utils.findInstance(sectionBlocks, 'collection', details.title);
                        // HM: Could do with sources of default content rather than relying on so many conditionals to make sure everything has a value
                        if (hasObjWithHandle) {
                            if (hasObjWithHandle.description) {
                                familyDescription.innerHTML = "";
                                familyDescription.insertAdjacentHTML('afterbegin', hasObjWithHandle.description);
                            }
                            if (hasObjWithHandle.url) {
                                familyButton.addEventListener('click', function () {
                                    window.location.href = hasObjWithHandle.url;
                                })
                            } else {
                                familyButton.addEventListener('click', function () {
                                    window.location.href = '/collections/car-seats';
                                })
                            }
                        } else {
                            familyButton.addEventListener('click', function () {
                                window.location.href = '/collections/car-seats';
                            })
                        }

                        var apiPromise = new Promise(function (resolve, reject) {
                            var ageGroup = carSeatChecker.ageGroup;
                            if (ageGroup == 'child') {
                                var fitData = carSeatChecker.createFitData(optionValue, 2);
                            } else if (ageGroup == 'toddler') {
                                var fitData = carSeatChecker.createFitData(optionValue, 1);
                            } else {
                                var fitData = carSeatChecker.createFitData(optionValue, 0);
                            }
                            model.fits = fitData;

                            resolve(fitData);
                        });
                        break
                    default:
                        console.log('ERROR S-404');
                        viewHelpers.toggleMessageOpen();
                        return;
                }
                return apiPromise
            } else {
                console.log('ERROR S-MISSING');
                viewHelpers.toggleMessageOpen();
            }
        }
    },
    setPersistentData: function (stepNumber, value) {
        try {
            if (typeof (Storage) !== "undefined") {
                if (localStorage.carSeatData == undefined) {
                    var carSeatData = {};
                    carSeatData.options = {};
                } else {
                    var carSeatData = JSON.parse(localStorage.carSeatData);
                }
                var carSeatData
                carSeatData.model = model;
                carSeatData.lastStep = stepNumber;
                carSeatData.options[stepNumber] = value;
                localStorage.carSeatData = JSON.stringify(carSeatData);
            } else {
                return false;
            }
        } catch (error) {
            localStorage.removeItem('carSeatData');
        }
    },
    loadStoredValues: function () {
        try {
            if (typeof (Storage) !== "undefined") {
                if (localStorage.carSeatData != undefined) {
                    var carSeatData = JSON.parse(localStorage.carSeatData);
                    model = carSeatData.model;
                    var optionData = carSeatData.options;
                    for (var stepNo in optionData) {
                        switch (parseInt(stepNo)) {
                            case 2:
                                carSeatChecker.setAgeGroup(optionData[stepNo]);
                                if (stepNo < carSeatData.lastStep) {
                                    addButtons(model.brands, 1, 3, false);
                                }
                                break;
                            case 3:
                                console.log('Setting make')
                                carSeatChecker.setMake(optionData[stepNo]);
                                if (stepNo < carSeatData.lastStep) {
                                    addButtons(model.models, 2, 4, "model");
                                }
                                break;
                            case 4:
                                carSeatChecker.setModel(optionData[stepNo]);
                                if (carSeatData.lastStep < 4) {
                                    addButtons(model.types, 3, 5, "car");
                                }
                                break;
                            case 5:
                                carSeatData.lastStep = 4
                                break;
                            case 6:
                                carSeatData.lastStep = 4;
                                break;
                        }
                    }
                    contentHandlers.loadPage(
                        carSeatData.lastStep,
                        false,
                        false,
                        optionData[carSeatData.lastStep]
                    );
                }
            }
        } catch (error) {
            // PASS - CANNOT LOAD PERSISTENCE
        }
    }
}

// JB NOTE: Wrapped this into a new method that handles fetching the data before changing page.
function changePage(pageNumber, goingBack) {
    var targetPage = document.getElementById('car-seat-page-' + pageNumber);
    viewHelpers.makePageActive(targetPage, pageNumber);

    if (goingBack !== true) {
        // HM: Once data fetched successfully disable overlay and change page
        viewHelpers.closeTarget(interstitialOverlay);

        switch (pageNumber) {
            case 2:
                addButtons(model.brands, 1, 3, false);
                break;
            case 3:
                addButtons(model.models, 2, 4, "model");
                break;
            case 4:
                addButtons(model.types, 3, 5, "car");
                break;
            case 5:
                addResults();
                break;
            case 6:
                addFit();
                break;
        }
    } else if (goingBack === true) {
        // HM: Start at the page your on, ie the page you're going back to +1. Destroy content in pages above that
        var startPage = pageNumber, clearNode;
        for (startPage; startPage < pageDetails.length; startPage++) {
            viewHelpers.destroyContent(startPage, pageDetails[startPage]);
        }
    }
}

function addButtons(inputData, renderPage, targetPage, nestedValueToRetrieve) {
    // HM: The brands are a flat array but otherwise it's an array of objects but typically we only want one value
    if (nestedValueToRetrieve) {
        valueArray = inputData.map(function (obj) {
            return obj[nestedValueToRetrieve];
        });
    } else {
        valueArray = inputData;
    }
    for (var i = 0; i < valueArray.length; i++) {
        viewHelpers.outputButtons(pageDetails[renderPage].contentContainer, valueArray[i], targetPage);
    }
}

function addResults() {
    var resultCarousel = document.querySelector(pageDetails[4].contentContainer);
    resultCarousel.classList.add('hide');

    if (model.families.length > 0) {
        resultCarousel.classList.add('swiper');
        resultCarousel.innerHTML = '<div class="swiper-wrapper"></div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div>';
        var wrapper = resultCarousel.querySelector('.swiper-wrapper');

        for (var i = 0; i < model.families.length; i++) {
            var carouselCell = viewHelpers.outputFamily(model.families[i]);
            if (carouselCell !== null) {
                wrapper.insertAdjacentHTML('beforeend', carouselCell);
            }
        }
        resultCarousel.classList.remove('hide');

        pageDetails[4].swiper = new Swiper(resultCarousel, {
            slidesPerView: 'auto',
            watchOverflow: true,
            navigation: {
                prevEl: resultCarousel.querySelector('.swiper-button-prev'),
                nextEl: resultCarousel.querySelector('.swiper-button-next')
            }
        });
    } else {
        viewHelpers.toggleMessageOpen();
    }
}

function addFit() {
    var seatImageUrl, seatImageAlt, howManySeats, howManySeatsClassName;
    // HM: Relies on the array model.fits array always being the same length, but we figure out if a car is 6, 8 or one
    // of the seven seat configurations by adding the value of the indexes
    var middleSeatExists = [];
    var hasInstallationInfo = model.fits.filter(function (fitting, index) {
        if (fitting.installation !== null) {
            middleSeatExists.push(index);
            return true;
        }
    });

    // HM: Not strictly necessary but if some of there is ever missing in the first four seat fit values this should be
    // a better method than just relying on non-null returned values from the source data. 5 seaters are largely more important than the other cars
    var hasMoreThan5Seats = hasInstallationInfo.filter(function (filteredFitting) {
        return filteredFitting.row > 2;
    });

    var middleSeatValue = middleSeatExists.reduce(function (accumulator, value) {
        return accumulator + value;
    });


    // HM: Values below passed as declaration within liquid section file with name that matches this script
    if (hasMoreThan5Seats.length <= 0) {
        seatImageUrl = carSeatImages.seat5;
        seatImageAlt = carSeatImages.seat5alt;
        howManySeatsClassName = "five-seater";
    } else {
        // HM: The values of all the added array indexes should total 21 and just take away the index value of the seat that's missing
        switch (middleSeatValue) {
            case 14:
                seatImageUrl = carSeatImages.seat6;
                seatImageAlt = carSeatImages.seat6alt;
                howManySeatsClassName = "six-seater";
                break;
            case 16:
                seatImageUrl = carSeatImages.seat3Middle7;
                seatImageAlt = carSeatImages.seat3Middle7alt;
                howManySeatsClassName = "seven-seater-middle";
                break;
            case 19:
                seatImageUrl = carSeatImages.seat7;
                seatImageAlt = carSeatImages.seat7alt;
                howManySeatsClassName = "seven-seater";
                break;
            case 21:
                seatImageUrl = carSeatImages.seat8;
                seatImageAlt = carSeatImages.seat8alt;
                howManySeatsClassName = "eight-seater";
                break;
        }
    }

    console.log('Run addFit');
    viewHelpers.outputFitCell(hasInstallationInfo, seatImageUrl, seatImageAlt, howManySeatsClassName);
}


//JB: Created this in order to have a family name property that references to titles and subgroups. Is currently dynamically  populated but will allow for override if needed.
var familyDetails = {};

// Models structure for populating page data. Will be populated upon user selections, page load and persistent data load.
var model = {
    brands: undefined,
    models: undefined,
    types: undefined,
    families: undefined,
    fits: undefined,
    redirectLink: undefined
}

// HM: Coupled precisely with corresponding HTML elements but don't think we're expanding things enormously and if we do it's not too hard to rewrite this
var pageDetails = [
    {
        id: 'car-seat-page-1',
        colour: 'orange',
        number: '1',
        contentContainer: null
    },
    {
        id: 'car-seat-page-2',
        colour: 'green',
        number: '2',
        contentContainer: '.brand-button-container'
    },
    {
        id: 'car-seat-page-3',
        colour: 'pink',
        number: '3',
        contentContainer: '.model-button-container'
    },
    {
        id: 'car-seat-page-4',
        colour: 'yellow',
        number: '4',
        contentContainer: '.type-button-container'
    },
    {
        id: 'car-seat-page-5',
        colour: 'turquoise',
        number: '5',
        contentContainer: '.result-carousel',
        swiper: undefined
    },
    {
        id: 'car-seat-page-6',
        colour: 'orange',
        number: '6',
        contentContainer: '.fit-checker',
        swiper: undefined
    }
];

var carSeatChecker = carSeatSearch();
(function () {
    if (document.getElementById('start-quiz')) {
        contentHandlers.loadStoredValues();
        carSeatChecker.fetchMakes()
            .then(function () {
                model.brands = carSeatChecker.makes.filter(function (brand) {
                    return brand && brand.trim() !== "";
                });
            });
    }
})()
function stockistsReadMore() {
    var readmoreBtn = $('.page-link-list__more'),
        collectionDescription = $('.page-link-list__list'),
        collectionDescriptionHeight = collectionDescription.outerHeight();

    readmoreBtn.off('click').on('click', function (e) {

        if (readmoreBtn.hasClass('active')) {

            collectionDescription.removeClass('active');

            collectionDescription.animate({
                height: collectionDescriptionHeight
            }, 1000, function () {
                readmoreBtn.removeClass('active');
            });

            readmoreBtn.text('See More');

        } else {

            collectionDescription.addClass('active');

            collectionDescription.animate({
                height: collectionDescription.get(0).scrollHeight
            }, 1000, function () {
                $(this).height('auto');
                readmoreBtn.addClass('active');
            });

            readmoreBtn.text('See Less');

        }

    });
}

if ($('.page-link-list__more').length > 0) {
    stockistsReadMore();
}
function quickviewVariant() {
	var variants = $('.product-quickview-frame .swatch-element'),
		variantInput = $('.product-quickview-frame .product-variant-id');

	$(variants).click(function(){
		var variantID = $(this).attr('data-variant-id');
		$(variants).removeClass('active');
		$(this).addClass('active');

		$(variantInput).attr('value',variantID);
	});

}

function quickviewSlick() {
	$('.product-quickview-frame .product-detail-images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots:true,
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow,
		arrows: true,
		fade: true,
	});
}

function quickviewAddToBasket() {
	$('.product-quickview-frame .btn-add-to-cart').click(function(){
		
		$('.product-quickview-frame form').submit(function (e) {
			e.preventDefault();
			addToCart($(this));
		});

		setTimeout(function() {
			$('.product-quickview-frame').removeClass('active');
			$('.product-quickview-overlay').removeClass('active');
			$('.product-quickview-frame .product-frame').html('');
		}, 2500);
	});
	
}

function quickView() {

	var quickViewBtn = $('.product-quickview .btn'),
		quickViewFrame = $('.product-quickview-frame'),
		quickViewOverlay = $('.product-quickview-overlay'),
		quickViewClose = $('.product-quickview-frame .frame-close'),
		quickViewProduct = $('.product-quickview-frame .product-frame');

	$(quickViewBtn).on( "click", function() {
		var productURL = $(this).attr('data-product-url'),
			productAvailability = $(this).attr('data-product-availability');

			console.log(productAvailability);

		quickViewFrame.addClass('active');
		quickViewOverlay.addClass('active');
		$('html,body').addClass('quickview-open');

		$.ajax({
			type: 'GET',
			url: productURL + '.json',
			dataType: 'json',
			success: function (data) {

				console.log(data);

				//if compare price (sale price) is available
				var productComparePrice = '';
				if (data.product.variants[0].compare_at_price > data.product.variants[0].price ) {
					productComparePrice = '<span class="product-price-original"><span class="money">' + data.product.variants[0].compare_at_price + '</span></span>';
				}


				//get product variants
				// var productVariants = '';
				// console.log(data.product.options.values);
				// console.log('yup');
				// $.each(data.product.options.values, function (i, variant) {
				// 	console.log('test' +vairant);
				// });

				//get product options (variant names)
				var productOptions = '';
				$.each(data.product.options, function (i, option) {
					
					//get product variants
					var productVariants = ''
					//loop through each variant
					$.each(option.values, function(i,variant) {

						var firstItem = '';
						if (i == 0) {
							firstItem = 'active';
						}

						productVariants += '<div data-value="'+ data.product.variants[i].title+'" data-variant-id="'+data.product.variants[i].id+'" class="swatch-element '+firstItem+'">'+data.product.variants[i].title+'</div>';
					});

					productOptions += '<div class="swatch swatch-'+option.name.toLowerCase()+'">' +
										'<div class="swatch-header">' +
											'Select a ' + option.name + '' +
										'</div>' +
										productVariants +	
									  '</div>'
				});

			
				//get images for products
				var quickviewImages = '';
				$.each(data.product.images, function (i, image) {
					quickviewImages += '<div class="product-image"><img src="'+ image.src +'" class="img-fluid" alt="'+ data.product.title +'"></div>';
				});

				//if product is available, show the available button, if product is sold out, show the sold out option.
				var addToCartButton = '';
				addToCartButton = '<button type="submit" name="add" data-add-to-cart="" class="btn-add-to-cart btn btn-primary mt-3 variant-available"><span data-add-to-cart-text="">Add to Basket</span></button>'; 

				//Build Markup output
				var quickviewHTML = '<div class="container product-detail-container quickview-product-details">' +
					'<div class="row align-items-center">' +
					'<div class="col-12 mb-3 mb-md-0">' +
						'<div class="product-detail-images">' +
						quickviewImages + 
						'</div>' +  
					'</div><!-- Col - Image -->' +

					'<div class="col-12">' +
						'<h1 class="product-title text-center"><a href="/products/'+ data.product.handle+'">'+ data.product.title +'</a></h1>' + 
						'<div class="row align-items-sm-center text-center">' +
						'<div class="col-12">' + 
							'<div class="product-detail-price-wrapper">' +
							'<span class="product-detail-price">' +
								'<span class="money">'+ data.product.variants[0].price + '</span>' +
							'</span>' +
							productComparePrice +
							'<form method="post" action="/cart/add">' +
							'<input min="1" type="number" id="quantity" name="quantity" value="1" class="d-none" />' +
								productOptions +
							'<input type="hidden" name="id" class="product-variant-id" value="'+ data.product.variants[0].id + '" />' +	
							addToCartButton +	
							'</form>' +
							'<a class="d-block text-align-center mt-3" href="/products/'+data.product.handle+'">More details</a>' + 
						'</div><!-- col -->' +	
						'</div><!-- row -->' +
					'</div><!-- Col - Details -->' +

					'</div><!-- row -->' +
					'</div><!-- container -->';

					quickViewProduct.html(quickviewHTML);
					quickviewSlick();
					quickviewVariant();
					quickviewAddToBasket();
			}
		});

	});

	$(quickViewClose).click(function(){
		quickViewFrame.removeClass('active');
		quickViewOverlay.removeClass('active');
		quickViewProduct.html('');
		$('html,body').removeClass('quickview-open');
	});
}

quickView();
/**
 * Velstar Ajaxify Cart
 **/
var config = {

    /* Langauge */
    addToCartBtnText: theme.strings.addToCart, //Add to Basket
    addedToCartBtnText: theme.strings.added, //Added to Basket
    addingToCartBtnText: theme.strings.adding, //Adding...
    soldOutBtnText: theme.strings.soldOut, //Sold Out
    //After adding a product to the cart, how long to wait before it returns to normal?
    returnBtnToNormal: 4000, // milliseconds

    /* Selectors */
    cartCountSelector: '.cart-count',
    cartTotalSelector: '.mini-cart-total',
    cartRemoveSelector: '.cart-prod-remove',

    /* Icons*/
    successIcon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
    errorIcon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
    loadingIcon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',

    /* No need to change this elements. */
    addToCartBtnSelector: '.btn-add-to-cart.variant-available',
    addToCartFormSelector: 'form[action="/cart/add"]',
    shopifyAjaxAddURL: '/cart/add.js',
    shopifyAjaxChangeURL: '/cart/change.js',
    shopifyAjaxCartURL: '/cart.js'
}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
    //$('.ajaxfeedback').remove();
    var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

    $addToCartForm.find(config.addToCartBtnSelector).after(feedback);
    $('.ajaxfeedback').slideDown();
}

//Provide the user Feedback if the Ajax was sucessful or not. Modified for mobile optional overlay button
function ajaxFeedbackMobile(status, html, $addToCartForm) {
    //$('.ajaxfeedback').remove();
    var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

    $addToCartForm.after(feedback);
    $('.ajaxfeedback').slideDown();
}

//BG: Provide the user feedback on the cart template when adjusting quantity / variant.
function ajaxFeedbackCart(status, html, output) {
    $('.ajaxFeedbackCart').remove();
    var feedback = '<span class="ajaxFeedbackCart ' + status + '">' + html + '</span>';

    $(output).after(feedback);

    setTimeout(function () {
        $('.ajaxFeedbackCart').fadeOut();
    }, 3000);

}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
    if ($button.children().length) {
        $button.children().each(function () {
            if (icon) {
                if ($.trim($(this).text()) !== '') {
                    $(this).html(label + icon);
                }
            } else {
                if ($.trim($(this).text()) !== '') {
                    $(this).text(label);
                }
            }
        });
    } else {
        $button.val(label).text(label);
    }
}

//BG: Function to update the Cart Dropdown with the newly added product(s)	
function updateMiniCartContents(cartCallback) {

    console.log('inside update minicart');

    //ajax get request to cart.js
    $.ajax({
        type: 'GET',
        url: config.shopifyAjaxCartURL,
        dataType: 'json',
        success: function (data) {

            //Get Cart Total Cost (format it) & Cart Count.
            var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
                cartCount = data.item_count,
                shippingCost = document.querySelector('#basket-sidebar .basket-shipping > .basket-shipping-value'),
                freeShippingValue = theme.freeShippingValue;

            if (data.total_price >= freeShippingValue && shippingCost) {
                shippingCost.textContent = theme.strings.shippingValue;
            } else if (shippingCost) {
                shippingCost.textContent = theme.strings.shippingMessage;
            }

            console.log(cartTotalCost);

            //Output cart total
            $('.basket-total .basket-total-value .money').text(cartTotalCost);
            $(config.cartTotalSelector).text(cartTotalCost);
            $(config.cartCountSelector).text(cartCount);
            if (cartCount > 0) {
                $(config.cartCountSelector).removeClass('no-items');
            } else {
                $(config.cartCountSelector).addClass('no-items');
            }

            //remove all items within cart.
            $('.cart-mini-contents .cart-row .cart-item').remove();

            //with the returned data, focus soley on the items. For each item...
            $.each(data.items, function (i, item) {
                //debugging
                //console.log(item);

                var itemTitle = item.product_title;
                var itemPrice = slate.Currency.formatMoney(item.price, theme.moneyFormat);
                //var itemQuantity = item.quantity;
                //var itemVariant = item.variant_title;
                //var itemVariantId = item.variant_id;
                var itemImage = item.image;
                var itemUrl = item.url;
                var cartHTML;

                //add each product back to mini cart preview. Follows liquid logic to detect if image is missing, typical with Spare Parts
                if (itemImage) {
                    cartHTML = '<div class="cart-item"><div class="cart-prod-img"><a href="' + itemUrl + '"><img src="' + itemImage + '" alt="' + itemTitle + '" class="img-fluid"></a></div><div class="cart-item-detail"><div class="cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><span class="cart-prod-price"><span class="money">' + itemPrice + '</span></span></div></div>';
                } else {
                    cartHTML = '<div class="cart-item"><div class="cart-prod-img"></div><div class="cart-item-detail"><div class="cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><span class="cart-prod-price"><span class="money">' + itemPrice + '</span></span></div></div>';
                }
                $('.cart-mini-contents .cart-row').append(cartHTML);

            });

            //re-trigger the remove functionality.
            removeCartItemTrigger();

            // HM todo: Full cart is present on page and data needs to be used to populate it, refactor with promise rather than callback
            if ($("[data-ajax-basket]").length > 0 && typeof cartCallback !== "undefined") {
                cartCallback(data);
            }
        }
    });
}

function updateCartContents(data) {
    console.log('update cart contents');
    $('#shopify-section-cart .basket-container .basket-item').remove();
    var basket = document.querySelector("#basket-main"),
        imageRatioClass = basket.dataset.imageRatio || "",
        sparesImageURL = basket.dataset.sparesImage,
        placeholderImage = basket.dataset.placeholderImage,
        // HM: Use template rendered in liquid rather than HTML string
        template = document.querySelector('#template-basket-item');
    if ('content' in document.createElement('template')) {
        $.each(data.items, function (i, item) {
            // Clone the template, target it's elements
            var basketItemTemplate = template.content.cloneNode(true),
                basketItem = basketItemTemplate.querySelector(".basket-item"),
                basketItemImageContainer = basketItem.querySelector(".basket-item-image > a"),
                basketItemImage = basketItemImageContainer.querySelector("img"),
                basketItemDetails = basketItem.querySelector(".basket-item-details"),
                basketItemDetailsTitle = basketItemDetails.querySelector(".product-title > a"),
                basketItemDetailsPriceContainer = basketItemDetails.querySelector(".product-price"),
                basketItemDetailsPrice = basketItemDetails.querySelector(".product-price > .money"),
                basketItemDetailsComparePrice = basketItemDetails.querySelector(".product-price-original > .money"),
                basketItemQuantity = basketItem.querySelector(".basket-item-quantity"),
                basketItemQuantityInput = basketItemQuantity.querySelector(".product-quantity"),
                basketItemDetailsRemove = basketItem.querySelector(".basket-item-remove > a");
            $.getJSON(`/products/${item.handle}.js`, function (product) {
                var currentVariant = slate.utils.findInstance(product.variants, "id", item.variant_id);
                if (currentVariant.compare_at_price) {
                    if (currentVariant.compare_at_price > item.price) {
                        basketItemDetailsComparePrice.textContent = slate.Currency.formatMoney(currentVariant.compare_at_price, theme.moneyFormat);
                        basketItemDetailsPriceContainer.classList.add("sale");
                    }
                }
            });
            // HM: Add content & attributes to elements
            basketItem.dataset.variantId = item.variant_id.toString();
            if (imageRatioClass) {
                basketItemImageContainer.classList.add(imageRatioClass);
            }
            basketItemImageContainer.href = item.url;

            if (item.featured_image.url) {
                basketItemImage.src = slate.Image.getSizedImageUrl(item.featured_image.url, "300x");
                basketItemImage.alt = item.featured_image.alt;
                basketItemImage.dataset.aspectratio = item.featured_image.aspect_ratio;
                basketItemImage.width = item.featured_image.width;
                basketItemImage.height = item.featured_image.height;
            } else {
                basketItemImage.src = sparesImageURL || placeholderImage;
                console.error('Failed to find product image')
            }

            basketItemDetailsTitle.url = item.url;
            basketItemDetailsTitle.textContent = item.title;
            basketItemDetailsPrice.textContent = slate.Currency.formatMoney(item.final_price, theme.moneyFormat);
            basketItemQuantity.dataset.variantId = item.variant_id.toString();
            basketItemQuantityInput.value = item.quantity;
            basketItemDetailsRemove.ariaLabel = item.title;
            basketItemDetailsRemove.href = `/cart/change?line=${i + 1}&amp;quantity=0`

            // HM: Append cloned template to basket
            basket.appendChild(basketItemTemplate);
        })
    }
    var totalPrice = document.querySelector('#basket-sidebar .basket-total-value > .money'),
        shippingCost = document.querySelector('#basket-sidebar .basket-shipping > .basket-shipping-value'),
        freeShippingValue = 8500;

        console.log('total price');
        console.log(data.total_price);

        console.log,('total price el');
        console.log(totalPrice);


    totalPrice.textContent = slate.Currency.formatMoney(data.total_price, theme.moneyFormat);

    if (data.total_price > freeShippingValue) {
        shippingCost.textContent = theme.strings.shippingValue;
    } else {
        shippingCost.textContent = theme.strings.shippingMessage;
    }
    cartItemQuantityVariant();
}

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
    //ajax get request to cart.js
    $.ajax({
        type: 'POST',
        url: config.shopifyAjaxChangeURL,
        data: 'quantity=0&id=' + variant_id,
        dataType: 'json',
        success: function (data) {
            //console.log('Remove Item Triggered');
            //Update the cart to reflect new contents.
            updateMiniCartContents();
        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
        }
    });
}

//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id, quantity, old_variant_id) {
    $.ajax({
        type: 'POST',
        url: config.shopifyAjaxAddURL,
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function (data) {
            ajaxFeedbackCart('success', 'Updated size', '.product-title[data-variant-id=' + old_variant_id + '] .cart-product-variant-select');
        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
        }
    });
}

//BG: function can be triggered by Quantity update
function quantityItemChange(variant_id, value, inputElement) {
    console.log('quantityItemChange');
    $.ajax({
        type: 'POST',
        url: config.shopifyAjaxChangeURL,
        data: 'quantity=' + value + '&id=' + variant_id,
        dataType: 'json',
        success: function (data) {
            $.each(data.items, function (index, item) {
                if (variant_id === item.variant_id) {
                    if (item.quantity == value) {
                        ajaxFeedbackCart('success', 'Quantity updated', '.basket-item[data-variant-id=' + variant_id + '] .basket-item-details .product-price');
                        //BG: if the amount has changed, but not to the value the user wanted.
                    } else if (item.quantity < value) {
                        ajaxFeedbackCart('warning', 'Quantity Updated to ' + item.quantity + '. This is the last remaining amount.', '.basket-item[data-variant-id=' + variant_id + '] .basket-item-details .product-price');
                        // HM: If cart items were created by AJAX call then they wont have a max value, there is no client side API for inventory levels and so it's necessary to set the max/value now
                        if (inputElement !== "undefined") {
                            // HM: Seems to be a bug doing this with jQuery where it doesn't updated the visible text content
                            $(inputElement)[0].value = item.quantity;
                            $(inputElement)[0].setAttribute("max", item.quantity);
                        }
                    }
                    return false
                }
            });


            updateMiniCartContents();
        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
        }
    });
}


//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
    //Remove Item from Cart
    $(config.cartRemoveSelector + ' span').off().on("click", function () {
        var varientID = $(this).attr('data-variant-id');

        $(this).parents('.cart-item').slideUp();

        //Pass over to removeItemFromCart Function.
        removeItemFromCart(varientID);

    });
}

function addToCart(form) {
    $('.ajaxfeedback').remove();
    //e.preventDefault();
    var $addToCartForm = form;
    var $addToCartBtns = $('button[data-add-to-cart]')

    //Adding button stage
    $addToCartBtns.each((i, addToCartBtn) => {
        updateBtnText($(addToCartBtn), config.addingToCartBtnText, config.loadingIcon);
        $(addToCartBtn).addClass('btn-adding').prop('disabled', true);
    });

    // Add to cart.
    $.ajax({
        url: config.shopifyAjaxAddURL,
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function () {
            //Added button stage
            $addToCartBtns.each((i, addToCartBtn) => {
                updateBtnText($(addToCartBtn), config.addedToCartBtnText, config.successIcon);
                $(addToCartBtn).removeClass('btn-adding').addClass('btn-added');
            });

            //Once added, reset button back to add.
            $addToCartBtns.each((i, addToCartBtn) => {
                window.setTimeout(function () {
                    $(addToCartBtn).prop('disabled', false).removeClass('btn-added');
                    updateBtnText($(addToCartBtn), config.addToCartBtnText);
                }, config.returnBtnToNormal);
            });

            updateMiniCartContents();

            window.setTimeout(function () {
                //$('.header-basket .cart-icon').addClass('swing animated');
                $('.header-basket').addClass('hover');
                $('.header-basket .cart-mini-contents .cart-header p').text(theme.strings.addedToYourBag);
            }, 1000);

            window.setTimeout(function () {
                $('.header-basket').removeClass('hover');
                //$('.header-basket .cart-icon').removeClass('swing animated');
                $('.header-basket .cart-mini-contents .cart-header p').text(theme.strings.yourBag);
            }, 4000);

        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            if (response.slice(0, 4) === 'All ') {
                ajaxFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                $addToCartBtns.each((i, addToCartBtn) => {
                    $(addToCartBtn).prop('disabled', false);
                    updateBtnText($(addToCartBtn), config.soldOutBtnText);
                    $(addToCartBtn).prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
                });
            } else {
                ajaxFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
                $addToCartBtns.each((i, addToCartBtn) => {
                    $(addToCartBtn).prop('disabled', false).removeClass('disabled');
                    updateBtnText($(addToCartBtn), config.addToCartBtnText);
                });
            }

        }

    });
    return false;
}

function addToCartWithoutForm($addToCartBtn, $container, variantId) {
    if (typeof variantId !== "undefined") {
        $('.ajaxfeedback').remove();

        $addToCartBtns = $('button[data-add-to-cart]')

        //Adding button stage
        $addToCartBtns.each((i, addToCartBtn) => {
            updateBtnText($(addToCartBtn), config.addingToCartBtnText, config.loadingIcon);
            $(addToCartBtn).addClass('btn-adding').prop('disabled', true);
        });

        // Add to cart.
        $.ajax({
            url: config.shopifyAjaxAddURL,
            dataType: 'json',
            type: 'post',
            data: 'quantity=1&id=' + variantId,
            success: function () {

                //Added button stage
                $addToCartBtns.each((i, addToCartBtn) => {
                    updateBtnText($(addToCartBtn), config.addedToCartBtnText, config.successIcon);
                    $(addToCartBtn).removeClass('btn-adding').addClass('btn-added');
                });

                //Once added, reset button back to add.
                $addToCartBtns.each((i, addToCartBtn) => {
                    window.setTimeout(function () {
                        $(addToCartBtn).prop('disabled', false).removeClass('btn-added');
                        updateBtnText($(addToCartBtn), config.addToCartBtnText);
                    }, config.returnBtnToNormal);
                });

                updateMiniCartContents(updateCartContents);

                window.setTimeout(function () {
                    //$('.header-basket .cart-icon').addClass('swing animated');
                    $('.header-basket').addClass('hover');
                    $('.header-basket .cart-mini-contents .cart-header p').text(theme.strings.addedToYourBag);
                }, 1000);

                window.setTimeout(function () {
                    $('.header-basket').removeClass('hover');
                    //$('.header-basket .cart-icon').removeClass('swing animated');
                    $('.header-basket .cart-mini-contents .cart-header p').text(theme.strings.yourBag);
                }, 4000);

            },
            error: function (XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                if (response.slice(0, 4) === 'All ') {
                    ajaxFeedbackMobile('error', response.replace('All 1 ', 'All '), $container);
                    $addToCartBtns.each((i, addToCartBtn) => {
                        $(addToCartBtn).prop('disabled', false);
                        updateBtnText($(addToCartBtn), config.soldOutBtnText);
                        $(addToCartBtn).prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
                    });
                } else {
                    ajaxFeedbackMobile('error', '<i class="fa fa-warning"></i> ' + response, $container);
                    $addToCartBtns.each((i, addToCartBtn) => {
                        $(addToCartBtn).prop('disabled', false).removeClass('disabled');
                        updateBtnText($(addToCartBtn), config.addToCartBtnText);
                    });
                }

            }

        });
    }
    return false;
}

//BG: allows the user to update the quantity on the cart page.
function cartItemQuantityVariant() {
    var cartItem = $('.basket-item');

    cartItem.each(function () {
        var thisCartItem = $(this),
            variantID = parseInt($(this).attr('data-variant-id')),
            quantityField = $(this).find('.product-quantity'),
            quantityIncrease = $(this).find('.btn-increase'),
            quantityDecrease = $(this).find('.btn-decrease'),
            removeProduct = $(this).find('.basket-item-remove > a');

        quantityDecrease.off('click').on('click', function () {
            var quantity = quantityField.val();

            //ensure quantity cannot be less than 1.
            if (quantity > 1) {
                quantity--;
                quantityField.val(quantity);
                quantityItemChange(variantID, quantity);
            } else if (quantity == 1) {
                var confirmDelete = confirm(theme.strings.confirmDelete);

                //If user confirms their delete action, delete the product from their cart.
                if (confirmDelete) {
                    thisCartItem.slideUp();
                    removeItemFromCart(variantID)
                    return false;
                } else {
                    return false;
                }
            }
        });

        quantityIncrease.off('click').on('click', function () {
            var quantity = quantityField.val(),
                maxQuantity = parseInt(quantityField.attr('max'));

            //Ensure quantity cannot be greater than maxQuantity
            if (quantity < maxQuantity) {
                quantity++;
                quantityField.val(quantity);
                console.log('increase quantity');
                quantityItemChange(variantID, quantity, quantityField);
            }
        });

        //on click of remove product
        removeProduct.off('click').on('click', function () {
            var confirmDelete = confirm(theme.strings.confirmDelete);

            //If user confirms their delete action, delete the product from their cart.
            if (confirmDelete) {
                thisCartItem.slideUp();
                removeItemFromCart(variantID)
                return false;
            } else {
                return false;
            }
        });


    });
}

function removeForbiddenTagItems(forbiddenTag = 'pre-order') {
    let itemRemoved = false;
  
    $.getJSON('/cart.js', function(cart) {
      const removalPromises = cart.items.map(item =>
        $.getJSON(`/products/${item.handle}.js`).then(product => {
          if (product.tags.includes(forbiddenTag)) {
            itemRemoved = true;
            return $.post('/cart/change.js', {
              quantity: 0,
              id: item.key
            });
          }
        })
      );
  
      Promise.all(removalPromises).then(() => {
        if (itemRemoved) {
          alert(theme.strings.preorderRemovalAlert);
            $.ajax({
                type: 'GET',
                url: window.location.pathname,
                data: {
                sections: 'cart,header'
                },
                success: function (response) {
                const parsed = typeof response === 'string' ? JSON.parse(response) : response;
                    if (parsed['cart']) {
                    $('#shopify-section-cart').replaceWith(parsed['cart']);
                    cartItemQuantityVariant();
                    }
            
                    if (parsed['header']) {
                    $('#shopify-section-header').replaceWith(parsed['header']);
                    }
                }
            });
        }
      });
    });
  }

$(document).ready(function () {

    const isCartPage = $('body').hasClass('template-cart');
    const hasMiniCartItems = $('.cart-mini-contents .cart-item').length > 0;

    if (isCartPage) {
        //cartItemQuantity();
        //cartItemVariantSize();
        cartItemQuantityVariant();
    }

    if (window.themeSettings && window.themeSettings.preproduct_active === true && window.themeSettings.remove_preorder_products == true) {
        if (isCartPage || hasMiniCartItems) {
            removeForbiddenTagItems();
        }
    }

    removeCartItemTrigger();

    $(config.addToCartFormSelector).submit(function (e) {
        e.preventDefault();
        addToCart($(this));
    });
});
//BG: Grab the recently viewed products array, and loop through the products and output them.
function retrieveRecentlyViewedProducts(array, outputLocation, maxProducts) {

    //if the array is greater than max allowed products, delete the last product from the array.
    if (array.length > maxProducts) {
        array.shift();
    }

    var targetCarousel = $(outputLocation);
    var targetEl = targetCarousel[0];
    if (targetEl && targetEl.swiper) {
        targetEl.swiper.destroy(true, true);
        var existingWrapper = findDirectChildByClass(targetEl, 'swiper-wrapper');
        if (existingWrapper) {
            while (existingWrapper.firstChild) {
                targetEl.insertBefore(existingWrapper.firstChild, existingWrapper);
            }
            targetEl.removeChild(existingWrapper);
        }
    }

    function getProductData(product) {
        return $.ajax({
            type: 'GET',
            url: '/products/' + product,
            dataType: 'json',
            error: function () {
                //BG: This should rarely happen, but if the product is no longer available, we get a json error, so want to remove the product from the array.
                console.log('product not found, but it will be removed from array on next page load')
                var arrayFix = array.indexOf(product);
                if (arrayFix !== -1) {
                    array.splice(arrayFix, 1);
                }
                //BG: Update localStorage
                localStorage.setItem("recentProducts", JSON.stringify(arrayFix));
            },
            success: function (data) {
                outputProduct(data, '.product-carousel');
            }
        });
    }

    var results = [];

    // store the reference to the Ajax feed for later usage
    for (i in array) {
        results.push(getProductData(array[i]));
    }

    $.when.apply(this, results).done(function () {
        var opts = parseJSONAttribute(targetEl, 'data-swiper-options');
        if (opts) {
            opts = normalizeSwiperMarkup(targetEl, opts);
            new Swiper(targetEl, opts);
        }
        // HM: Race condition with script loaded from Shopify
        if (typeof ReloadSmartWishlist !== "undefined") {
            ReloadSmartWishlist();
        }
    })
}

//BG: Add current product to the recently viewed array
function addNewProduct(array, productHandle, maxProducts) {

    //BG: if array is greater than the maxProducts, then delete the first item in the array
    if (array.length > maxProducts) {
        array.shift();
    }

    //BG: only add the product to the array, if it doesn't already exist
    if (array.indexOf(productHandle) == -1 && productHandle != "undefined.js") {
        array.push(productHandle);
    }
    //BG: Update localStorage
    localStorage.setItem("recentProducts", JSON.stringify(array));

}

$(document).ready(function () {
    //Retrieve localstorage for recentproducts(if it exists)
    var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")) || [],
        outputLocation = ".product-carousel .main-carousel",
        productCarousel = $('.product-carousel .main-carousel[data-product-handle]'),
        productCarouselHandle = productCarousel.attr('data-product-handle'),
        maxProducts = 6;

    // HM: Check if on product page by getting product JSON object
    if ($('script[data-product-json]').length > 0) {
        var productJSON = JSON.parse($('script[data-product-json]').text()),
            newProduct = productJSON.handle + ".js";
    }

    // HM: Recently viewed carousel can appear on non-product pages, these will have get as product-handle to prompt fetch only
    if (savedRecentProducts && productCarouselHandle === "get") {
        retrieveRecentlyViewedProducts(savedRecentProducts, outputLocation, maxProducts);
    }
    // HM: Recently viewed carousel used on a product page, get and add to recently viewed products
    else if (savedRecentProducts && productJSON && productCarousel.length > 0) {
        retrieveRecentlyViewedProducts(savedRecentProducts, outputLocation, maxProducts);
        addNewProduct(savedRecentProducts, newProduct, maxProducts);
    }
    // HM: Recently viewed carousel used on a product page, get and add to recently viewed products
    else if (savedRecentProducts && productJSON && productCarousel.length === 0) {
        addNewProduct(savedRecentProducts, newProduct, maxProducts);
    }
    else if (!savedRecentProducts) {
        //First time user has visited a product page, so let's create the new local storage.
        //console.log('doesn\'t exist, let\'s make a new array');
        if (productCarousel.length > 0) {
            // HM: Hide the whole section if the recently viewed carousel is on the page but there's no products to display
            $('.shopify-section.product-carousel').css('display', 'none');
        }
        var recentProducts = [];
        addNewProduct(recentProducts, newProduct, maxProducts);
    }
})
if (document.getElementById('countdown-usp-header')) {
    //Let body know we have the countdown enabled
    document.body.classList.add("countdown-enabled");
    //Product Countdown
    //Countdown function
    function uspCreateTargetDate() {
        var uspCountdownContainerData = document.querySelector('#countdown-usp-container').dataset,
            yy = parseInt(uspCountdownContainerData.countdownYear),
            mo = parseInt(uspCountdownContainerData.countdownMonth),
            dd = parseInt(uspCountdownContainerData.countdownDays),
            hh = parseInt(uspCountdownContainerData.countdownHours),
            mi = parseInt(uspCountdownContainerData.countdownMinutes);

        var lastDay = new Date(yy, mo, 0).getDate(); // Setting day to 0 gives the last day of the current month
        var target = new Date(yy, mo - 1, Math.min(lastDay, dd), hh, mi, 0).getTime();
    
        return target;
    }
    
    var uspTargetDate = uspCreateTargetDate();

    (function () {
        function countdown() {
            var target = uspTargetDate,
                targetElement = document.querySelector('#countdown-usp-header'),
                now = new Date;

            //if greater than target time...
            if (now > target) {
                document.querySelector('.countdown-message').classList.add('d-none');
                document.querySelector('.countdown-message-wrapper').classList.add('d-none');
                document.querySelector('.countdown-message-end').classList.remove('d-none');
            } else {
                var remain = target - now,
                    second = 1000,
                    minute = second * 60,
                    hour = minute * 60,
                    day = hour * 24;

                var dd = Math.floor(remain / day),
                    hh = Math.floor((remain % day) / hour),
                    mm = Math.floor((remain % hour) / minute),
                    ss = Math.floor((remain % minute) / second);

                targetElement.querySelector('[data-days]').innerText = dd;
                targetElement.querySelector('[data-hours]').innerText = hh;
                targetElement.querySelector('[data-minutes]').innerText = mm;
                targetElement.querySelector('[data-seconds]').innerText = ss;

            }
            setTimeout(countdown, 1000);
        }

        document.addEventListener('DOMContentLoaded', countdown);
    })();
}
//End Product Countdown
if ($("a[href='#scrollDown']").length > 0) {
    $("a[href='#scrollDown']").each(function () {
        $(this).click(function (e) {
            e.preventDefault();
            // HM: Find parent Shopify section and select the next one along
            var immediateSiblingToParentSection = $(this).closest('.shopify-section').next(),
                textFeaturesBehaviour = document.querySelector('.header-text-features').dataset.headerBehaviour,
                // HM: If text features are in a fixed position floating with the header then be sure to deduct them from the offset
                heightOfAllHeaderElements = textFeaturesBehaviour !== "floating" ? getHeightOfHeaderElements('header') : getHeightOfHeaderElements('header-text-features'),
                totalOffset = immediateSiblingToParentSection.offset().top - heightOfAllHeaderElements;

            $("html, body").animate({ scrollTop: totalOffset }, "slow");
        })
    });
}
function addNewProductComparison(array, productHandle, storageType) {

    array.push(productHandle);

    localStorage.setItem(storageType, JSON.stringify(array));

    var newProductComparison = JSON.parse(localStorage.getItem(storageType));
    var length = Object.keys(newProductComparison).length;

    //LM: Update Product Detail button text
    $('.product-compare').text('Added to Product Comparison');

    $('.btn-product-compare').css('display','block')

    renderCompare(newProductComparison, '.comparison-table');
}

function addProductCompare() {
    var productHandle = $('.product-compare').attr('data-product-handle')
    productType = $('.product-compare').attr('data-product-type'),
    productTypeLocal = productType += '_compare',
    savedProductComparison = JSON.parse(localStorage.getItem(productTypeLocal)),
    comparisonTableLocal = $('.comparison-table').attr('data-local-storage'),
    tableComparisonCheck = JSON.parse(localStorage.getItem(comparisonTableLocal));

    $('.product-compare, .product-compare-mobile').off().on('click', function(){
        if (savedProductComparison) {
            var length = Object.keys(savedProductComparison).length;
            // If relevant local storage array has 4 or more products then show warning. If not then add product to the array.
            if( length == 4 ) {
                ajaxFeedbackCart('warning','Maxiumum of 4 product for comparison.','.product-compare');
            } else if (jQuery.inArray(productHandle, savedProductComparison) == -1) {
                addNewProductComparison(savedProductComparison, productHandle, productTypeLocal);
            }
        } else {
            // Relevant Local Storage is not available therefore lets add the product to brand new array.
            var productsComparison = [];
            addNewProductComparison(productsComparison, productHandle, productTypeLocal);
        }
    });

    // For Product Page.
    // If Local Storage Array is present.
    if (savedProductComparison) {
        // If product handle is already in array then change wording on comparison button.
        if (jQuery.inArray(productHandle, savedProductComparison) !== -1) {
            $('.product-compare').text('Added to Product Comparison');
        } 
    }

    setUpButtons();
    modalHeight();

    // For Individual Comparison Table pages.
    if(tableComparisonCheck) {
        renderCompare(tableComparisonCheck, '.comparison-table');
    }
}

function renderCompare(array, outputLocation) {
    //if there are products to display, remove the hidden class.
    var template_buffer = '';
    if (array.length > 0) {
        // loop for the array, and output the products.
        $.each(array,function(i, product) {
            $.ajax({
                type: 'GET',
                url: '/products/' + product +'/?view=listing-small',
                success: function (data) {
                    template_buffer += data;
                },
                complete: function() {
                    $(outputLocation).html(template_buffer)
                }
            }); 
        });
    }
}
function renderCompareModal() {
    //if there are products to display, remove the hidden class.
    var comparisonTableLocal = $('.comparison-table').attr('data-local-storage'),
    array = JSON.parse(localStorage.getItem(comparisonTableLocal));
    $('.modal-compare-table td.middle').each(function(){
        $(this).remove()
    })
    if (array.length > 0) {
        // loop for the array, and output the products.
        $.each(array,function(i, product) {
            $.ajax({
                type: 'GET',
                url: '/products/' + product +'/?view=listing',
                success: function (data) {
                    var object = JSON.parse(data)
                    Object.keys(object).forEach(function(key,index) {
                        if(key !== 'image' && key !== 'explore'){
                            $('.modal-compare-table .'+key+' td.first').after(
                                '<td class="middle" data-handle="'+object.handle+'">'+object[key]+'</td>'
                            )
                        }
                        else if(key === 'image'){
                            $('.modal-compare-table .'+key+' td.first').after(
                                '<td class="middle image" data-handle="'+object.handle+'"><div class="close" data-handle="'+object.handle+'"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cross" viewBox="0 0 12 12"><g stroke="#20202B" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M1.572 1L11 10.428M11 1l-9.428 9.428"></path></g></svg></div><img src="'+object[key]+'"></td>'
                            )  
                        }
                        else if(key === 'explore'){
                            $('.modal-compare-table .'+key+' td.first').after(
                                '<td class="middle image" data-handle="'+object.handle+'"><a class="btn btn-primary" href="'+object[key]+'">EXPLORE</a></td>'
                            )  
                        }
                    })
                },
                complete: function() {
                    $('.product-compare-modal').css('display','block');
                    $('body').css('position','fixed');
                    if(array.length < 4){
                        $('.product-compare-modal .last').css('display','table-cell')
                    }
                    else{
                        $('.product-compare-modal .last').css('display','none')
                    }
                    var height = $(window).height() - $('.product-compare-modal').offset().top
                    $('.product-compare-modal').css('height',height+'px')
                }
            }); 
        });
    }else{
        $('.product-compare-modal').css('display','block');
        $('body').css('position','fixed');
        if(array.length < 4){
            $('.product-compare-modal .last').css('display','table-cell')
        }
        else{
            $('.product-compare-modal .last').css('display','none')
        }
        var height = $(window).height() - $('.product-compare-modal').offset().top
        $('.product-compare-modal').css('height',height+'px')
    }
}
function clearAll(){
    var comparisonTableLocal = $('.comparison-table').attr('data-local-storage')
    localStorage.setItem(comparisonTableLocal, JSON.stringify([]))
    renderCompare([], '.comparison-table');
    $('.btn-product-compare').css('display','none')
    $('.product-compare-pop-out').removeClass('show')
    $('.btn-product-compare').html($('.btn-product-compare').data('close'))
    resetAddToButton();
}
function resetAddToButton(){
    $('.product-compare').html('<span class="product-compare" data-product-handle="all-in-all-i-rotate-car-seat-lunaria" data-product-type="all">Add To Compare<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></span>')
}
function setUpButtons(){
    $('.btn-product-compare').off().on('click', function(){
        $('.product-compare-pop-out').toggleClass('show')
        if($('.product-compare-pop-out').hasClass('show')){
            $(this).html($(this).data('open'))
        }
        else{
            $(this).html($(this).data('close'))
        }
    })

    $('.remove-all-comparison').off().on('click', clearAll);

    if(!tableComparisonCheck || tableComparisonCheck.length == 0){
        $('.btn-product-compare').css('display','none')
    }else{
        $('.btn-product-compare').css('display','block')
    }

    $('.comparison-table').on('click','.column .close',deleteColumn);

    $('.modal-compare-table').on('click','.close',deleteColumnModal)

    $('.btn-product-compare-modal').off().on('click', function(){
        renderCompareModal()
    })

    $('.close-modal').off().on('click', function(){
        $('.product-compare-modal').css('display','none');
        $('body').css('position','relative');
    })

    $('.modal-compare-table .collection-listing').change(function(e){
        var value = $(this).val()
        $('.modal-compare-table .product-listing').val('null')
        if(value != 'null'){
            $.ajax({
                type: 'GET',
                url: '/collections/' + value +'/?view=listing',
                success: function (data) {
                    $('.modal-compare-table .product-listing').html(data)
                }
            }); 
        }
    })

    $('.modal-compare-table .product-listing').change(function(e){
        var value = $(this).val()
        $(this).val('null')
        if(value != 'null'){
            var comparisonTableLocal = $('.comparison-table').attr('data-local-storage'),
            tableComparisonCheck = JSON.parse(localStorage.getItem(comparisonTableLocal)),
            productType = $('.product-compare').attr('data-product-type'),
            productTypeLocal = productType += '_compare';
            if (jQuery.inArray(value, tableComparisonCheck) == -1) {
                addNewProductComparison(tableComparisonCheck,value,productTypeLocal)
                renderCompareModal()
            }
        }
    })
}
function modalHeight(){
    var height = $(window).height() - $('.product-compare-modal').offset().top;
    $('.product-compare-modal').css('height',height+'px')
    $(window).resize(function(){
        clearTimeout(window.resizeModalTimeout);
        window.resizeModalTimeout = setTimeout(function(){
            var height = $(window).height() - $('.product-compare-modal').offset().top
            $('.product-compare-modal').css('height',height+'px')
        }, 100);
    })
}
function deleteColumn(){
    var column = $(this).parent().parent(),
    columnID = $(column).attr('data-handle'),
    comparisonTableLocal = $('.comparison-table').attr('data-local-storage'),
    tableComparisonCheck = JSON.parse(localStorage.getItem(comparisonTableLocal));

    $(column).remove();

    var index = tableComparisonCheck.indexOf(columnID);
    if (index > -1) {
        tableComparisonCheck.splice(index, 1);
        localStorage.setItem(comparisonTableLocal, JSON.stringify(tableComparisonCheck));
    }
    if(tableComparisonCheck.length == 0){
        clearAll();
    }
    else if($('.product-compare').attr('data-product-handle') == columnID){
        resetAddToButton();
    }
    if(tableComparisonCheck.length < 4){
        $('.product-compare-modal .last').css('display','table-cell')
    }
    else{
        $('.product-compare-modal .last').css('display','none')
    }
}
function deleteColumnModal(){
    console.log('deleteColumnModal')
    console.log($(this).data('handle'))
    var handle = $(this).data('handle'),
    comparisonTableLocal = $('.comparison-table').attr('data-local-storage'),
    tableComparisonCheck = JSON.parse(localStorage.getItem(comparisonTableLocal));

    $('[data-handle='+handle+']').each(function(){
        $(this).remove();
    })

    var index = tableComparisonCheck.indexOf(handle);
    if (index > -1) {
        tableComparisonCheck.splice(index, 1);
        localStorage.setItem(comparisonTableLocal, JSON.stringify(tableComparisonCheck));
    }
    if(tableComparisonCheck.length == 0){
        clearAll();
    }
    else if($('.product-compare').attr('data-product-handle') == handle){
        resetAddToButton();
    }
    if(tableComparisonCheck.length < 4){
        $('.product-compare-modal .last').css('display','table-cell')
    }
    else{
        $('.product-compare-modal .last').css('display','none')
    }
}
if ($('.product-compare').length > 0) {
    addProductCompare();
}
if ($('body.template-product').length > 0 && typeof sparePartsUrlPath !== "undefined" && typeof activeProductId !== "undefined") {

    /* HM todo: Much of the below is code reuse from ajax-cart and the colourways/bundles JSON fetches. Could be refactored
    for further reuse and to cut down the file size */

    //Provide the user Feedback if the Ajax was sucessful or not. Modified for mobile optional overlay button
    function ajaxFeedbackSpares(status, html, $addToCartForm) {
        //$('.ajaxfeedback').remove();
        var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

        $addToCartForm.after(feedback);
        $('.ajaxfeedback').slideDown();
    }

    function addToCartSpares(element) {
        $('.ajaxfeedback').remove();
        //e.preventDefault();
        var $addToCartBtn = $(element);
        var $previousSibling = $(element).prev();
        var $addToCartBtnId = $(element).attr('data-variant-id');

        //Adding button stage
        updateBtnText($addToCartBtn, 'Added To Bag', config.loadingIcon);
        $addToCartBtn.addClass('btn-adding').prop('disabled', true);

        // Add to cart.
        $.ajax({
            url: config.shopifyAjaxAddURL,
            dataType: 'json',
            type: 'post',
            data: 'quantity=1&id=' + $addToCartBtnId,
            success: function (itemData) {

                //Added button stage
                updateBtnText($addToCartBtn, config.addedToCartBtnText, config.successIcon);
                $addToCartBtn.removeClass('btn-adding').addClass('btn-added');

                //Once added, reset button back to add.
                window.setTimeout(function () {
                    $addToCartBtn.removeClass('btn-added');
                    updateBtnText($addToCartBtn, 'Added To Bag');
                }, 4000);

                updateMiniCartContents();

                window.setTimeout(function () {
                    //$('.header-basket .cart-icon').addClass('swing animated');
                    $('.header-basket').addClass('hover');
                    $('.header-basket .cart-mini-contents .cart-header p').text(theme.strings.addedToYourBag);
                }, 1000);

                window.setTimeout(function () {
                    $('.header-basket').removeClass('hover');
                    //$('.header-basket .cart-icon').removeClass('swing animated');
                    $('.header-basket .cart-mini-contents .cart-header p').text(theme.strings.yourBag);
                }, 4000);

            },
            error: function (XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                if (response.slice(0, 4) === 'All ') {
                    ajaxFeedbackSpares('error', response.replace('All 1 ', 'All '), $previousSibling);
                    $addToCartBtn.prop('disabled', false);
                    updateBtnText($addToCartBtn, config.soldOutBtnText);
                    $addToCartBtn.prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
                } else {
                    ajaxFeedbackSpares('error', '<i class="fa fa-warning"></i> ' + response, $previousSibling);
                    $addToCartBtn.prop('disabled', false).removeClass('disabled');
                    updateBtnText($addToCartBtn, config.addToCartBtnText);
                }
            }
        });
        return false;
    }

    (function () {

       // only proceed if the product is a "Bundle"
        if (activeProductType === "Bundle") {
            const dataBundle = document.querySelector('[data-nobundle]');
            const accordionContainer = document.querySelector('.accordion-container');
            if (dataBundle && accordionContainer) {
                const message = dataBundle.getAttribute('data-nobundle');
                if (message) {
                    const messageElement = document.createElement('p');
                    messageElement.textContent = message;
                    accordionContainer.insertBefore(messageElement, accordionContainer.firstChild);
                }
            }
        }

        // stop further execution for "Spare Part" or "Bundle"
        if (activeProductType == "Spare Part") {
            return;
        }
        
        /* only run if this div exists. This won't appear if:
        A) the snippet 'product-colour-swatch.liquid' file is not included on the product page
        B) the product does not have a tag that contains "group_colours_"
        */
        var targetContainer = document.getElementById("speedy-spares-target-container");
        var repairsAccordion = document.getElementById("repairs");

        $.ajax({
            type: 'GET',
            //BG: "?view=colour" is a url parameter that will the template based on the value provided.
            // currentFamily applies a Shopify filter that finds products based on product tag and currentType filters out any bundles or accessories.
            url: sparePartsUrlPath,
            success: function (data) {
                if (data) {
                    try {
                        var json = JSON.parse(data);
                    } catch (e) {
                        var json = null; // meh
                    }
                }
                if (json) {
                    console.log('Help Zone | products: ' + json.products.length);
                    var productsCount = 0;
                    
                    //if Json is sucessful, pass over to function to output the results.
                    for (var key in json.products) {
                        var id = json.products[key]['id'],
                            title = json.products[key]['title'],
                            type = json.products[key]['type'],
                            priceInGBP = json.products[key]['price'],
                            available = json.products[key]['available'],
                            btnString;

                        console.log('Help Zone | type: ' + type);
                        console.log('Help Zone | title: ' + title);
                        //if current product ID matches the product ID in the loop or type isn't spare, skip it as it's a full product not a spare
                        if (id !== activeProductId && type === "Spare Part") {

                                if (available) {
                                    btnString = '<button type="submit" class="btn btn-primary add-to-cart-spares" data-variant-id="' + id + '">Buy Now</button>';
                                } else {
                                    btnString = '<button type="submit" class="btn btn-disabled add-to-cart-spares" data-variant-id="' + id + '" disabled>Unavailable</button></div>'
                                }
                                listMarkupElement = 
                                '<div class="product-sku-container">' +
                                    '<div class="product-sku-container__inner"><h5>' + title + '</h5></div>' +
                                    '<div class="product-sku-container__inner product-sku-container__last">' +
                                        '<p>' + priceInGBP + '</p>' + btnString +
                                    '</div>' +
                                '</div>';
                                targetContainer.insertAdjacentHTML('beforeend', listMarkupElement);
                                if (available) {
                                    targetContainer.querySelector('[data-variant-id="' + id + '"]').addEventListener('click', function () {
                                        addToCartSpares(this);
                                    });
                                }

                                productsCount++;

                        }
                    }

                    // HM: Ajax will always fetch the product you're on as it's filtering by it's own spareparts tag. > 1 means spares are associated
                    if (productsCount > 0) {
                        repairsAccordion.classList.remove('hidden');
                    }
                }
            }
        });
    })()
}
if (document.getElementById('warranty-form')) {
    (function () {
        var dateContainer = document.getElementById('date-input-container');
        var dateHtml = '<input type="date" id="native-datepicker" class="warranty-form-date" name="purchase-date" required="required"/>';

        if (Modernizr.inputtypes.date) {
            dateContainer.insertAdjacentHTML('beforeend', dateHtml);
            var nativeDatePicker = document.getElementById('native-datepicker');
            // HM: Add max date to today https://stackoverflow.com/questions/32378590/set-date-input-fields-max-date-to-today
            nativeDatePicker.max = new Date().toISOString().split("T")[0];
        } else {
            // HM: Regex to check for UK date format and includes logic for leap years https://stackoverflow.com/questions/15491894/regex-to-validate-date-format-dd-mm-yyyy
            dateContainer.insertAdjacentHTML('beforeend', '<input type="text" required="required" id="datepicker" name="purchase-date" class="warranty-form-date" pattern="^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[13-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$">');
            $("#datepicker").datepicker({
                changeMonth: true,
                changeYear: true,
                maxDate: new Date(),
                dateFormat: "dd/mm/yy",
            });
        }

        var form = document.getElementById('warranty-form');
        form.addEventListener("submit", handleWarrantyFormSubmission);

        function initSelect2Toybox() {
            $('.toybox-group-loading-wrapper').hide();
            $('#ToyboxProductId').select2({
                templateResult: function (item) {
                    if (!item.id) {
                        return item.text;
                    }
                    var dropdownHtml = '<div class="toybox-dropdown-item" data-shopify-id="' + item.shopify_id + '">';
                    dropdownHtml += '<img src="' + item.image + '" alt="' + item.sku + ' - Product image" />';
                    dropdownHtml += '<span>' + item.name + ' - ' + item.sku + '</span>';
                    dropdownHtml += '</div>'
                    var $dropdownHtml = $(dropdownHtml)
                    return $dropdownHtml
                },
                placeholder: "Search products",
                ajax: {
                    url: `${window.Shopify.routes.root}search`,
                    delay: 500,
                    dataType: 'json',
                    processResults: function (data, page) {
                        var returnResults = [];
                        data.results.forEach(result => {
                            formatedResult = {
                                'name': result.name,
                                'text': result.name,
                                'shopify_id': result.shopify_id,
                                'id': JSON.stringify({
                                    id: result.toybox_id,
                                    sku: result.sku,
                                    name: result.name
                                }),
                                'sku': result.sku,
                                'image': result.image
                            };
                            returnResults.push(formatedResult);
                        });

                        return {
                            'results': returnResults,
                            'pagination': {
                                'more': data.pagination.more
                            }
                        };
                    },
                    data: function (params) {
                        var query = {
                            q: params.term || '',
                            view: 'warranty',
                            page: params.page || 1,
                            type: 'product',
                            'filter.p.tag': 'Allow Product Registration'
                        }
                
                        return query;
                    }
                }
            });
        }

        function setWarrantyFormState(state, form, cuddleID) {
            var error, complete, loading;
            error = complete = loading = false;
            switch (state) {
                case 'loading':
                    loading = true;
                    break;
                case 'error':
                    error = true;
                    break;
                case 'complete':
                    complete = true;
            }
            if (cuddleID != undefined) {
                $('#cuddleID-return').text(cuddleID);
            }
            if (loading) {
                $(form).addClass('is-loading');
            } else {
                $(form).removeClass('is-loading');
            }
            if (error) {
                $(form).addClass('has-error');
            } else {
                $(form).removeClass('has-error');
            }
            if (complete) {
                $(form).addClass('is-complete');
            } else {
                $(form).removeClass('is-complete');
            }
        }

        function handleWarrantyFormSubmission(e) {
            e.preventDefault();
            setWarrantyFormState('loading', form);
            var toyBoxId = window.toyBoxCustomerDetails.ToyBoxID;
            if (toyBoxId == undefined || toyBoxId == null || toyBoxId == "") {
                var requestFields = [
                    ["EmailAddress", window.toyBoxCustomerDetails.EmailAddress],
                    ["Firstname", window.toyBoxCustomerDetails.Firstname],
                    ["Surname", window.toyBoxCustomerDetails.Surname],
                ];
                var handler = new CosattoServiceHandler('contact-id', 'POST', window.liquidStoreVariables.testMode);
                handler.request(
                    requestFields,
                    function (state, xmlDoc) {
                        // TODO CHANGE REFERENCE
                        var toyBoxId = xmlDoc.getElementsByTagName('GetContactIdResult')[0].childNodes[0].nodeValue;
                        submitWarrantyFromRequest(toyBoxId);
                    }
                );
            } else {
                submitWarrantyFromRequest(toyBoxId);
            }
        }

        function submitWarrantyFromRequest(toyBoxId) {
            var dateInput = $('#warranty-form .warranty-form-date').val();
            var isoDateString = new Date(dateInput).toISOString();
            var isoDateStringNow = new Date().toISOString();
            var batchReference = $('#warranty-form .batch-reference-input').val(),
                receiptNumber = $('#warranty-form .receipt-number-input').val(),
                retailerName = $('#warranty-form .retailer-input').val(),
                toyBoxProductIdJSON = $('#warranty-form #ToyboxProductId').val(),
                toyBoxProductId = JSON.parse(toyBoxProductIdJSON).id;

            // HM: Add score and Klaviyo var declarations
            var score = $('#warranty-form .score-input').val(),
                email = toyBoxCustomerDetails.EmailAddress,
                comments = $('#warranty-form .comments-input').val(),
                commaSeparatedListOfInterests = "";

            // HM: Simple string concatenation so the list of interests the user clicked can be seen in Klaviyo
            $("input:checkbox[name=interest]:checked").each(function (index, value) {
                var isFirstElement = index == 0;
                var isLastElement = index == $("input:checkbox[name=interest]:checked").length - 1;

                if (isFirstElement) {
                    commaSeparatedListOfInterests += ($(this).val() + ',');
                } else if (isLastElement) {
                    commaSeparatedListOfInterests += (' ' + $(this).val());
                } else {
                    commaSeparatedListOfInterests += (' ' + $(this).val() + ',');
                }
            });

            var requestFields = [
                ["BatchReference", batchReference],
                ["OtherRetailerName", retailerName],
                ["PurchaseDate", isoDateString],
                ["ReceiptNumber", receiptNumber],
                ["ToyboxContactId", toyBoxId],
                ["ToyboxProductId", toyBoxProductId],
            ];

            var scoreRequestFields = [
                ["Comments", comments],
                ["EmailAddress", email],
                ["Score", score],
            ];

            var klaviyoFields = {
                "Purchase_Reasons": commaSeparatedListOfInterests,
                "Registered_Product": JSON.parse(toyBoxProductIdJSON).name,
                "Purchase_Date": isoDateString,
                "Registered_Date": isoDateStringNow,
                "Registered_Product_Code": JSON.parse(toyBoxProductIdJSON).sku
            };

            // HM: Capture return value and use it when all async jobs complete
            var cuddleID;

            try {
                var handler = new CosattoServiceHandler('warranty-register', 'POST', window.liquidStoreVariables.testMode);
                var scoreHandler = new CosattoServiceHandler('add-score', 'POST', window.liquidStoreVariables.testMode);

                handler.request(
                    requestFields,
                    function (state, xmlDoc) {
                        cuddleID = xmlDoc.getElementsByTagName('a:GuaranteeReference')[0].childNodes[0].nodeValue;
                        console.log('Warranty: Added successfully.');
                        scoreHandler.request(
                            scoreRequestFields,
                            function (state, xmlDoc) {
                                // HM: Not currently a customer facing element of the site
                                console.log('NPS Score: Added successfully.')
                                setWarrantyFormState(state, form, cuddleID);
                                // HM: Boolean passed from liquid as object property within inline JS
                                if (toyBoxCustomerDetails.AcceptsMarketing) {
                                    _learnq.push(["track", "Registered Product Guarantee", klaviyoFields]);
                                }
                            }
                        );
                    }
                );
            } catch (error) {
                setWarrantyFormState('error', form);
            }

            return false;
        }

        initSelect2Toybox();
    })();
}

if (document.getElementById('warranty-list')) {
    (function () {

        var warrantyList = document.getElementById('warranty-list');
        // HM: Identify XML by tag name and then set the title to display and order to display the fields in
        var fieldNames = {
            "a:ExpirationDateTime": {title: "Expires", order: 4},
            "a:GuaranteeReference": {title: "Reference", order: 2},
            "a:ProductName": {title: "Product Name", order: 1},
            "a:RegistrationDateTime": {title: "Registered", order: 3}
        }

        function generateWarrantyList(guarantees) {
            var warranty, warrantyField, xmlTag, xmlContentAsDate, convertedDateFormat, xmlTagHTML, htmlArray;
            for (var x = 0; x < guarantees.length; x++) {
                htmlArray = [];
                warranty = document.createElement("div");
                warranty.classList.add("warranty");

                for (var y = 0; y < guarantees[x].childNodes.length; y++) {
                    xmlTag = guarantees[x].childNodes[y].tagName;
                    if (xmlTag in fieldNames) {
                        warrantyField = document.createElement("div");
                        warrantyField.classList.add("warranty__field");
                        xmlTagHTML = '<span class="warranty-field__title">' + fieldNames[xmlTag].title + ':</span> ';
                        if (xmlTag == "a:ExpirationDateTime" || xmlTag == "a:RegistrationDateTime") {
                            xmlContentAsDate = new Date(guarantees[x].childNodes[y].textContent);
                            convertedDateFormat = xmlContentAsDate.toLocaleDateString();
                            warrantyField.innerHTML = xmlTagHTML + convertedDateFormat;
                        } else if (xmlTag in fieldNames) {
                            warrantyField.innerHTML = xmlTagHTML + guarantees[x].childNodes[y].textContent;
                        }
                        htmlArray.push({elem: warrantyField, order: fieldNames[xmlTag].order})
                    }
                }

                htmlArray.sort(function (a, b) {
                    return a.order - b.order;
                });

                for (var i = 0; i < htmlArray.length; i++) {
                    warranty.append(htmlArray[i].elem);
                }

                warrantyList.append(warranty);
            }
        }

        function getWarrantiesFromRequest(id) {
            var handler = new CosattoServiceHandler('get-guarantees', 'POST', window.liquidStoreVariables.testMode);
            // HM: 3rd array item used as prefix and the guarantee fetch has none, so blank string used
            var requestFields = [["toyboxContactId", id, ""]];
            try {
                handler.request(
                    requestFields,
                    function (state, xmlDoc) {
                        // TODO CHANGE REFERENCE
                        var allGuarantees = xmlDoc.getElementsByTagName('a:Guarantee');
                        if (allGuarantees.length > 0) {
                            generateWarrantyList(allGuarantees);

                            let $toggle = jQuery('.warranty-form-container .toggle');
                            $toggle.css('display', 'flex');
                            let $toggleButtons = $toggle.find('> button');
                            $toggleButtons.on('click', function(e){
                                $toggleButtons.filter('.active').removeClass('active');

                                let $this = jQuery(e.currentTarget);
                                $this.addClass('active');
                                let $list = jQuery('#warranty-list');
                                if($this.hasClass('grid') === true) {
                                    $list.removeClass('list-view');
                                    return;
                                }
                                $list.addClass('list-view');
                            });
                        } else {
                            if (window.location.href.indexOf(".es") > -1) {
                                warrantyList.textContent = "No hay ninguna garantía asociada a esta cuenta."
                            } else if (window.location.href.indexOf(".de") > -1) {
                                warrantyList.textContent = "Mit diesem Konto sind keine Garantien verbunden."
                            } else {
                                warrantyList.textContent = "There aren't any guarantees currently associated with your account."
                            }
                        }
                    }
                );
            } catch (error) {
                console.log(error);
            } finally {
                // HM: Hide the loading icon when fetch complete
                let $container = jQuery('.warranty-form-container');
                $container.find('.loading-icon-wrapper').css('display', 'none');
            }
        }

        var toyBoxId = window.toyBoxCustomerDetails.ToyBoxID;
        var handler = new CosattoServiceHandler('contact-id', 'POST', window.liquidStoreVariables.testMode);

        if (toyBoxId == undefined || toyBoxId == null || toyBoxId == "") {
            var requestFields = [
                ["EmailAddress", window.toyBoxCustomerDetails.EmailAddress],
                ["Firstname", window.toyBoxCustomerDetails.Firstname],
                ["Surname", window.toyBoxCustomerDetails.Surname],
            ];
            try {
                handler.request(
                    requestFields,
                    function (state, xmlDoc) {
                        // TODO CHANGE REFERENCE
                        var toyBoxId = xmlDoc.getElementsByTagName('GetContactIdResult')[0].childNodes[0].nodeValue;
                        getWarrantiesFromRequest(toyBoxId);
                    }
                );
            } catch (error) {
                $('.warranty-form-container .loading-icon-wrapper').css('display', 'none');
                console.log(error);
            }
        } else {
            getWarrantiesFromRequest(toyBoxId);
        }
    })();
}

// SH: To Do: We need to combine these with other store/domain settings, so theese are updates as new stores are created

(function () {

        const storeRedirect = $('.store-redirect');

        if (storeRedirect.length) {
            geoLocation();
            redirectClose();
        }

        // HM: Helpers to create cookie with specific name, value and expiry
        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + "domain=cosatto./ ;path=/;";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
        // HM: Simplified logic, simply prompt user with a popup if they on the wrong domain. Don't show popup for 1 year if user chooses not to visit correct domain
        function geoLocation() {
            var geoPopup = getCookie('geoPopup'),
                storeAddress = $('.store-redirect').attr('data-store-address'),
                redirectPopup = $('.redirect-popup'),
                redirectOverlay = $('.redirect-overlay'),
                redirectTargetCountry = $('.redirect-content .target-country'),
                redirectButtonLink = $('.redirect-content .btn-redirect');
        
            const url = new URL(window.Shopify.routes.root + 'browsing_context_suggestions.json', window.location.origin);
            url.searchParams.set('country[enabled]', 'true');
            url.searchParams.set('language[enabled]', 'true');
        
            fetch(url)
                .then(res => res.json())
                .then(data => {
                    const detectedCountry = data?.detected_values?.country?.handle;
        
                    if (detectedCountry) {
                        document.body.dataset.country = detectedCountry;
                    }
        
                    if (geoPopup !== "false") {
                        let storeMap = {};
                        try {
                            storeMap = JSON.parse(storeRedirect.attr('data-geo-map') || '{}');
                        } catch (err) {
                            console.error('[Geo] Invalid JSON in redirect map:', err);
                        }
        
                        const defaultRedirect = storeRedirect.data('url-default');
        
                        let targetUrl = null;
                        let targetCountry = detectedCountry;
        
                        if (detectedCountry in storeMap) {
                            const mappedUrl = storeMap[detectedCountry];
                            const expectedHost = mappedUrl.replace(/^https?:\/\//, '');
        
                            if (!storeAddress.includes(expectedHost)) {
                                targetUrl = mappedUrl;
                            } else {
                            }
                        } else {
                            const expectedHost = defaultRedirect.replace(/^https?:\/\//, '');
        
                            if (!storeAddress.includes(expectedHost)) {
                                targetUrl = defaultRedirect;
                                targetCountry = 'UK';
                            } else {
                            }
                        }
        
                        if (targetUrl) {
                            $(redirectTargetCountry).html(targetCountry);
                            $(redirectButtonLink).attr('href', targetUrl);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        } else {
                            setCookie("geoPopup", "false", 365);
                        }
                    } else {
                    }
                })
                .catch(err => {
                    console.error('[Geo] Error fetching browsing context:', err);
                });
        }
        
        
        
      

        // HM: Click and close popup, don't show it again for 1 year
        function redirectClose() {
            $('.redirect-close').off('click').on('click', function () {

                $('.redirect-popup').removeClass('active');
                $('.redirect-overlay').removeClass('active');

                setCookie("geoPopup", "false", 365);

            });
        }
    }
)()
if (document.getElementById('comparison-table') && typeof comparisonData !== "undefined") {
    (function () {
        document.addEventListener('shopify:section:load', comparisonTool);
        document.addEventListener('DOMContentLoaded', comparisonTool);

        function comparisonTool() {
            /*
            * HM: Keys are coupled to the names of setting objects coming from liquid schema to show a user friendly name
            * for the table row that corresponds to the schemas data. Between this and some variables printed from liquid this
            * JS is probably best maintained inline with the snippet. This functionality will be expanded and it's not certain
            * that all these table rows will have the same names, so multiple presentationTitles objects might be needed or refactor
            * if required.
            * */
            var bodyOfTablePage = document.body;
            var comparisonTable = document.getElementById("comparison-table");
            var comparisonTool = document.querySelector(".landing-page.comparison-tool");
            var comparisonList = document.getElementById("comparison-list");
            var comparisonMessageOverlay = document.getElementById("comparison-message");
            var closeButton = document.getElementById("main-close-button");
            var downloadButton = document.querySelector("[data-download-button]");
            var comparisonButtons = document.getElementById("comparison-confirmation");
            var productCounter = document.getElementById("product-counter");
            var buttonContainer = document.querySelector(".comparison-confirmation__button-container");
            var confirmButton = document.getElementById("btn-confirm");
            var clearButton = document.getElementById("btn-clear");
            var shutButton = document.getElementById("btn-shut");
            var closeIcon = document.querySelector(".icon-close");
            var headRow = document.querySelector(".head-row");
            var checkboxLabels = comparisonTool.querySelectorAll(".comparison-product__label");
            var allButtons = comparisonTool.querySelectorAll("input");

            // HM: Helper functions, inline usage means jQuery probably wont have loaded.
            function toggleTable() {
                if (!comparisonTable.classList.contains("active")) {
                    comparisonTable.classList.add("active");
                    bodyOfTablePage.classList.add("child-modal-active");
                } else {
                    comparisonTable.classList.remove("active");
                    bodyOfTablePage.classList.remove("child-modal-active");
                }
            }

            function openButtons() {
                if (!comparisonButtons.classList.contains("active")) {
                    comparisonButtons.classList.add("active");
                }
            }

            function closeButtons() {
                if (comparisonButtons.classList.contains("active")) {
                    comparisonButtons.classList.remove("active");
                }
            }

            function uncheckAll() {
                for (var n = 0; n < allButtons.length; n++) {
                    allButtons[n].disabled = false;
                    allButtons[n].checked = false;
                }
                closeButtons();
                destroyCells();
                destroyList();
                resetLabels();
            }

            function downloadFile() {
                // Create an invisible A element
                const a = document.createElement("a");
                a.style.display = "none";
                document.body.appendChild(a);
                a.href = this.dataset.downloadButton;

                // Use download attribute to set set desired file name
                a.setAttribute("download", this.dataset.fileName);
                a.setAttribute("target", "_blank");

                // Trigger the download by simulating click
                a.click();

                // Cleanup
                document.body.removeChild(a);
            }

            function destroyCells() {
                var headCells = comparisonTable.querySelectorAll('.header');
                var bodyCells = comparisonTable.querySelectorAll('.column.body');

                for (var x = 0; x < headCells.length; x++) {
                    headCells[x].remove();
                }

                for (var y = 0; y < bodyCells.length; y++) {
                    bodyCells[y].remove();
                }
            }

            function destroyList() {
                var listItems = comparisonList.querySelectorAll('.comparison-list__item');

                for (var x = 0; x < listItems.length; x++) {
                    listItems[x].remove();
                }
            }

            function resetLabels() {
                for (var x = 0; x < checkboxLabels.length; x++) {
                    checkboxLabels[x].classList.remove('inactive');
                }
            }

            // HM: Generates column data, either from clicking on the checkboxes or initially setting up the DOM from the window loading.
            function createColumns(targetInput, targetContainer) {
                //console.log('targetInput: ' + targetInput);
                //console.log('targetContainer: ' + targetContainer);
                console.log('targetContainer.dataset.handle: ' + targetContainer.dataset.handle);
                if (targetInput.checked) {
                    // SH: Ensure index always starts with 0
                    var indexToNumber = parseInt(0 + targetContainer.dataset.index);
                    var productData = comparisonData.products[indexToNumber];
                    //console.log('targetContainer.dataset.index: ' + targetContainer.dataset.index);
                    console.log('indexToNumber: ' + indexToNumber);
                    // HM: Simple default in case the url is ever left blank
                    var productURL = productData["url"] || "/";
                    headRow.insertAdjacentHTML("beforeend", '<td class="header ' + targetContainer.dataset.handle + '"><h4>' + productData["name"] + '</h4><div><a href="' + productURL + '"><img src="' + productData["image"] + '"></a></div><h5>' + productData["price"] + '<div><a class="btn btn-primary" href="' + productURL + '">' + comparisonData.buyString + '</a></td>');
                    for (var k = 0; k < comparisonRows.length; k++) {
                        var rowHandle = comparisonRows[k].dataset.handle,
                        isTrueSet;

                        switch (productData[rowHandle]) {
                            case true:
                                isTrueSet = true;
                                break;
                            case false:
                                isTrueSet = false;
                                break;
                            case 'true':
                                isTrueSet = true;
                                break;
                            case 'false':
                                isTrueSet = false;
                                break;
                            default:
                                isTrueSet = null;
                        }

                        if (typeof isTrueSet === "boolean") {
                            // HM: Schema input is a checkbox, not text. So display an icon instead.
                            comparisonRows[k].insertAdjacentHTML("beforeend", `<td class="column body ${targetContainer.dataset.handle}">${isTrueSet ? comparisonData.trueIcon : ""}</td>`);
                        } else {
                            var rowBody = productData[rowHandle];
                            comparisonRows[k].insertAdjacentHTML("beforeend", '<td class="column body ' + targetContainer.dataset.handle + '">' + rowBody + '</td>');
                        }
                    }
                    // HM: Add the comparison list item for the confirmation section at the bottom of the page
                    comparisonList.insertAdjacentHTML("beforeend", '<h4 class="comparison-list__item ' + targetContainer.dataset.handle + '"><label for="' + targetContainer.dataset.handle + '">' + productData["name"] + '</label></h4>');
                }
            }

            function checkUpdateDOMState() {
                // HM: Get all the checked inputs on the page
                var checkedButtons = comparisonTool.querySelectorAll(".comparison-product__button input:checked");
                productCounter.textContent = checkedButtons.length.toString();

                // HM: If theres more than one open the confirmation dialogue box
                if (checkedButtons.length > 0) {
                    openButtons();
                    if (checkedButtons.length === 1) {
                        confirmButton.disabled = true;
                        // HM: Saves wrestling with !important rules in CSS and means the button still follows primary styling if it ever changes
                        if (confirmButton.classList.contains('btn-primary') && !confirmButton.classList.contains('btn-tertiary')) {
                            confirmButton.classList.remove('btn-primary');
                            confirmButton.classList.add('btn-tertiary');
                        }
                        if (!comparisonMessageOverlay.classList.contains('active')) {
                            comparisonMessageOverlay.classList.add('active');
                        }
                        if (buttonContainer.classList.contains('active')) {
                            buttonContainer.classList.remove('active')
                            buttonContainer.classList.add('hidden')
                        }
                    } else {
                        confirmButton.disabled = false;
                        if (!confirmButton.classList.contains('btn-primary') && confirmButton.classList.contains('btn-tertiary')) {
                            confirmButton.classList.add('btn-primary');
                            confirmButton.classList.remove('btn-tertiary');
                        }
                        if (comparisonMessageOverlay.classList.contains('active')) {
                            comparisonMessageOverlay.classList.remove('active');
                        }
                        if (buttonContainer.classList.contains('hidden')) {
                            buttonContainer.classList.remove('hidden');
                            buttonContainer.classList.add('active');
                        }
                    }
                } else if (checkedButtons.length < 1) {
                    closeButtons();
                }

                // HM: If there's 4 then disable inputs that aren't already checked otherwise make sure they're all enabled
                if (checkedButtons.length > 3) {
                    for (var m = 0; m < allButtons.length; m++) {
                        // HM: Disable unchecked checkboxes to prevent too many being selected
                        if (!allButtons[m].checked) {
                            allButtons[m].disabled = true;
                        }
                    }
                    for (var o = 0; o < checkboxLabels.length; o++) {
                        // HM: Only grey out the label if the box isn't checked
                        if (!checkboxLabels[o].nextElementSibling.checked) {
                            checkboxLabels[o].classList.add('inactive');
                        }
                    }
                } else {
                    for (var n = 0; n < allButtons.length; n++) {
                        allButtons[n].disabled = false;
                    }
                    for (var p = 0; p < checkboxLabels.length; p++) {
                        checkboxLabels[p].classList.remove('inactive');
                    }
                }
            }

            // HM: When the window loads we need to create the table and enable/disable inputs, as if the user hits Back the state of the inputs is actually stored.
            function loadInit() {
                var buttonContainers = document.querySelectorAll(".comparison-product__button");
                var checkboxThatMatchesContainer;

                for (var x = 0; x < buttonContainers.length; x++) {
                    checkboxThatMatchesContainer = document.getElementById(buttonContainers[x].dataset.handle);
                    createColumns(checkboxThatMatchesContainer, buttonContainers[x]);
                }

                checkUpdateDOMState();
            }

            // HM: Events for everything where we have to manually handle the state using the DOM
            confirmButton.addEventListener("click", toggleTable);
            closeIcon.addEventListener("click", toggleTable);
            closeIcon.addEventListener("click", uncheckAll);
            closeButton.addEventListener("click", toggleTable);
            closeButton.addEventListener("click", uncheckAll);
            if (downloadButton) {
                downloadButton.addEventListener("click", downloadFile);
            }
            if(clearButton){
                clearButton.addEventListener("click", uncheckAll);
            }
            if(shutButton){
                shutButton.addEventListener("click", closeButtons);
            }

            window.addEventListener('load', loadInit);

            // HM: More data coupling. Adds the initial row headers, correct table layout is dependant on the data attributes in comp-row always managing to return data from the comparisonProducts
            var comparisonRows = document.querySelectorAll(".comp-row");
            var checkboxInputs = document.querySelectorAll(".comparison-product__button");

            for (var j = 0; j < checkboxInputs.length; j++) {
                checkboxInputs[j].addEventListener("change", function (e) {
                    // HM: Remove display none from button overlay, used to prevent animation occurring on page load
                    if (comparisonButtons.classList.contains('not-loaded')) {
                        comparisonButtons.classList.remove('not-loaded')
                    }
                    var checkedButtons = comparisonTool.querySelectorAll("input:checked");
                    // HM todo: This check makes the same check in createColumns redundant however the window.load method needs to run that check
                    if (!e.target.checked) {
                        // HM: Removes all elements with a class that matches the current target handle
                        var handleizedProductAsClass = '.' + this.dataset.handle;
                        var allExistingColumns = comparisonTable.querySelectorAll(handleizedProductAsClass);
                        var existingListItem = comparisonList.querySelector(handleizedProductAsClass);
                        existingListItem.remove();
                        for (var l = 0; l < allExistingColumns.length; l++) {
                            allExistingColumns[l].remove();
                        }
                    } else {
                        createColumns(e.target, this);
                    }
                    // HM: Check if the confirmation dialogue needs showing/hiding and inputs enabling/disabling
                    checkUpdateDOMState();
                })
            }
        }
    })()
}


$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

});

/* ==========================================================================
#Custom Velstar
========================================================================== */

//product page swatch change
$('.swatch :radio').change(function () {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});

$(document).ready(function () {
    //console.log('document ready');
    $('.scroll-link').click(function (e) {
        e.preventDefault()
        let scrolltop = ($($(this).data('scroll')).offset().top - 200)
        $([document.documentElement, document.body]).animate({
            scrollTop: scrolltop
        }, 1000);
    });
    if($("#countdown-usp-container.scroll-hide")){
        var countdown_h = $("#countdown-usp-container.scroll-hide").outerHeight(); var lastScrollTop = 0;
        if(countdown_h){
            console.log('countdown height: ' + countdown_h);
        }
        /* SH: To do, mobile top margin doesn't reflect height in browser emulator */
        $(window).scroll(function(event){
            var st = $(this).scrollTop();
            if (st > lastScrollTop && countdown_h){
                $("#countdown-usp-container.scroll-hide").stop().animate({"marginTop": "-" + countdown_h + "px"}, "fast" );
                //$("#shopify-section-header").stop().animate({"marginTop": "-" + countdown_h + "px"}, "slow" );
            } else {
                $("#countdown-usp-container.scroll-hide").stop().animate({"marginTop": "0px"}, "fast" );
                //$("#shopify-section-header").stop().animate({"marginTop": "0px"}, "slow" );
            }
            lastScrollTop = st;
        });
    }
});




function parseJSONAttribute(element, attributeName) {
    var value = element.getAttribute(attributeName);

    if (!value) {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn('Invalid JSON in ' + attributeName, element, error);
        return null;
    }
}

function findDirectChildByClass(element, className) {
    var children = element.children;

    for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains(className)) {
            return children[i];
        }
    }

    return null;
}

function normalizeSwiperMarkup(swiperEl, opts) {
    if (!swiperEl.classList.contains('swiper')) {
        swiperEl.classList.add('swiper');
    }

    var wrapper = findDirectChildByClass(swiperEl, 'swiper-wrapper');

    if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        var movedChildren = [];
        var childNodes = swiperEl.children;

        for (var i = 0; i < childNodes.length; i++) {
            var node = childNodes[i];
            if (
                !node.classList.contains('swiper-pagination') &&
                !node.classList.contains('swiper-button-prev') &&
                !node.classList.contains('swiper-button-next')
            ) {
                movedChildren.push(node);
            }
        }

        for (var j = 0; j < movedChildren.length; j++) {
            wrapper.appendChild(movedChildren[j]);
        }

        swiperEl.insertBefore(wrapper, swiperEl.firstChild);
    }

    var slides = wrapper.children;
    for (var k = 0; k < slides.length; k++) {
        if (!slides[k].classList.contains('swiper-slide')) {
            slides[k].classList.add('swiper-slide');
        }
    }

    if (!opts) {
        return opts;
    }

    if (opts.pagination === true) {
        var defaultPagination = findDirectChildByClass(swiperEl, 'swiper-pagination');
        if (!defaultPagination) {
            defaultPagination = document.createElement('div');
            defaultPagination.className = 'swiper-pagination';
            swiperEl.appendChild(defaultPagination);
        }
        opts.pagination = {
            el: defaultPagination,
            clickable: true
        };
    } else if (opts.pagination && typeof opts.pagination === 'object') {
        var paginationEl = null;

        if (typeof opts.pagination.el === 'string') {
            paginationEl = swiperEl.querySelector(opts.pagination.el);
        } else if (opts.pagination.el && opts.pagination.el.nodeType === 1) {
            paginationEl = opts.pagination.el;
        }

        if (!paginationEl) {
            paginationEl = findDirectChildByClass(swiperEl, 'swiper-pagination');
        }

        if (!paginationEl) {
            paginationEl = document.createElement('div');
            paginationEl.className = 'swiper-pagination';
            swiperEl.appendChild(paginationEl);
        }

        opts.pagination.el = paginationEl;
    }

    if (opts.navigation === true) {
        var prevButton = findDirectChildByClass(swiperEl, 'swiper-button-prev');
        var nextButton = findDirectChildByClass(swiperEl, 'swiper-button-next');

        if (!prevButton) {
            prevButton = document.createElement('div');
            prevButton.className = 'swiper-button-prev';
            swiperEl.appendChild(prevButton);
        }

        if (!nextButton) {
            nextButton = document.createElement('div');
            nextButton.className = 'swiper-button-next';
            swiperEl.appendChild(nextButton);
        }

        opts.navigation = {
            prevEl: prevButton,
            nextEl: nextButton
        };
    } else if (opts.navigation && typeof opts.navigation === 'object') {
        var prevEl = null;
        var nextEl = null;

        if (typeof opts.navigation.prevEl === 'string') {
            prevEl = swiperEl.querySelector(opts.navigation.prevEl);
        } else if (opts.navigation.prevEl && opts.navigation.prevEl.nodeType === 1) {
            prevEl = opts.navigation.prevEl;
        }

        if (typeof opts.navigation.nextEl === 'string') {
            nextEl = swiperEl.querySelector(opts.navigation.nextEl);
        } else if (opts.navigation.nextEl && opts.navigation.nextEl.nodeType === 1) {
            nextEl = opts.navigation.nextEl;
        }

        if (!prevEl) {
            prevEl = findDirectChildByClass(swiperEl, 'swiper-button-prev');
        }
        if (!nextEl) {
            nextEl = findDirectChildByClass(swiperEl, 'swiper-button-next');
        }

        if (!prevEl) {
            prevEl = document.createElement('div');
            prevEl.className = 'swiper-button-prev';
            swiperEl.appendChild(prevEl);
        }

        if (!nextEl) {
            nextEl = document.createElement('div');
            nextEl.className = 'swiper-button-next';
            swiperEl.appendChild(nextEl);
        }

        opts.navigation.prevEl = prevEl;
        opts.navigation.nextEl = nextEl;
    }

    return opts;
}

function initSwipers(context) {
    var scope = context || document;
    var swiperEls = scope.querySelectorAll('[data-swiper-options]:not(.swiper-initialized)');

    for (var i = 0; i < swiperEls.length; i++) {
        var opts = parseJSONAttribute(swiperEls[i], 'data-swiper-options');
        opts = normalizeSwiperMarkup(swiperEls[i], opts);

        if (opts) {
            new Swiper(swiperEls[i], opts);
        }
    }
}

$(document).ready(function () {
    initSwipers();
});

// HM: Used to reload JS within Theme Customiser
document.addEventListener('shopify:section:load', function (e) {
    // HM: Reinit any Klarna items
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({eventName: 'refresh-placements'});

    // Reinitialise Swiper carousels in the reloaded section
    initSwipers(e.target);

    if (document.getElementById('countdown-usp-container')) {
        uspTargetDate = uspCreateTargetDate();
    }
});

if (document.getElementById('countdown-offer-header')) {
    //Let body know we have the countdown enabled
    document.body.classList.add("countdown-enabled");
   
    function offerCreateTargetDate() {
        const offerCountdownContainerData = document.querySelector('#countdown-offer-container').dataset,
            yy = parseInt(offerCountdownContainerData.countdownYear),
            mo = parseInt(offerCountdownContainerData.countdownMonth),
            dd = parseInt(offerCountdownContainerData.countdownDays),
            hh = parseInt(offerCountdownContainerData.countdownHours),
            mi = parseInt(offerCountdownContainerData.countdownMinutes);
    
        const target = new Date(yy, mo - 1, Math.min(new Date(yy, mo, 0).getDate(), dd), hh, mi, 0);
    
        return target;
    }
    
    let offerTargetDate = offerCreateTargetDate();

    (function () {
        function offerCountdown() {
            const target = offerTargetDate,
                targetElement = document.querySelector('#countdown-offer-header'),
                now = new Date;

            //if greater than target time...
            if (now > target) {
                document.querySelector('.countdown-message').classList.add('d-none');
                document.querySelector('.countdown-message-wrapper').classList.add('d-none');
                document.querySelector('.countdown-message-end').classList.remove('d-none');
            } else {
                const remain = target - now,
                    second = 1000,
                    minute = second * 60,
                    hour = minute * 60,
                    day = hour * 24;

                const dd = Math.floor(remain / day),
                    hh = Math.floor((remain % day) / hour),
                    mm = Math.floor((remain % hour) / minute),
                    ss = Math.floor((remain % minute) / second);

                if ($(window).width() < screenMD) {
                    targetElement.innerHTML =
                        '<div class="time days">' + dd + '<small>' + theme.strings.general.short_time.days + '</small></div><div class="time hours">' + hh + '<small>' + theme.strings.general.short_time.hours + '</small></div><div class="time minutes">' + mm + '<small>' + theme.strings.general.short_time.mins + '</small></div><div class="time seconds">' + ss + '<small>' + theme.strings.general.short_time.secs + '</small></div>';
                } else {
                    targetElement.innerHTML =
                        '<div class="time days">' + dd + '<small>' + theme.strings.general.time.days + '</small></div><div class="time hours">' + hh + '<small>' + theme.strings.general.time.hours + '</small></div><div class="time minutes">' + mm + '<small>' + theme.strings.general.time.mins + '</small></div><div class="time seconds">' + ss + '<small>' + theme.strings.general.time.secs + '</small></div>';
                }
            }
            setTimeout(offerCountdown, 1000);
        }

        document.addEventListener('DOMContentLoaded', offerCountdown);
    })();
}


//Hide/reveal header when scrolling down/up (only for mobile so below 992px)
document.addEventListener('DOMContentLoaded', function() {
    let lastScrollY = 0;
    let ticking = false;
    const header = document.querySelector('#site-header');
    const filter = document.querySelector('.mobile-filter-sort');
    const mediaQuery = window.matchMedia('(max-width: 991px)');
    let isMobile = mediaQuery.matches;

    if (!header) return;

    mediaQuery.addEventListener('change', (e) => {
        isMobile = e.matches;
        if (!isMobile) {
            header.classList.remove('header-hidden');
        }
    });

    const hideTolerance = 320;

    const setHeaderVisibility = () => {
        const currentScrollY = window.scrollY;
        if(isMobile) {
            if (currentScrollY > lastScrollY && currentScrollY > hideTolerance) {
                header.classList.add('header-hidden');
                if(filter) filter.classList.add('top');
            } else {
                header.classList.remove('header-hidden');
                if(filter) filter.classList.remove('top');
            }
        }
        lastScrollY = currentScrollY;
    }

    document.addEventListener("scroll", () => { 
        if (!ticking) {
            // Throttle the event to "setHeaderVisibility" every 20ms
            setTimeout(() => {
                setHeaderVisibility();
                ticking = false;
            }, 20);
            ticking = true;
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const offerBar = document.querySelector('[data-offer-bar]');
    if (!offerBar || !offerBar.children.length) return;
    document.body.classList.add('show-offer-bar');
});

const initBodyTagPadding = () => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const BREAKPOINTS = {
        DESKTOP: 992,
    };

    const mediaQuery = window.matchMedia(`(width >= ${BREAKPOINTS.DESKTOP}px)`);

    const setCSSVariable = () => {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--body-padding-offset', `${headerHeight}px`);
    }

    mediaQuery.addEventListener('change', setCSSVariable);

    setCSSVariable();

}

document.addEventListener('DOMContentLoaded', function () {
    initBodyTagPadding();
});

document.addEventListener('shopify:section:load', function (e) {
    initBodyTagPadding();
});
